import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { v4 as uuid } from "uuid";

import {
  AGENT_SERVER_URL,
  APP_URL,
  AGENT_PORTAL_URL,
} from "../../../config/config";
import { withRouter } from "react-router-dom";

import {
  listAgentAllowedServices,
  getAgentInfo,
  updateAgentAllowedServices,
  listAssignedServicesAgreementsCp,
  deleteClientAssignedAgreementCp,
  getClientArchivedAgreementsCp,
  getAgentArchivedAgreementsSingle,
  reassignAgentArchivedAgreement,
  deleteAgentArchivedAgreement,
  sendEmailNew,
  revokeAgentSignedAgreements,
  approveAgentSignedAgreement,
  getAgentLogin,
  getSingleAgent,
  getPartnerSubAgentCommissionAllocation,
  savePartnerSubAgentCommissionAllocation,
  editAgent,
  resendActivationAgent,
  getSingleAgentLoginDetail,
  getAgentAssignedForms,
  viewAgentFormSubmission,
  approveAgentSubmission,
  rejectAgentSubmission,
  allAgentRejections,
  listAllFormsAgent,
  assignFormToAgents,
  getAgentArchivedForms,
  getEditAgentEmailPreview,
  getActionActions,
  saveAgentActionsRequest,
  sendPartnerSubmissionLinkByEmail,
  notifyAgentLogin,
  sendAgentLoginUrlEmail,
  sendAgentResetPasswordEmail,
  listAgents,
  sendClientInvite,
} from "./../../../config/api_calls";
import {
  ListAgentAssignRoles,
  editAgentAssignRole,
  // get_onboarding_user,
  // save_onboarding_user,
} from "../../../config/agent_role_api_calls";
import {
  getCustomSettings,
  getPartnerForgotPasswordLink,
} from "./../../../config/reseller_api_calls";
import { getAgentAgreementSigneeDetailsNew } from "../../../config/signed_agreements_api_calls";
import {
  getAgentNotificationSettings,
  submitAgentNotificationSettings,
} from "./../../../config/general_api_calls";
// import { listForms } from "./../../../config/forms_api_calls";
import { addSettings, addMsaInfo } from "../../../actions";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import HelperClass from "./../../../config/helperClass";
import makeAnimated from "react-select/animated";
import countryList from "react-select-country-list";
import { PhoneNumberUtil } from "google-libphonenumber";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";

import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import dateFormat, { masks } from "dateformat";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import MutextField from "@material-ui/core/TextField";
import { ValidateEmail } from "../../../config/utility";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import PasswordStrengthBar from "react-password-strength-bar";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";

import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import Autocomplete from "@material-ui/lab/Autocomplete";
import localization from "../../../localization/enUS";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";

const animatedComponents = makeAnimated();
const auth = new HelperClass();
class ViewAgent extends Component {
  constructor() {
    super();
    this.state = {
      serviceAssignedData: [],
      showServiceLoader: true,
      assignedLoader: true,
      checkAll: false,
      update_service_button: false,
      agent_accountno: "",
      client_update_name: "",
      client_comp_name: "",
      client_update_email: "",
      client_name_initials: "",
      client_status: "",
      assignedErrorMessage: "",
      assignedSuccessMessage: "",
      loginErrorMessage: "",
      login_url: "",
      showLoginModal: false,
      activeTab: "agreements",

      errorMessageAgreements: "",
      successMessageAgreements: "",
      errorMessageArchiveAgreements: "",
      successMessageArchiveAgreements: "",
      signedData: [],
      unsignedData: [],
      selected_agent_accountno: "",
      removeErrorTitle: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      remove_agreement_button: false,
      selected_agreement_id: "",
      errorMessageArchivedDetails: "",
      reassign_archive_id: "",
      errorMessageReassign: "",
      successMessageReassign: "",
      uploadErrorTitle: "",
      uploadErrorMessage: "",
      uploadSuccessMessage: "",
      upload_agreement_button: false,
      add_picture: "",
      add_picture_name: "",
      signee_name: "",
      signee_email: "",
      signee_title: "",
      signee_comment: "",
      charLimit: 1000,
      characterExceededMessage: "",
      errorMessageSignee: "",
      successMessageSignee: "",
      eSuccessMessage: "",
      eErrorMessage: "",
      isRevokeReasonActive: false,
      revoke_reason: "",
      isApproveActive: false,
      approve_agreement_id: "",
      approve_agreement_accountno: "",
      c_password: "",
      signee_details: [],
      agent_email: "",
      agent_phone: "",
      agent_company: "",
      // Role is a separate field from Title, shown only when enabled in settings.
      agent_role: "",
      role_field_enabled: false,
      agent_status: "",
      agent_password: "",
      agent_address: "",
      agent_address2: "",
      agent_city: "",
      agent_state: "",
      agent_zip: "",
      agent_country: "United States",
      sharelink_limit: "",
      errorMessageEdit: "",
      successMessageEdit: "",
      errorName: "",
      errorAgentStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      notifyCheckBox: false,
      notifyLoginLoading: false,
      notifyLoginSuccess: "",
      notifyLoginError: "",
      
      clientSignupLink: "",
      clientSignupAgentId: "",
      copiedClientSignup: false,
      inviteClientName: "",
      inviteClientEmail: "",
      inviteClientComment: "",
      inviteClientDisabled: false,
      inviteClientError: "",
      inviteClientSuccess: "",
      permission_view_signup_link: 0,
      // Partner Sub-Agent commission allocation modal
      is_sub_agent: false,
      agent_signup_hash: "",
      allocation_loading: false,
      allocation_saving: false,
      allocation_pct: "",
      allocation_main_rate: null,
      allocation_error: "",
      allocation_success: "",
      loginUrl: "",
      sendingLoginEmail: false,
      sendingResetPasswordEmail: false,
      loginEmailSent: false,
      resetPasswordEmailSent: false,
      loginEmailError: "",
      resetPasswordEmailError: "",
      copiedLogin: false,
      copiedResetPassword: false,
      
      activation_button: false,
      activation_tick: false,
      activation_cross: false,

      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      errorMessageSubAgentRole: "",
      successMessageSubAgentRole: "",
      subassignRoleData: [],
      subassignSubRoleData: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      checkedRoleIds: [],
      checkedSubRoleIds: [],
      checkedName: "",
      checkedEmail: "",
      statusChanged: false,
      formsErrorMessage: "",
      formsSuccessMessage: "",
      errorMessageTotals: "",
      errorMessageTotalsTitle: "",
      form_title: "",
      form_accountno: "",
      agent_submission_id: "",
      agent_submission_type: "",
      approveAgentErrorMessage: "",
      approveAgentSuccessMessage: "",
      form_token: "",
      approveAgentErrorMessage: "",
      approveAgentSuccessMessage: "",
      approve_agent_button: false,
      approvalNotes: "",
      approvalNotesError: "",
      rejectAgentErrorMessage: "",
      rejectAgentSuccessMessage: "",
      reject_agent_reason: "",
      allAgentRejectionsListing: [],
      agentsList: [],
      selectedForms: [],
      selectAllAgents: false,
      assignModalLoader: true,
      errorMessageAssignModal: "",
      successMessageAssignModal: "",
      errorMessageArchiveForms: "",
      archivedForms: [],
      formsAssignedData: [],
      isEmailChanged: false,
      proceedAfterEmailModal: false,
      showEmailWarning: false,
      original_client_update_email: "",
      modalDataLoading: false,

      agent_action_list: [], // List of actions
      selected_action_map: {}, // { 1: true, 2: false }
      disableSaveBtn: false,
      successMessageAgentAction: "",
      errorMessageAgentAction: "",
      address_autocomplete: true,
      address_validation: true,

      resetLink: "",
      copied: false,
      copiedSub: false,
      successMessageSub: "",
      showMailForm: false,
      mailName: "",
      mailEmail: "",
      mailComment: "",
      successMessageMail: "",
      errorMessageMail: "",

      notification_form_token: "",
      notification_scheduler: false,
      schedule_div: false,
      repeat_count: 7,
      repeat_interval: 24,
      initial_reminder_interval: 2,
      notification_loader: false,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      missing_form_settings: "No",
      permissionsState: [],
      permission_edit_partner: 0,
      permission_approve_agreement: 0,
      permission_reject_agreement: 0,
      permission_view_agreement: 0,
      permission_upload_agreement: 0,
      permission_remove_agreement: 0,
      permission_view_signee: 0,
      permission_update_products: 0,
      permission_assign_form: 0,
      permission_view_archived_forms: 0,
      permission_approve_form_submission: 0,
      permission_reject_form_submission: 0,
      permission_view_form_submission: 0,
      permission_edit_form_submission: 0,
      permission_view_submission_rejections: 0,
      permission_edit_submission_notifications: 0,
      permission_update_menu: 0,
      permission_update_actions: 0,
      permission_view_client_sso: 0,
      permission_forogt_password_link: 0,

      // Onboarding Settings
      // onboardingItems: [],
      // onboardingErrorMessage: "",
      // onboardingErrorMessageTitle: "",
      // onboardingSuccessMessage: "",
      // onboardingItemsWithErrors: [],
      // onboarding_save_loading: false,
      // newStepCounter: 0,
      // onboardingTitle: "",
      // onboardingMessage: "",

      // Edit Onboarding Form
      // editOnboardingId: "",
      // editOnboardingTitle: "",
      // editOnboardingForm: "",
      // editOnboardingAnswerType: "",
      // editOnboardingAllowSkip: false,
      // editOnboardingAllowEnable: false,
      // editOnboardingAllowAI: false,
      questionErrorMessage: "",
      questionErrorMessageTitle: "",
      questionSuccessMessage: "",
      add_question_loader: false,
      formsLoading: false,
      formsList: [],

      // Delete Onboarding Modal
      // onboarding_id: "",
      // onboardingErrorMessageDelete: "",
      // onboardingSuccessMessageDelete: "",
      isProcessing: false,

      // Drag functionality
      // dragOverIndex: null,
      // draggedItem: null,
    };
    this.countryOptions = countryList()
    .getData()
    .sort((a, b) => {
      if (a.label === "United States") return -1;
      if (b.label === "United States") return 1;
      return a.label.localeCompare(b.label);
    });
    this.draggedItem = undefined;
    this.draggedItemData = null;
  }

  async componentDidMount() {
    let agent_accountno = this.props.props.match.params.agent_accountno;
    // Sub-Agent hint from the navigation (?type=sub_agent, set by the Sub
    // Agents listing) — makes the page render in Sub-Agent mode from the very
    // first paint; get_agent_info's main_agent_accountno merges in as the
    // authoritative confirmation.
    let is_sub_agent_hint = false;
    try {
      const searchParams = new URLSearchParams(
        this.props.props.location && this.props.props.location.search
          ? this.props.props.location.search
          : "",
      );
      is_sub_agent_hint = searchParams.get("type") === "sub_agent";
    } catch (e) {
      is_sub_agent_hint = false;
    }
    this.setState({
      agent_accountno: agent_accountno,
      is_sub_agent: is_sub_agent_hint,
    });
    const getClientInfoResponce = await getAgentInfo(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    // console.log("getClientInfoResponce.data : ", getClientInfoResponce.data);
    if (!getClientInfoResponce?.data?.data) {
      this.setState({ tableLoader: false });
      return;
    }
    if (
      getClientInfoResponce.data.data.status === 403 ||
      getClientInfoResponce.data.data.errors === "authentication missing" ||
      getClientInfoResponce.data.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      getClientInfoResponce.data.data.status === 404 ||
      getClientInfoResponce.data.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      getClientInfoResponce.data.data.status === 200 &&
      getClientInfoResponce.data.data.message === "success"
    ) {
      const client_initials = getClientInfoResponce.data.data.name
        .split(" ")
        .map((word) => {
          const firstChar = word.charAt(0);
          return /^[a-zA-Z]+$/.test(firstChar) ? firstChar : "";
        })
        .join("");
      let kyc_percentage =
        (100 / getClientInfoResponce.data.data.steps_allowed) *
        getClientInfoResponce.data.data.steps_completed;

      const enableStatus =
        getClientInfoResponce.data.data.clientIntegrationPermission &&
        getClientInfoResponce.data.data.clientIntegrationPermission.length > 0
          ? getClientInfoResponce.data.data.clientIntegrationPermission[0]
              .enable
          : "No";
      const isEnableChecked = enableStatus === "Yes";

      const enableStatusMeta =
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta &&
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta.length >
          0
          ? getClientInfoResponce.data.data.clientIntegrationPermissionMeta[0]
              .enable
          : "No";
      const isEnableCheckedMeta = enableStatusMeta === "Yes";

      this.setState({
        client_comp_name: getClientInfoResponce.data.data.comp_name,
        client_update_name: getClientInfoResponce.data.data.name,
        client_title: getClientInfoResponce.data.data.title,
        client_update_email: getClientInfoResponce.data.data.email,
        kyc_email_address: getClientInfoResponce.data.data.email,
        client_phone: getClientInfoResponce.data.data.phone,
        client_address: getClientInfoResponce.data.data.address,
        client_address2: getClientInfoResponce.data.data.address2,
        client_country: getClientInfoResponce.data.data.country,
        client_city: getClientInfoResponce.data.data.city,
        client_state: getClientInfoResponce.data.data.state,
        client_zip: getClientInfoResponce.data.data.zip,
        client_id: getClientInfoResponce.data.data.id,
        // Partner Sub-Agent: hide Sub Users / Sub Agents tabs (a Sub-Agent
        // can never create Sub Users or Sub-Agents).
        is_sub_agent:
          Boolean(
            getClientInfoResponce.data.data.main_agent_accountno &&
              getClientInfoResponce.data.data.main_agent_accountno !== "",
          ) || this.state.is_sub_agent,
        agent_signup_hash: getClientInfoResponce.data.data.signup_hash || "",
        client_sharelink_limit: getClientInfoResponce.data.data.sharelink_limit,
        client_status: getClientInfoResponce.data.data.isVerified,
        client_name_initials: client_initials,
        totalClientAgreements: getClientInfoResponce.data.data.totalAgreements,
        signedClientAgreements:
          getClientInfoResponce.data.data.signedAgreements,
        unsignedClientAgreements:
          getClientInfoResponce.data.data.unsignedAgreements,
        totalSalesOrders: getClientInfoResponce.data.data.totalOrders,
        paidSalesOrders: getClientInfoResponce.data.data.paidOrders,
        completedSalesOrders: getClientInfoResponce.data.data.completedOrders,
        kyc_percentage: kyc_percentage.toFixed(0),
        client_isVerified: getClientInfoResponce.data.data.isVerified,
        loginDetails: getClientInfoResponce.data.data.agentLoginDetails,
        signee_name: getClientInfoResponce.data.data.name,
        signee_title: getClientInfoResponce.data.data.title,
        signee_email: getClientInfoResponce.data.data.email,
        original_client_update_email: getClientInfoResponce.data.data.email,
      });
      //console.log("this.state.kyc_percentage: ", this.state.kyc_percentage);
    } else {
      // window.location.replace("/error");
    }
    this.showAssignedServices();
    this.agentAgreements();
    this.getCustomSettings();
    this.getClientSignupLink();
    // this.getOnboardingItems();
    // this.get_forms_list();
  }

  // Fetch this agent's CLIENT registration (signup) link from list_agents:
  // rowData[9] = CHANNEL_PORTAL_PATH + client/register/<signup_hash>
  // (rowData[6] is the sub-agent link; id at [7], accountno at [8]).
  getClientSignupLink = async () => {
    try {
      const response = await listAgents(auth.getAccount(), auth.getToken());
      if (
        response.data.status === 200 &&
        response.data.message === "success" &&
        Array.isArray(response.data.data)
      ) {
        const row =
          response.data.data.find(
            (r) => String(r[8]) === String(this.state.agent_accountno),
          ) ||
          response.data.data.find(
            (r) => String(r[7]) === String(this.state.client_id),
          );
        if (row) {
          this.setState({
            clientSignupLink: row[9] || "",
            clientSignupAgentId: row[7] || "",
          });
        } else if (this.state.is_sub_agent && this.state.agent_signup_hash) {
          // Partner Sub-Agents are excluded from list_agents; build the
          // client-register link from the hash returned by get_agent_info.
          this.setState({
            clientSignupLink:
              (process.env.REACT_APP_AGENT_PORTAL_URL || "") +
              "client/register/" +
              this.state.agent_signup_hash,
            clientSignupAgentId: this.state.client_id || "",
          });
        }
      }
    } catch (e) {
      // Non-blocking: leave the section empty if the link can't be fetched.
    }
  };

  // Build the client registration link, appending the entered name/email as a
  // base64 prefill (same payload the email invite uses) when present.
  buildClientRegisterLink = () => {
    const base = this.state.clientSignupLink;
    if (!base) return "";
    const name = (this.state.inviteClientName || "").trim();
    const email = (this.state.inviteClientEmail || "").trim();
    if (!name && !email) return base;
    try {
      const b64 = btoa(
        unescape(encodeURIComponent(JSON.stringify({ email, name }))),
      );
      return base.replace(/\/+$/, "") + "/" + b64;
    } catch (e) {
      return base;
    }
  };

  copyClientSignup = () => {
    const link = this.buildClientRegisterLink();
    if (!link) return;
    navigator.clipboard.writeText(link).then(() => {
      this.setState({
        successMessage: "Link Copied Successfully!",
        copiedClientSignup: true,
      });
      setTimeout(
        () =>
          this.setState({ successMessage: "", copiedClientSignup: false }),
        2000,
      );
    });
  };

  openInviteClientModal = () => {
    this.setState({
      inviteClientName: "",
      inviteClientEmail: "",
      inviteClientComment: "",
      inviteClientError: "",
      inviteClientSuccess: "",
      inviteClientDisabled: false,
    });
    window.$("#modalInviteClientAgent").modal("show");
  };

  // Invite a client to register under THIS agent — same flow/email as the
  // Clients module "Invite New Client", with the agent fixed (select_agent =
  // this agent's accountno) so attribution stays identical.
  inviteClientFromAgent = async () => {
    const { inviteClientName, inviteClientEmail, inviteClientComment } =
      this.state;
    this.setState({ inviteClientError: "", inviteClientSuccess: "" });

    if (inviteClientName === "") {
      this.setState({ inviteClientError: "Please enter the name." });
      return;
    } else if (inviteClientEmail === "") {
      this.setState({ inviteClientError: "Please enter the email address." });
      return;
    } else if (ValidateEmail(inviteClientEmail) === false) {
      this.setState({
        inviteClientError: "Please enter the valid email address.",
      });
      return;
    } else if (inviteClientComment === "") {
      this.setState({ inviteClientError: "Please enter the comment." });
      return;
    }

    // Backend matches the agent by `agents.id` (SELECT signup_hash FROM agents
    // WHERE id = select_agent), so send the agent id — the same value the
    // Clients module dropdown uses (list_agents row[7]) — not the accountno.
    const select_agent =
      this.state.clientSignupAgentId || this.state.client_id;
    if (!select_agent) {
      this.setState({
        inviteClientError:
          "Unable to determine the agent. Please reload the page and try again.",
      });
      return;
    }

    this.setState({ inviteClientDisabled: true });
    try {
      const servicesResponce = await sendClientInvite(
        auth.getAccount(),
        auth.getToken(),
        select_agent,
        inviteClientEmail,
        inviteClientName,
        inviteClientComment,
      );

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 409) {
        this.setState({
          inviteClientError: "Client already registered with this email.",
          inviteClientDisabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          inviteClientError:
            "There is some error while sending invite to the client.",
          inviteClientDisabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          inviteClientError: "",
          inviteClientSuccess: "Invite successfully sent to the client.",
          inviteClientDisabled: false,
          inviteClientName: "",
          inviteClientEmail: "",
          inviteClientComment: "",
        });
      } else {
        this.setState({
          inviteClientError:
            "There is some error while sending invite to the client.",
          inviteClientDisabled: false,
        });
      }
    } catch (e) {
      this.setState({
        inviteClientError:
          "There is some error while sending invite to the client.",
        inviteClientDisabled: false,
      });
    }
    setTimeout(() => {
      this.setState({ inviteClientError: "", inviteClientSuccess: "" });
    }, 4000);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "partners",
        "view_partner",
      );
      // console.log("Can Edit Clients:", canEdit);

      this.setState({
        permissionsState: canEdit,
        permission_edit_partner: canEdit[0].edit_partner,
        permission_approve_agreement: canEdit[0].approve_agreement,
        permission_reject_agreement: canEdit[0].reject_agreement,
        permission_view_agreement: canEdit[0].view_agreement,
        permission_upload_agreement: canEdit[0].upload_agreement,
        permission_remove_agreement: canEdit[0].remove_agreement,
        permission_view_signee: canEdit[0].view_signee,
        permission_update_products: canEdit[0].update_products,
        permission_assign_form: canEdit[0].assign_form,
        permission_view_archived_forms: canEdit[0].view_archived_forms,
        permission_approve_form_submission: canEdit[0].approve_form_submission,
        permission_reject_form_submission: canEdit[0].reject_form_submission,
        permission_view_form_submission: canEdit[0].view_form_submission,
        permission_edit_form_submission: canEdit[0].edit_form_submission,
        permission_view_submission_rejections:
          canEdit[0].view_submission_rejections,
        permission_edit_submission_notifications:
          canEdit[0].edit_submission_notifications,
        permission_update_menu: canEdit[0].update_menu,
        permission_update_actions: canEdit[0].update_actions,
        permission_view_partner_sso: canEdit[0].view_partner_sso,
        permission_forogt_password_link: canEdit[0].forgot_password_link,
        permission_view_signup_link: canEdit[0].view_signup_link,
      });
      //console.log("Can Edit Clients:", canEdit);
    }
  }

  showAssignedServices = async () => {
    const { agent_accountno } = this.state;
    const servicesResponce = await listAgentAllowedServices(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    // console.log("showAssignedServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        showServiceLoader: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        serviceAssignedData: servicesResponce.data.data,
        showServiceLoader: false,
        assignedLoader: false,
      });
    } else {
      this.setState({
        showServiceLoader: false,
        assignedLoader: false,
      });
    }
  };

  handleCheckboxChange = (id) => {
    const serviceAssignedData = this.state.serviceAssignedData.map(
      (checkbox) =>
        checkbox.id === id
          ? { ...checkbox, checked: !checkbox.checked }
          : checkbox,
    );
    this.setState({ serviceAssignedData });
  };

  handleCheckAllChange = () => {
    const { checkAll, serviceAssignedData } = this.state;
    const updatedCheckboxes = serviceAssignedData.map((checkbox) => ({
      ...checkbox,
      checked: !checkAll,
    }));
    this.setState({
      serviceAssignedData: updatedCheckboxes,
      checkAll: !checkAll,
    });
  };

  updateAssignedServices = async () => {
    const { checkAll, serviceAssignedData, agent_accountno } = this.state;
    this.setState({
      update_service_button: true,
    });
    // console.log(
    //   "updateAssignedServices serviceAssignedData: ",
    //   serviceAssignedData
    // );
    const servicesResponce = await updateAgentAllowedServices(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
      JSON.stringify(serviceAssignedData),
    );
    // console.log("updateAssignedServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        update_service_button: false,
        assignedErrorMessage: `There is some error while assigning the services to the ${localization.specificPortals.agentText}.`,
        assignedSuccessMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        assignedErrorMessage: "",
        assignedSuccessMessage: `Services / Products assigned successfully to the ${localization.specificPortals.agentText}.`,
        update_service_button: false,
      });
      setTimeout(() => {
        this.showAssignedServices();
      }, 3000);
    } else {
      this.setState({
        update_service_button: false,
        assignedErrorMessage: `There is some error while assigning the services to the ${localization.specificPortals.agentText}.`,
        assignedSuccessMessage: "",
      });
    }
    setTimeout(() => {
      this.setState({
        update_service_button: false,
        assignedErrorMessage: "",
        assignedSuccessMessage: "",
      });
    }, 4000);
  };

  editClientModal = async () => {
    const { client_accountno } = this.state;
    const getClientInfoResponce = await getAgentInfo(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    // console.log(
    //   "getClientInfoResponce.data.data : ",
    //   getClientInfoResponce.data.data
    // );
    if (
      getClientInfoResponce.data.data.status === 403 ||
      getClientInfoResponce.data.data.errors === "authentication missing" ||
      getClientInfoResponce.data.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      getClientInfoResponce.data.data.status === 404 ||
      getClientInfoResponce.data.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      // this.setState({
      //   tableLoader: false,
      // });
    } else if (
      getClientInfoResponce.data.data.status === 200 &&
      getClientInfoResponce.data.data.message === "success"
    ) {
      window.$("#modalUpdateClient").modal("show");
      this.setState({
        update_client_account_no: client_accountno,
        client_comp_name: getClientInfoResponce.data.data.comp_name,
        client_update_name: getClientInfoResponce.data.data.name,
        client_title: getClientInfoResponce.data.data.title,
        client_update_email: getClientInfoResponce.data.data.email,
        client_phone: getClientInfoResponce.data.data.phone,
        client_address: getClientInfoResponce.data.data.address,
        client_address2: getClientInfoResponce.data.data.address2,
        client_country: getClientInfoResponce.data.data.country,
        client_city: getClientInfoResponce.data.data.city,
        client_state: getClientInfoResponce.data.data.state,
        client_zip: getClientInfoResponce.data.data.zip,
        client_account_status: getClientInfoResponce.data.data.account_status,
        client_isVerified: getClientInfoResponce.data.data.isVerified,
      });
    } else {
      // window.location.replace("/error");
    }
    // console.log('edit client account_no : ',tableMeta.rowData[0]);
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          agent_city: city && city !== "" ? city : "",
          agent_state: state && state !== "" ? state : "",
          agent_zip: zipCode && zipCode !== "" ? zipCode : "",
          agent_country: country && country !== "" ? country : "",
          agent_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          agent_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  reloadAgentInfo = async () => {
    const getClientInfoResponce = await getAgentInfo(
      auth.getAccount(),
      auth.getToken(),
      this.state.agent_accountno,
    );
    // console.log(
    //   "getClientInfoResponce.data.data : ",
    //   getClientInfoResponce.data
    // );
    if (
      getClientInfoResponce.data.data.status === 403 ||
      getClientInfoResponce.data.data.errors === "authentication missing" ||
      getClientInfoResponce.data.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      getClientInfoResponce.data.data.status === 404 ||
      getClientInfoResponce.data.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      // this.setState({
      //   tableLoader: false,
      // });
    } else if (
      getClientInfoResponce.data.data.status === 200 &&
      getClientInfoResponce.data.data.message === "success"
    ) {
      const client_initials = getClientInfoResponce.data.data.name
        .split(" ")
        .map((word) => {
          const firstChar = word.charAt(0);
          return /^[a-zA-Z]+$/.test(firstChar) ? firstChar : "";
        })
        .join("");
      let kyc_percentage =
        (100 / getClientInfoResponce.data.data.steps_allowed) *
        getClientInfoResponce.data.data.steps_completed;

      const enableStatus =
        getClientInfoResponce.data.data.clientIntegrationPermission &&
        getClientInfoResponce.data.data.clientIntegrationPermission.length > 0
          ? getClientInfoResponce.data.data.clientIntegrationPermission[0]
              .enable
          : "No";
      const isEnableChecked = enableStatus === "Yes";

      const enableStatusMeta =
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta &&
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta.length >
          0
          ? getClientInfoResponce.data.data.clientIntegrationPermissionMeta[0]
              .enable
          : "No";
      const isEnableCheckedMeta = enableStatusMeta === "Yes";

      this.setState({
        client_comp_name: getClientInfoResponce.data.data.comp_name,
        client_update_name: getClientInfoResponce.data.data.name,
        client_title: getClientInfoResponce.data.data.title,
        client_update_email: getClientInfoResponce.data.data.email,
        kyc_email_address: getClientInfoResponce.data.data.email,
        client_phone: getClientInfoResponce.data.data.phone,
        client_address: getClientInfoResponce.data.data.address,
        client_address2: getClientInfoResponce.data.data.address2,
        client_country: getClientInfoResponce.data.data.country,
        client_city: getClientInfoResponce.data.data.city,
        client_state: getClientInfoResponce.data.data.state,
        client_zip: getClientInfoResponce.data.data.zip,
        client_id: getClientInfoResponce.data.data.id,
        // Partner Sub-Agent: hide Sub Users / Sub Agents tabs (a Sub-Agent
        // can never create Sub Users or Sub-Agents).
        is_sub_agent:
          Boolean(
            getClientInfoResponce.data.data.main_agent_accountno &&
              getClientInfoResponce.data.data.main_agent_accountno !== "",
          ) || this.state.is_sub_agent,
        agent_signup_hash: getClientInfoResponce.data.data.signup_hash || "",
        client_sharelink_limit: getClientInfoResponce.data.data.sharelink_limit,
        client_status: getClientInfoResponce.data.data.isVerified,
        client_name_initials: client_initials,
        totalClientAgreements: getClientInfoResponce.data.data.totalAgreements,
        signedClientAgreements:
          getClientInfoResponce.data.data.signedAgreements,
        unsignedClientAgreements:
          getClientInfoResponce.data.data.unsignedAgreements,
        totalSalesOrders: getClientInfoResponce.data.data.totalOrders,
        paidSalesOrders: getClientInfoResponce.data.data.paidOrders,
        completedSalesOrders: getClientInfoResponce.data.data.completedOrders,
        kyc_percentage: kyc_percentage.toFixed(0),
        client_isVerified: getClientInfoResponce.data.data.isVerified,
        loginDetails: getClientInfoResponce.data.data.agentLoginDetails,
        signee_name: getClientInfoResponce.data.data.name,
        signee_title: getClientInfoResponce.data.data.title,
        signee_email: getClientInfoResponce.data.data.email,
      });
      //console.log("this.state.kyc_percentage: ", this.state.kyc_percentage);
    } else {
      // window.location.replace("/error");
    }
  };

  // Handle drag start - only from handle icon
  // handleDragStart = (e, index) => {
  //   e.dataTransfer.effectAllowed = "move";
  //   this.setState({ draggedItem: index });
  //   this.draggedItemData = this.state.onboardingItems[index];
  // };

  // Handle drag over
  // handleDragOver = (e, index) => {
  //   e.preventDefault();
  //   e.dataTransfer.dropEffect = "move";
  //   // Only allow drop on unlocked items or after them
  //   const item = this.state.onboardingItems[index];
  //   if (!item.isLocked) {
  //     this.setState({ dragOverIndex: index });
  //   }
  // };

  // Handle drag leave
  // handleDragLeave = (e) => {
  //   e.preventDefault();
  //   this.setState({ dragOverIndex: null });
  // };

  // Handle drop - swap two items
  // handleDrop = (e, dropIndex) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   const { onboardingItems, draggedItem } = this.state;
  //   const draggedIndex = draggedItem;

  //   this.setState({ dragOverIndex: null, draggedItem: null });

  //   // If dragging onto itself, do nothing
  //   if (
  //     draggedIndex === undefined ||
  //     draggedIndex === null ||
  //     draggedIndex === dropIndex
  //   ) {
  //     return;
  //   }

  //   // Prevent dropping on locked items
  //   if (onboardingItems[dropIndex] && onboardingItems[dropIndex].isLocked) {
  //     return;
  //   }

  //   // Swap items at draggedIndex and dropIndex
  //   const swappedItems = this.swapItems(
  //     onboardingItems,
  //     draggedIndex,
  //     dropIndex,
  //   );
  //   this.setState({ onboardingItems: swappedItems });
  // };

  // Swap two items in array - clean implementation
  // swapItems = (array, index1, index2) => {
  //   const newArray = [...array];
  //   [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];
  //   return newArray;
  // };

  // Handle drag end
  // handleDragEnd = () => {
  //   this.setState({ dragOverIndex: null, draggedItem: null });
  // };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      assignedLoader: true,
    });

    // Fetch onboarding items when onboarding tab is accessed
    // if (tab === "onboarding_settings") {
    //   this.getOnboardingItems();
    // }
  };

  // Onboarding Methods
  // getOnboardingItems = async () => {
  //   try {
  //     const accountno = auth.getAccount();
  //     const token = auth.getToken();
  //     const { agent_accountno } = this.state;

  //     const response = await get_onboarding_user(
  //       accountno,
  //       token,
  //       agent_accountno,
  //       "partner",
  //     );

  //     if (response && response.status === 200) {
  //       const responseData = response.data;
  //       // console.log("Response Data Object:", responseData);

  //       let formattedItems = [];

  //       // Check if response status is success
  //       if (responseData.status === "success") {
  //         // The API returns: { status: "success", data: { steps: { steps: [...], total_steps, progress }, ... } }
  //         let stepsData = null;

  //         // Handle case where data is an object (single item)
  //         if (
  //           responseData.data &&
  //           typeof responseData.data === "object" &&
  //           !Array.isArray(responseData.data)
  //         ) {
  //           // Check for steps.steps structure
  //           if (responseData.data.steps && responseData.data.steps.steps) {
  //             stepsData = responseData.data.steps.steps;
  //           }
  //           // Check for onboarding_template.steps structure
  //           else if (
  //             responseData.data.onboarding_template &&
  //             responseData.data.onboarding_template.steps
  //           ) {
  //             stepsData = responseData.data.onboarding_template.steps;
  //           }
  //           // Fallback to direct steps property
  //           else if (
  //             responseData.data.steps &&
  //             Array.isArray(responseData.data.steps)
  //           ) {
  //             stepsData = responseData.data.steps;
  //           }
  //         }
  //         // Handle case where data is an array with items
  //         else if (
  //           responseData.data &&
  //           Array.isArray(responseData.data) &&
  //           responseData.data.length > 0
  //         ) {
  //           // Look for onboarding_template property first (new structure)
  //           const templateContainer = responseData.data[0]?.onboarding_template;

  //           if (templateContainer && templateContainer.steps) {
  //             stepsData = templateContainer.steps;
  //           } else {
  //             // Fallback to old structure for backward compatibility
  //             const stepsContainer = responseData.data[0]?.steps;
  //             if (
  //               stepsContainer &&
  //               stepsContainer.steps &&
  //               stepsContainer.steps.steps
  //             ) {
  //               stepsData = stepsContainer.steps.steps;
  //             } else if (stepsContainer && stepsContainer.steps) {
  //               stepsData = stepsContainer.steps;
  //             } else {
  //               stepsData = stepsContainer;
  //             }
  //           }
  //         }

  //         // console.log("Steps Data:", stepsData);

  //         // Handle array format (new - preserves exact order)
  //         if (stepsData && Array.isArray(stepsData)) {
  //           formattedItems = stepsData.map((stepData, index) => ({
  //             id: stepData.id || `step_${index + 1}`,
  //             title: stepData.title || "",
  //             form: stepData.form || "",
  //             allowSkip:
  //               stepData.allowSkip === 1 || stepData.allowSkip === true
  //                 ? true
  //                 : false,
  //             enable:
  //               stepData.enable === 1 ||
  //               stepData.enable === true ||
  //               stepData.isEnabled === 1 ||
  //               stepData.isEnabled === true
  //                 ? true
  //                 : false,
  //             type: stepData.type || "",
  //             isFilled:
  //               stepData.isFilled === 1 || stepData.isFilled === true
  //                 ? true
  //                 : false,
  //             isSkipped:
  //               stepData.isSkipped === 1 || stepData.isSkipped === true ? 1 : 0,
  //             isLocked: index < 2, // First two items are locked
  //           }));
  //         }
  //         // Handle object format with step titles as keys (legacy)
  //         else if (
  //           stepsData &&
  //           typeof stepsData === "object" &&
  //           !Array.isArray(stepsData)
  //         ) {
  //           formattedItems = Object.entries(stepsData).map(
  //             ([title, stepData], index) => ({
  //               id: stepData.id || `step_${index + 1}`,
  //               title: title.trim(),
  //               form: stepData.form || "",
  //               allowSkip:
  //                 stepData.allowSkip === 1 || stepData.allowSkip === true
  //                   ? true
  //                   : false,
  //               enable:
  //                 stepData.enable === 1 ||
  //                 stepData.enable === true ||
  //                 stepData.isEnabled === 1 ||
  //                 stepData.isEnabled === true
  //                   ? true
  //                   : false,
  //               type: stepData.type || "",
  //               isFilled:
  //                 stepData.isFilled === 1 || stepData.isFilled === true
  //                   ? true
  //                   : false,
  //               isSkipped:
  //                 stepData.isSkipped === 1 || stepData.isSkipped === true
  //                   ? 1
  //                   : 0,
  //               isLocked: index < 2, // First two items are locked
  //             }),
  //           );
  //         }
  //       }

  //       // console.log("Formatted Items:", formattedItems);

  //       if (formattedItems.length > 0) {
  //         this.setState({
  //           onboardingItems: formattedItems,
  //           newStepCounter: formattedItems.length,
  //           onboardingTitle: responseData.data.onboardingTitle || "",
  //           onboardingMessage: responseData.data.message || "",
  //         });
  //         // console.log("State Updated with items:", formattedItems);
  //       } else {
  //         console.warn("No items found in response");
  //         this.setState({
  //           onboardingItems: [],
  //           newStepCounter: 0,
  //         });
  //       }
  //     } else {
  //       console.warn(
  //         "Failed to fetch onboarding items - Invalid status:",
  //         response?.status,
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching onboarding items:", error);
  //     console.error("Error Stack:", error.stack);
  //   }
  // };

  // updateOnboardingItemTitle = (id, newTitle) => {
  //   const updatedItems = this.state.onboardingItems.map((item) =>
  //     item.id === id ? { ...item, title: newTitle } : item,
  //   );

  //   // Remove error if title is not empty
  //   let updatedErrors = [...this.state.onboardingItemsWithErrors];
  //   if (newTitle.trim() !== "") {
  //     updatedErrors = updatedErrors.filter((errorId) => errorId !== id);
  //   }

  //   this.setState({
  //     onboardingItems: updatedItems,
  //     onboardingItemsWithErrors: updatedErrors,
  //   });
  // };

  // Helper method to check if agreement step should be filled (green border)
  isAgreementStepFilled = () => {
    const { unsignedData } = this.state;

    // If no unsigned agreements, it's filled
    if (!unsignedData || unsignedData.length === 0) {
      return true;
    }

    // Check if all unsigned agreements have ismandatory: "No"
    return unsignedData.every((agreement) => agreement.ismandatory === "No");
  };

  // Get available forms excluding forms already selected in other steps
  // getAvailableFormsForStep = (currentStepId) => {
  //   const { onboardingItems, formsList } = this.state;

  //   // Get all form IDs already selected in other steps (excluding the current step)
  //   const selectedFormIds = onboardingItems
  //     .filter(
  //       (item) =>
  //         item.id !== currentStepId && item.form && item.form.trim() !== "",
  //     )
  //     .map((item) => item.form);

  //   // Filter formsList to exclude already selected forms
  //   const availableForms = formsList.filter(
  //     (form) => !selectedFormIds.includes(form.form_accountno),
  //   );

  //   return availableForms;
  // };

  // editOnboarding = async (onboardingId) => {
  //   const { onboardingItems } = this.state;
  //   const itemToEdit = onboardingItems.find((item) => item.id === onboardingId);

  //   if (itemToEdit) {
  //     // Prevent editing of items that are already filled
  //     if (itemToEdit.isFilled) {
  //       console.warn("Cannot edit filled onboarding item");
  //       return;
  //     }

  //     this.setState({
  //       editOnboardingId: onboardingId,
  //       editOnboardingTitle: itemToEdit.title,
  //       editOnboardingForm: itemToEdit.form || "",
  //       editOnboardingAnswerType: itemToEdit.answerType || "",
  //       editOnboardingAllowSkip: itemToEdit.allowSkip || false,
  //       editOnboardingAllowEnable: itemToEdit.enable || false,
  //       editOnboardingIsEnabled:
  //         itemToEdit.isEnabled !== undefined && itemToEdit.isEnabled !== null
  //           ? itemToEdit.isEnabled
  //           : 1,
  //       editOnboardingAllowMultiple:
  //         itemToEdit.allow_multiple !== undefined
  //           ? itemToEdit.allow_multiple
  //           : 0,
  //       editOnboardingAllowAI: itemToEdit.allowAI || false,
  //       questionErrorMessage: "",
  //       questionErrorMessageTitle: "",
  //       questionSuccessMessage: "",
  //       add_question_loader: false,
  //     });
  //     // Fetch forms data before opening modal if not already loaded
  //     if (!this.state.formsList || this.state.formsList.length === 0) {
  //       await this.get_forms_list();
  //     }
  //     window.$("#modalEditOnboarding").modal("show");
  //   }
  // };

  // deleteOnboarding = (onboarding_id) => {
  //   this.setState({
  //     onboarding_id: onboarding_id,
  //     onboardingErrorMessageDelete: "",
  //     onboardingSuccessMessageDelete: "",
  //   });
  //   window.$("#modalDeleteAlert").modal("show");
  // };

  // deleteOnboardingItem = async () => {
  //   this.setState({ isProcessing: true });
  //   const { onboarding_id, onboardingItems } = this.state;

  //   try {
  //     // Add your API call here if needed
  //     // Example: await deleteOnboardingItemAPI(...)

  //     // For now, perform local deletion
  //     const updatedItems = onboardingItems.filter(
  //       (item) => item.id !== onboarding_id,
  //     );
  //     const updatedErrors = this.state.onboardingItemsWithErrors.filter(
  //       (errorId) => errorId !== onboarding_id,
  //     );

  //     this.setState({
  //       onboardingItems: updatedItems,
  //       onboardingItemsWithErrors: updatedErrors,
  //       onboardingSuccessMessageDelete: "Onboarding item deleted successfully.",
  //       onboardingErrorMessageDelete: "",
  //     });

  //     setTimeout(() => {
  //       window.$("#modalDeleteAlert").modal("hide");
  //       this.setState({
  //         onboardingSuccessMessageDelete: "",
  //         onboarding_id: "",
  //         isProcessing: false,
  //       });
  //     }, 2000);
  //   } catch (error) {
  //     this.setState({
  //       onboardingErrorMessageDelete:
  //         error.message || "Failed to delete onboarding item.",
  //       onboardingSuccessMessageDelete: "",
  //       isProcessing: false,
  //     });
  //   }
  // };

  // modalHideDel = () => {
  //   this.setState({
  //     onboarding_id: "",
  //     onboardingErrorMessageDelete: "",
  //     onboardingSuccessMessageDelete: "",
  //     isProcessing: false,
  //   });
  //   window.$("#modalDeleteAlert").modal("hide");
  // };

  // addNewOnboardingStep = () => {
  //   const { newStepCounter } = this.state;
  //   const newId = uuid();

  //   // Set state for new onboarding item with empty values
  //   this.setState(
  //     {
  //       editOnboardingId: newId,
  //       editOnboardingTitle: "",
  //       editOnboardingForm: "",
  //       editOnboardingAnswerType: "",
  //       editOnboardingAllowSkip: false,
  //       editOnboardingAllowEnable: false,
  //       editOnboardingIsEnabled: 1,
  //       editOnboardingAllowMultiple: 0,
  //       editOnboardingAllowAI: false,
  //       questionErrorMessage: "",
  //       questionErrorMessageTitle: "",
  //       questionSuccessMessage: "",
  //       add_question_loader: false,
  //       newStepCounter: newStepCounter + 1,
  //     },
  //     () => {
  //       // Ensure forms are loaded
  //       if (!this.state.formsList || this.state.formsList.length === 0) {
  //         this.get_forms_list();
  //       }
  //       // Open modal after state is updated
  //       window.$("#modalAddOnboarding").modal("show");
  //     },
  //   );
  // };

  // // Fetch Forms from API
  // get_forms_list = async () => {
  //   this.setState({ formsLoading: true });
  //   try {
  //     const response = await listForms(auth.getAccount(), auth.getToken());
  //     if (response && response.data && response.data.status === 200) {
  //       const formsArray = response.data.data || [];
  //       this.setState({
  //         formsList: formsArray,
  //         formsLoading: false,
  //       });
  //     } else {
  //       this.setState({
  //         formsList: [],
  //         formsLoading: false,
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching forms:", error);
  //     this.setState({
  //       formsList: [],
  //       formsLoading: false,
  //     });
  //   }
  // };

  // closeModal = (modalId) => {
  //   this.setState({
  //     editQuestionErrorMessage: "",
  //     editQuestionSuccessMessage: "",
  //     editOnboardingId: "",
  //     editOnboardingTitle: "",
  //     editOnboardingForm: "",
  //     editOnboardingAnswerType: "",
  //     editOnboardingAllowSkip: false,
  //     editOnboardingAllowEnable: false,
  //     editOnboardingAllowAI: false,
  //     editOnboardingLoader: false,
  //     newQuestion: [],
  //     questionErrorMessage: "",
  //     questionErrorMessageTitle: "",
  //     questionSuccessMessage: "",
  //     add_question_loader: false,
  //   });
  //   window.$("#" + modalId).modal("hide");
  // };

  // submitEditOnboarding = () => {
  //   const {
  //     editOnboardingId,
  //     editOnboardingTitle,
  //     editOnboardingForm,
  //     editOnboardingAnswerType,
  //     editOnboardingAllowSkip,
  //     editOnboardingAllowEnable,
  //     editOnboardingIsEnabled,
  //     editOnboardingAllowMultiple,
  //     onboardingItems,
  //     newStepCounter,
  //   } = this.state;

  //   if (!editOnboardingForm || editOnboardingForm === "") {
  //     this.setState({
  //       questionErrorMessage: "Please select a form from the dropdown.",
  //       questionErrorMessageTitle: "Form Required",
  //       questionSuccessMessage: "",
  //       add_question_loader: false,
  //     });
  //     return;
  //   }

  //   // Validate title (required)
  //   if (!editOnboardingTitle || editOnboardingTitle.trim() === "") {
  //     this.setState({
  //       questionErrorMessage: "Please enter an onboarding item title.",
  //       questionErrorMessageTitle: "Title Required",
  //       questionSuccessMessage: "",
  //       add_question_loader: false,
  //     });
  //     return;
  //   }

  //   this.setState({ add_question_loader: true });

  //   // Check if item already exists (edit mode) or is new item (add mode)
  //   const itemExists = onboardingItems.some(
  //     (item) => item.id === editOnboardingId,
  //   );

  //   let updatedItems;
  //   let successMessage;
  //   let updatedCounter = newStepCounter;

  //   if (itemExists) {
  //     // Update existing item
  //     updatedItems = onboardingItems.map((item) =>
  //       item.id === editOnboardingId
  //         ? {
  //             ...item,
  //             title: editOnboardingTitle,
  //             form: editOnboardingForm,
  //             answerType: editOnboardingAnswerType,
  //             allowSkip: editOnboardingAllowSkip,
  //             enable: editOnboardingAllowEnable,
  //             isEnabled: editOnboardingIsEnabled,
  //             allow_multiple: editOnboardingAllowMultiple,
  //           }
  //         : item,
  //     );
  //     successMessage = "Onboarding item updated successfully.";
  //   } else {
  //     // Add new item
  //     const newItem = {
  //       id: editOnboardingId,
  //       title: editOnboardingTitle,
  //       form: editOnboardingForm,
  //       answerType: editOnboardingAnswerType,
  //       allowSkip: editOnboardingAllowSkip,
  //       enable: editOnboardingAllowEnable,
  //       isEnabled: editOnboardingIsEnabled,
  //       allow_multiple: editOnboardingAllowMultiple,
  //       isLocked: false,
  //     };
  //     updatedItems = [...onboardingItems, newItem];
  //     updatedCounter = newStepCounter + 1;
  //     successMessage = "Onboarding item added successfully.";
  //   }

  //   this.setState({
  //     onboardingItems: updatedItems,
  //     newStepCounter: updatedCounter,
  //     questionErrorMessage: "",
  //     questionErrorMessageTitle: "",
  //     questionSuccessMessage: successMessage,
  //   });

  //   setTimeout(() => {
  //     this.setState({
  //       questionErrorMessage: "",
  //       questionErrorMessageTitle: "",
  //       questionSuccessMessage: "",
  //       editOnboardingId: "",
  //       editOnboardingTitle: "",
  //       editOnboardingForm: "",
  //       editOnboardingAnswerType: "",
  //       editOnboardingAllowSkip: false,
  //       editOnboardingAllowEnable: false,
  //       editOnboardingIsEnabled: 1,
  //       editOnboardingAllowMultiple: 0,
  //       editOnboardingDescription: "",
  //       add_question_loader: false,
  //     });
  //     window.$("#modalEditOnboarding").modal("hide");
  //     window.$("#modalAddOnboarding").modal("hide");
  //   }, 2000);
  // };

  // saveOnboardingSettings = async () => {
  //   // Validate items
  //   const emptyItems = this.state.onboardingItems.filter(
  //     (item) => item.title.trim() === "",
  //   );

  //   if (emptyItems.length > 0) {
  //     const emptyItemIds = emptyItems.map((item) => item.id);
  //     this.setState({
  //       onboardingItemsWithErrors: emptyItemIds,
  //       onboardingErrorMessage:
  //         "Please fill in all onboarding step titles before saving.",
  //       onboardingErrorMessageTitle: "Validation Error",
  //       onboardingSuccessMessage: "",
  //     });
  //     return;
  //   }

  //   // Validation 2: Check for duplicate step names
  //   const { onboardingItems } = this.state;
  //   const stepNames = onboardingItems.map((item) =>
  //     item.title.trim().toLowerCase(),
  //   );
  //   const uniqueStepNames = new Set(stepNames);

  //   if (stepNames.length !== uniqueStepNames.size) {
  //     // Find all items that have duplicate names
  //     const itemsWithDuplicateNames = onboardingItems.filter((item) => {
  //       const count = stepNames.filter(
  //         (name) => name === item.title.trim().toLowerCase(),
  //       ).length;
  //       return count > 1;
  //     });

  //     this.setState({
  //       onboardingItemsWithErrors: itemsWithDuplicateNames.map(
  //         (item) => item.id,
  //       ),
  //       onboardingErrorMessage:
  //         "Duplicate step names found. Each step must have a unique name. Please rename the duplicate steps.",
  //       onboardingErrorMessageTitle: "Duplicate Steps",
  //       onboardingSuccessMessage: "",
  //     });
  //     return;
  //   }

  //   this.setState({
  //     onboarding_save_loading: true,
  //     onboardingErrorMessage: "",
  //     onboardingErrorMessageTitle: "",
  //     onboardingSuccessMessage: "",
  //   });

  //   try {
  //     const accountno = auth.getAccount();
  //     const token = auth.getToken();
  //     const {
  //       agent_accountno,
  //       onboardingItems,
  //       onboardingTitle,
  //       onboardingMessage,
  //     } = this.state;

  //     // Format steps data for API with proper type assignment
  //     const stepsData = onboardingItems.map((item, index) => {
  //       let stepType = "form";
  //       let isEnabled =
  //         item.isEnabled !== undefined && item.isEnabled !== null
  //           ? item.isEnabled
  //           : item.enable
  //             ? 1
  //             : 0;
  //       let stepIsFilled = item.isFilled ? 1 : 0;

  //       // First step is type "basic"
  //       if (index === 0) {
  //         stepType = "basic";
  //         isEnabled = 1;
  //         stepIsFilled = 1;
  //       }
  //       // Second step is type "agreement"
  //       else if (index === 1) {
  //         stepType = "agreement";
  //         isEnabled = 1;
  //         stepIsFilled = 1;
  //       }

  //       const stepObj = {
  //         id: item.id || uuid(),

  //         title: item.title,
  //         form: item.form || "",
  //         allowSkip: item.allowSkip ? 1 : 0,
  //         isEnabled: isEnabled,
  //         isFilled: stepIsFilled,
  //         allow_multiple:
  //           item.allow_multiple !== undefined ? item.allow_multiple : 0,
  //         form_desc: "",
  //         formFilledDate: "",
  //         type: stepType,
  //         isSkipped: item.isSkipped || 0,
  //         ...(index === 1 && { agreementDetails: "" }),
  //         ...(index > 1 && { formToken: "" }),
  //       };
  //       return stepObj;
  //     });

  //     // Call the save API
  //     const response = await save_onboarding_user(
  //       accountno,
  //       token,
  //       agent_accountno,
  //       stepsData,
  //       "partner",
  //       onboardingTitle,
  //       onboardingMessage,
  //     );

  //     // console.log("Save Onboarding Items Response:", response);

  //     if (
  //       response &&
  //       response.status === 200 &&
  //       response.data &&
  //       response.data.status === "success"
  //     ) {
  //       this.setState({
  //         onboarding_save_loading: false,
  //         onboardingSuccessMessage: "Onboarding settings saved successfully.",
  //         onboardingItemsWithErrors: [],
  //       });

  //       // Reload page after showing success message
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1500);
  //     } else {
  //       this.setState({
  //         onboarding_save_loading: false,
  //         onboardingErrorMessage:
  //           response?.data?.message || "Failed to save onboarding settings.",
  //         onboardingErrorMessageTitle: "Error",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error saving onboarding settings:", error);
  //     this.setState({
  //       onboarding_save_loading: false,
  //       onboardingErrorMessage:
  //         error.message || "Failed to save onboarding settings.",
  //       onboardingErrorMessageTitle: "Error",
  //     });
  //   }
  // };

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  agentAgreements = async (event) => {
    let company_id = this.state.agent_accountno;
    this.setState({
      isRevokeReasonActive: false,
      revoke_reason: "",
      errorMessage: "",
      successMessage: "",
      agent_accountno: company_id,
    });
    let clientAgreementsInfo = [];
    const servicesResponce = await listAssignedServicesAgreementsCp(
      auth.getAccount(),
      auth.getToken(),
      company_id,
    );

    // console.log("agentAgreements: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (
        servicesResponce.data.clientAgreementsInfo &&
        servicesResponce.data.clientAgreementsInfo.length > 0
      ) {
        clientAgreementsInfo = servicesResponce.data.clientAgreementsInfo;
      }
      const combinedAgreements = [
        ...clientAgreementsInfo,
        ...servicesResponce.data.unSignedAgreements,
      ];
      this.setState({
        signedData: combinedAgreements,
        unsignedData: servicesResponce.data.unSignedAgreements,
        errorMessage: "",
        successMessage: "",
        assignedLoader: false,
      });
    } else {
      this.setState({
        signedData: [],
        unsignedData: [],
        errorMessage: "",
        successMessage: "",
        assignedLoader: false,
      });
    }
  };

  downloadPdf = async (d_f_name, title) => {
    if (d_f_name) {
      var url =
        process.env.REACT_APP_AGENT_PORTAL_URL +
        "files_data/agreements/" +
        d_f_name;
      //console.log("File URL: ", url);
      // Sanitize company name: remove special characters and replace spaces with underscores
      const sanitizeFileName = (name) => {
        return name
          .replace(/[^a-zA-Z0-9\s_-]/g, '') // Remove special characters
          .replace(/\s+/g, '_') // Replace spaces with underscores
          .trim();
      };
      let pdf_name = `${title}_${this.state.agent_accountno}_${sanitizeFileName(this.state.client_comp_name)}.pdf`;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = pdf_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage: "There is some error while downloading the PDF.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    }
  };

  removeContract = (agreement_accountno) => {
    const { agent_accountno } = this.state;
    let selected_agent_accountno = agent_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_agent_accountno: selected_agent_accountno,
      selected_agreement_id: selected_agreement_id,
      removeErrorTitle: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      remove_agreement_button: false,
    });
    window.$("#modalRemoveContract").modal("show");
  };

  modalHideRemove = () => {
    window.$("#modalRemoveContract").modal("hide");
  };

  remove_agreement = async () => {
    const { selected_agreement_id, selected_agent_accountno } = this.state;
    this.setState({
      removeSuccessMessage: "",
      removeErrorMessage: "",
      disabled: true,
      remove_agreement_button: true,
    });
    const agreementResponce = await deleteClientAssignedAgreementCp(
      auth.getAccount(),
      auth.getToken(),
      selected_agent_accountno,
      selected_agreement_id,
    );

    // console.log("deleteAgreement: ", agreementResponce.data);
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      this.setState({
        removeErrorMessage: "There is some error while removing the agreement.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        removeErrorMessage: "",
        removeSuccessMessage: "Agreement removed successfully.",
      });

      setTimeout(() => {
        window.$("#modalRemoveContract").modal("hide");
        this.agentAgreements();
        this.reloadAgentInfo();
      }, 3000);
    } else {
      this.setState({
        removeErrorMessage: "There is some error while processing the request.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
    }
  };

  openSigneeDetails = async (agreement_accountno) => {
    const { agent_accountno } = this.state;
    let selected_agent_accountno = agent_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_agent_accountno: selected_agent_accountno,
      selected_agreement_id: selected_agreement_id,
      signee_details: [],
    });
    const servicesResponce = await getAgentAgreementSigneeDetailsNew(
      auth.getAccount(),
      auth.getToken(),
      selected_agent_accountno,
      selected_agreement_id,
    );
    // console.log("openSigneeDetails.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        approveErrorMessage:
          "There is an error while displaying the signee details. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "signee_not_found"
    ) {
      this.setState({
        approveErrorMessage: "Signee details not found.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "agent_not_found"
    ) {
      this.setState({
        approveErrorMessage: `${localization.specificPortals.agentLabel} not found.`,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signee_details: servicesResponce.data.data,
      });
    } else {
      this.setState({
        approveErrorMessage:
          "There is an error while displaying the signee details. Please try again.",
        disabled: false,
      });
    }
    //
    window.$("#modalOpenSignee").modal("show");
  };

  archived_agreements = async (agent_accountno) => {
    // console.log("archived_agreements agent_accountno: ", agent_accountno);

    const kycResponce = await getClientArchivedAgreementsCp(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    // console.log("archived_agreements: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the credit applications. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedAgreements: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnServices: [
          { name: "agreement_title", label: "Agreement Name" },
          {
            name: "archived_date",
            label: "Archived date",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "signed_date",
            label: "Signed Date",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "approved",
            label: "Approved",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_approved(value)}</div>;
              },
            },
          },
          {
            name: "pdf_path",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_download(value, tableMeta)}</div>;
              },
            },
          },

          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.get_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                <li>
                                  <Tooltip
                                    title="Reassign Agreement"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.reassing_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-repeat"></em>
                                      <span>Reassign</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                <li>
                                  <Tooltip
                                    title="Delete Agreement"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  format_approved = (value) => {
    if (value === "Yes") {
      return (
        <Tooltip title="This agreement is approved." placement="top">
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_download = (value, tableMeta) => {
    if (value !== "") {
      return (
        <a
          onClick={() => this.downloadPdf(value, tableMeta.rowData[0])}
          title="Download Agreement"
          style={{
            cursor: "pointer",
          }}
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-download"></em>
          </span>
        </a>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> --
        </span>
      );
    }
  };

  get_archived_details = async (value, tableMeta) => {
    const { agent_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    // console.log("get_archived_details archive_id: ", archive_id);

    const kycResponce = await getAgentArchivedAgreementsSingle(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
      archive_id,
    );
    // console.log("get_archived_details: ", kycResponce.data);
    window.$("#modalArchivedDetails").modal("show");
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchivedDetails:
          "There is an error while getting the credit applications. Please try again later.",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchivedDetails: "",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedAgreementsDetails: kycResponce.data.data,
      });
    } else {
      this.setState({
        errorMessageArchivedDetails: "",
      });
    }
  };

  reassing_archived_details = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    this.setState({
      reassign_archive_id: archive_id,
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: false,
    });
    window.$("#modalReassignAlert").modal("show");
  };

  modalHideReassign = () => {
    window.$("#modalReassignAlert").modal("hide");
  };

  reassign_archived_agreement = async () => {
    const { reassign_archive_id, agent_accountno } = this.state;
    this.setState({
      successMessageReassign: "",
      errorMessageReassign: "",
      disabled: true,
    });
    const agreementResponce = await reassignAgentArchivedAgreement(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
      reassign_archive_id,
    );

    // console.log("reassignAgreement: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageReassign:
          "There is some error while processing the request.",
        successMessageReassign: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "Agreement successfully reassigned."
    ) {
      //await this.reLoadClients();
      this.setState({
        errorMessageReassign: "",
        successMessageReassign: "Agreement successfully reassigned.",
        disabled: false,
      });

      setTimeout(() => {
        window.$("#modalReassignAlert").modal("hide");
        this.archived_agreements(agent_accountno);
        this.reloadAgentInfo();
      }, 3000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        errorMessageReassign:
          "There is some error while processing the request.",
        successMessageReassign: "",
        disabled: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  delete_archived_details = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    this.setState({
      delete_archive_id: archive_id,
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: false,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  delete_archived_agreement = async () => {
    const { delete_archive_id, agent_accountno } = this.state;
    this.setState({
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: true,
    });
    const agreementResponce = await deleteAgentArchivedAgreement(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
      delete_archive_id,
    );

    // console.log("deleteAgreement: ", agreementResponce.data);
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      this.setState({
        errorMessageDelete: "There is some error while processing the request.",
        successMessageDelete: "",
        disabled: false,
      });
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        errorMessageDelete: "",
        successMessageDelete: "Archived agreement deleted successfully.",
      });

      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.archived_agreements(agent_accountno);
      }, 3000);
    } else {
      this.setState({
        errorMessageDelete: "There is some error while processing the request.",
        successMessageDelete: "",
        disabled: false,
      });
    }
  };

  openUploadContract = async (agreement_accountno) => {
    const { agent_accountno } = this.state;
    let selected_agent_accountno = agent_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_agent_accountno: selected_agent_accountno,
      selected_agreement_id: selected_agreement_id,
      uploadErrorTitle: "",
      uploadErrorMessage: "",
      uploadSuccessMessage: "",
      upload_agreement_button: false,
      add_picture: "",
      add_picture_name: "",
    });
    window.$("#modalOpenUploadContract").modal("show");
  };

  submitClientContract = async () => {
    let {
      selected_agent_accountno,
      selected_agreement_id,
      add_picture,
      add_picture_name,
    } = this.state;
    this.setState({
      upload_agreement_button: true,
    });
    if (add_picture_name === "") {
      this.setState({
        uploadErrorMessage: "Agreement file is required.",
        uploadErrorTitle: "Missing Fields",
        upload_agreement_button: false,
      });
      setTimeout(() => {
        this.setState({
          uploadErrorTitle: "",
          uploadErrorMessage: "",
        });
      }, 4000);
      return false;
    } else {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("file", add_picture);
      formData.append("fileName", add_picture_name);
      formData.append("agent_accountno", Number(selected_agent_accountno));
      formData.append("agreement_id", Number(selected_agreement_id));

      try {
        axios
          .post(
            AGENT_SERVER_URL +
              "signed_agreements_external_api_calls/upload_agent_agreement_new",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            // console.log("submitSignatory response.data : ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                uploadErrorMessage: "Record not found.",
                uploadErrorTitle: "System Error",
                upload_agreement_button: false,
                uploadSuccessMessage: "",
              });
            } else if (response.data.status === 403) {
              this.setState({
                uploadErrorTitle: "System Error",
                uploadErrorMessage: response.data.message,
                upload_agreement_button: false,
                uploadSuccessMessage: "",
              });
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                uploadSuccessMessage: "Agreement added successfully.",
                uploadErrorMessage: "",
                uploadErrorTitle: "",
                upload_agreement_button: true,
              });
              //this.reloadClients();
              setTimeout(() => {
                this.agentAgreements();
                this.reloadAgentInfo();
                window.$("#modalOpenUploadContract").modal("hide");
              }, 4000);
            } else {
              this.setState({
                uploadErrorTitle: "System Error",
                uploadErrorMessage:
                  "There is some error while adding the agreement.",
                uploadSuccessMessage: "",
                upload_agreement_button: false,
              });
            }
          });
      } catch (error) {
        this.setState({
          uploadErrorTitle: "System Error",
          uploadErrorMessage: "There is some error while adding the agreement.",
          disabled: false,
          uploadSuccessMessage: "",
          upload_agreement_button: false,
        });

        // console.log("catch : ", error);
      }
      setTimeout(() => {
        this.setState({
          uploadErrorMessage: "",
          uploadErrorTitle: "",
        });
      }, 4000);
    }
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation selectedFiles PDF, DOC, DOCX, ZIP, TXT, PNG, JPEG, JPG
    const allowedFileTypes = [
      ".png",
      ".jpg",
      ".jpeg",
      ".doc",
      ".docx",
      ".pdf",
      ".zip",
      ".txt",
      ".rtf",
    ];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        uploadErrorMessage:
          "Invalid file type. Please select a valid file format.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      e.target.value = null;
      return;
    }

    // File size validation (e.g., limit to 10MB)
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        uploadErrorMessage:
          "File size exceeds the limit (10MB). Please choose a smaller file.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      e.target.value = null;
      return;
    }

    // Clear any previous errors
    this.setState({
      add_picture: selectedFile,
      uploadErrorMessage: "",
      uploadErrorTitle: "",
      add_picture_name: selectedFile.name,
    });
    e.target.value = null;
    //return true;
  };

  open_signee = async (agreement_accountno) => {
    let selected_agreement_id = agreement_accountno;
    this.setState({
      errorMessageSignee: "",
      successMessageSignee: "",
      characterExceededMessage: "",
      signee_comment: "",
      selected_agreement_id: selected_agreement_id,
    });
    window.$("#modalSendSignee").modal("show");
  };

  close_signee = async () => {
    window.$("#modalSendSignee").modal("hide");
  };

  handleChangeTextArea = (event) => {
    let { value } = event.target;
    const { charLimit } = this.state;

    // Update state only if the character limit is not exceeded

    if (value.length <= charLimit) {
      this.setState({ signee_comment: value, characterExceededMessage: "" });
    } else {
      //value = value.slice(0, charLimit);
      this.setState({
        characterExceededMessage: `Character limit exceeded. Maximum 500 characters are allowed. you have entered ${value.length} characters.`,
      });
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.value : target.value;
    const { name } = target;

    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "agent_company") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }

    if (name === "agent_email" && !this.state.modalDataLoading) {
      const { original_client_update_email } = this.state;

      const isChanged =
        (value || "").trim() !== (original_client_update_email || "").trim();

      this.setState({ isEmailChanged: isChanged }, () => {
        // console.log("Original Email:", original_client_update_email);
        // console.log("New Email:", value);
        // console.log("isEmailChanged:", this.state.isEmailChanged);
      });
    }
    this.setState({
      [name]: value,
    });
    //console.log("handleChange: ", name + " " + value);
  };

  handleEmailWarningYes = () => {
    this.setState(
      {
        proceedAfterEmailModal: true,
      },
      () => {
        this.formUpdateSubmit();
      },
    );
  };

  handleEmailWarningNo = () => {
    this.setState({ showEmailWarning: false });
  };

  send_email = async () => {
    let { signee_name, signee_email, signee_title, signee_comment } =
      this.state;
    this.setState({
      successMessageSignee: "",
      errorMessageSignee: "",
    });
    let is_validated = true;
    let errorMessage = "";
    if (!signee_name.trim()) {
      is_validated = false;
      errorMessage = "Signee name is required.";
    } else if (!signee_email.trim()) {
      is_validated = false;
      errorMessage = "Signee email is required.";
    } else if (ValidateEmail(signee_email) === false) {
      is_validated = false;
      errorMessage = "Invalid email format.";
    } else if (!signee_title.trim()) {
      is_validated = false;
      errorMessage = "Signee title is required.";
    }

    if (!is_validated) {
      this.setState({
        errorMessageSignee: errorMessage,
      });
      return;
    }

    if (is_validated) {
      let apiResponce = await sendEmailNew(
        auth.getAccount(),
        auth.getToken(),
        this.state.agent_accountno,
        this.state.signee_name,
        this.state.signee_email,
        this.state.signee_title,
        this.state.signee_comment,
        this.state.selected_agreement_id,
      );
      // console.log("apiResponce.send_email: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        this.setState({
          successMessageSignee: "Email sent successfully.",
          errorMessageSignee: "",
          disabled: false,
          signee_comment: "",
        });
        setTimeout(() => {
          window.$("#modalSendSignee").modal("hide");
        }, 3000);
      } else {
        this.setState({
          errorMessageSignee: "Something went wrong,try again later.",
          disabled: false,
          successMessageSignee: "",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        successMessageSignee: "",
        errorMessageSignee: "",
      });
    }, 3000);
  };

  handleRevokeValueChange = (event) => {
    const { target } = event;
    const value = target.value;

    this.setState({
      revoke_reason: value,
    });
  };

  revokeAgreement = async (agreement_id, agreement_accountno) => {
    this.setState({
      isRevokeReasonActive: true,
      revoke_reason: "",
      errorMessage: "",
      successMessage: "",
      revokeAgreementData: {
        agreement_id: agreement_id,
        agreement_accountno: agreement_accountno,
      },
    });
  };

  handleAgentAgreementRevokeSubmit = async (
    agreement_id,
    agreement_accountno,
    agent_id,
    revoke_reason,
  ) => {
    let is_validated = true;
    if (revoke_reason === "") {
      is_validated = false;
      this.setState({
        errorCompName: "error",
        errorMessage: "Revoke Reason is required.",
      });
    }
    if (is_validated === true) {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
        disabled: true,
      });

      const servicesResponce = await revokeAgentSignedAgreements(
        auth.getAccount(),
        auth.getToken(),
        agent_id,
        agreement_id,
        agreement_accountno,
        revoke_reason,
      );
      // console.log(
      //   "handleAgentAgreementRevokeSubmit.data: ",
      //   servicesResponce.data
      // );
      this.setState({
        disabled: false,
      });
      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      } else if (servicesResponce.data.status === 406) {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
        //window.location.replace("/error");
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          successMessageAgreements: "Agreement is revoked successfully",
          revoke_reason: "",
          isRevokeReasonActive: false,
        });
      } else {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
      });
      this.agentAgreements();
      this.reloadAgentInfo();
    }, 4000);
  };

  approveAgreement = async (agent_id) => {
    const { approve_agreement_accountno, approve_agreement_id } = this.state;
    this.setState({
      successMessageAgreements: "",
      errorMessageAgreements: "",
      disabled: true,
    });

    const servicesResponce = await approveAgentSignedAgreement(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
      approve_agreement_id,
      approve_agreement_accountno,
    );
    // console.log("approveAgreement.data: ", servicesResponce.data);
    this.setState({
      disabled: false,
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.agentAgreements();
      this.reloadAgentInfo();
      this.setState({
        successMessageAgreements: "Agreement approved successfully",
        approve_agreement_id: "",
        approve_agreement_accountno: "",
        isApproveActive: false,
      });
    } else {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
    }

    setTimeout(() => {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
      });
    }, 4000);
  };
  agentLogin = async () => {
    this.setState({
      loginErrorMessage: "",
      login_url: "",
      showLoginModal: true,
    });
    const servicesResponce = await getAgentLogin(
      auth.getAccount(),
      auth.getToken(),
      this.state.client_id,
    );
    // console.log("agentLogin.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "inactive"
    ) {
      this.setState({
        loginErrorMessage: "Account is not active.",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "notVerified"
    ) {
      this.setState({
        loginErrorMessage:
          "Account is not verifed. Please check your email and click verify link.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        login_url: servicesResponce.data.login_url,
      });

      this.closeLoginModal();
      setTimeout(() => {
        window.open(servicesResponce.data.login_url, "_blank");
      }, 500);
    } else {
      this.setState({
        loginErrorMessage:
          "There is some error while authenticating the account.",
      });
    }
  };

  closeLoginModal = () => {
    this.setState({
      showLoginModal: false,
      loginErrorMessage: "",
      login_url: "",
    });
  };

  toggleLoginModal = (show) => {
    if (show) {
      this.setState({
        showLoginModal: true,
      });
    } else {
      this.closeLoginModal();
    }
  };

  editAgentForm = async (value, tableMeta) => {
    this.setState({
      modalDataLoading: true,
      isEmailChanged: false,
      showEmailWarning: false,
      proceedAfterEmailModal: false,
    });
    const servicesResponce = await getSingleAgent(
      auth.getAccount(),
      auth.getToken(),
      this.state.client_id,
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let agent_status = "0";
      if (
        servicesResponce.data.data[0][6] &&
        servicesResponce.data.data[0][6] === "active"
      ) {
        agent_status = "1";
      }
      this.setState({
        title: servicesResponce.data.data[0][0],
        name: servicesResponce.data.data[0][1],
        agent_email: servicesResponce.data.data[0][2],
        agent_phone: servicesResponce.data.data[0][3],
        agent_id: servicesResponce.data.data[0][4],
        agent_company: servicesResponce.data.data[0][5],
        agent_status: agent_status,
        sharelink_limit: servicesResponce.data.data[0][7],
        agent_address: servicesResponce.data.data[0][8],
        agent_address2: servicesResponce.data.data[0][9],
        agent_city: servicesResponce.data.data[0][10],
        agent_state: servicesResponce.data.data[0][11],
        agent_zip: servicesResponce.data.data[0][12],
        agent_country: servicesResponce.data.data[0][13],
        agent_isVerified: servicesResponce.data.data[0][14],
        agent_role: servicesResponce.data.data[0][15] || "",
        agent_password: "",
        tableLoader: false,
      });
      window.$("#modalFormDetail").modal("show");
    } else {
      // window.location.replace("/error");
    }
    this.setState({ modalDataLoading: false });
  };

  formUpdateSubmit = async () => {
    let {
      title,
      name,
      agent_email,
      agent_password,
      c_password,
      agent_phone,
      agent_company,
      agent_status,
      sharelink_limit,
      agent_address,
      agent_address2,
      agent_city,
      agent_state,
      agent_zip,
      agent_country,
      statusChanged,
      agent_isVerified,
      isEmailChanged,
      proceedAfterEmailModal,
    } = this.state;
    const modalBody = document.getElementById("modalFormDetail");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    this.setState({
      proceedAfterEmailModal: false,
      showEmailWarning: false,
      successMessageEdit: "",
      errorMessageEdit: "",
    });
    this.setState({
      errorMessageEdit: "",
      errorName: "",
      errorStatus: "",
      errorAgentCompany: "",
      errorAgentEmail: "",
      errorAgentPhone: "",
      errorAgentAddress: "",
      errorAgentCity: "",
      errorAgentState: "",
      errorAgentZip: "",
      errorAgentCountry: "",
      errorAgentPassword: "",
      errorCPassword: "",
      errorPass: "",
      errorAgentSharelink: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (this.state.name === "") {
      this.setState({
        errorName: "error",
        errorMessageEdit: `${localization.specificPortals.agentLabel} Name is required.`,
      });
      is_validated = false;
    } else if (this.state.agent_company === "") {
      this.setState({
        errorAgentCompany: "error",
        errorMessageEdit: "Company name is required.",
      });
      is_validated = false;
    } else if (this.state.agent_phone === "") {
      this.setState({
        errorAgentPhone: "error",
        errorMessageEdit: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.agent_phone)) {
      this.setState({
        errorAgentPhone: "error",
        errorMessageEdit: "Invalid phone format.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.agent_email) === false) {
      this.setState({
        errorAgentEmail: "error",
        errorMessageEdit: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.agent_password !== "") {
      if (this.state.agent_password.length < 8) {
        this.setState({
          errorAgentPassword: "error",
          errorMessageEdit: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(agent_password)) {
        this.setState({
          errorAgentPassword: "error",
          errorMessageEdit:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.c_password === "") {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit: "Confirm password is required.",
        });
        is_validated = false;
      } else if (this.state.c_password.length < 8) {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit:
            "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (
        this.state.agent_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorCPassword: "error",
          errorMessageEdit: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    } else if (this.state.agent_address === "") {
      this.setState({
        errorAgentAddress: "error",
        errorMessageEdit: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.agent_city === "") {
      this.setState({
        errorAgentCity: "error",
        errorMessageEdit: "City is required.",
      });
      is_validated = false;
    } else if (this.state.agent_state === "") {
      this.setState({
        errorAgentState: "error",
        errorMessageEdit: "State is required.",
      });
      is_validated = false;
    } else if (this.state.agent_zip === "") {
      this.setState({
        errorAgentZip: "error",
        errorMessageEdit: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (this.state.agent_country === "") {
      this.setState({
        errorAgentCountry: "error",
        errorMessageEdit: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.sharelink_limit === "") {
      this.setState({
        errorAgentSharelink: "error",
        errorMessageEdit: `${localization.specificPortals.sharelinkLabel} limit is required.`,
      });
      is_validated = false;
    }
    if (is_validated) {
      if (isEmailChanged && !proceedAfterEmailModal) {
        this.setState({ showEmailWarning: true });
        return;
      }
      let apiResponce = await editAgent(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        agent_email,
        agent_password,
        agent_phone,
        this.state.client_id,
        agent_company,
        agent_status,
        sharelink_limit,
        agent_address,
        agent_address2,
        agent_city,
        agent_state,
        agent_zip,
        agent_country,
        this.state.notifyCheckBox.toString(),
        statusChanged,
        agent_isVerified,
        this.state.agent_role,
      );
      //console.log("Edit Agent RES: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";
        this.setState({
          errorMessageEdit: formattedErrorMessage,
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "already_assigned"
      ) {
        this.setState({
          successMessageEdit: "",
          errorMessageEdit: "Email already in use. Please use a different one.",
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessageEdit: `${localization.specificPortals.agentLabel} updated successfully.`,
          errorMessageEdit: "",
          tableLoader: false,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessageEdit: "Something went wrong,try again later.",
          successMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageEdit: "",
        successMessageEdit: "",
        disabled: false,
        tableLoader: false,
        notifyCheckBox: false,
      });
    }, 3000);
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleChangeCountry = (event) => {
    const country = event?.label || "";
    this.setState({
      agent_country: country,
    });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  notifyAgentLoginByEmail = async () => {
    this.modalOpenForgotPasswordLink();
  };

  resendActivationAgent = async () => {
    let { agent_accountno } = this.state;
    this.setState({
      activation_button: true,
      activation_tick: false,
      activation_cross: false,
    });
    window.$("#modalAlertResend").modal("show");
    const kycResponce = await resendActivationAgent(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    //console.log("resendActivationAgent: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: true,
        activation_cross: false,
      });
    } else {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
    }
    setTimeout(() => {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: false,
      });
      window.$("#modalAlertResend").modal("hide");
    }, 4000);
  };

  // Commission allocation of a Partner Sub-Agent: a free decimal percentage
  // of the order total (e.g. 0.1 / 2 / 5 / 10), capped by the Main Agent's
  // commission. Validated channel-side; 409 over_allocation returns remaining.
  openAllocationModal = async () => {
    this.setState({
      allocation_error: "",
      allocation_success: "",
      allocation_loading: true,
      allocation_saving: false,
    });
    window.$("#modalSubAgentAllocation").modal("show");
    await this.loadAllocation();
  };

  loadAllocation = async () => {
    try {
      const res = await getPartnerSubAgentCommissionAllocation(
        auth.getAccount(),
        auth.getToken(),
        Number(this.state.client_id),
      );
      if (
        res &&
        res.data &&
        res.data.status === 200 &&
        res.data.message === "success" &&
        res.data.data
      ) {
        const d = res.data.data;
        this.setState({
          allocation_pct: String(d.sub_percentage),
          allocation_main_rate: d.main_rate,
          allocation_loading: false,
        });
      } else {
        this.setState({
          allocation_error: "Unable to load the commission allocation.",
          allocation_loading: false,
        });
      }
    } catch (e) {
      this.setState({
        allocation_error: "Unable to load the commission allocation.",
        allocation_loading: false,
      });
    }
  };

  saveAllocation = async () => {
    const pct = parseFloat(this.state.allocation_pct);
    if (isNaN(pct) || pct < 0 || pct > 100) {
      return this.setState({
        allocation_error: "Please enter a valid percentage between 0 and 100.",
        allocation_success: "",
      });
    }
    this.setState({ allocation_saving: true, allocation_error: "" });
    try {
      const res = await savePartnerSubAgentCommissionAllocation(
        auth.getAccount(),
        auth.getToken(),
        Number(this.state.client_id),
        pct.toString(),
      );
      if (res && res.data && res.data.status === 200) {
        this.setState({
          allocation_success: "Commission allocation saved successfully.",
          allocation_saving: false,
        });
        // Close as soon as the API returns 200; refresh the values in place so
        // reopening shows the saved allocation. Failure branches leave the
        // modal open with the error.
        window.$("#modalSubAgentAllocation").modal("hide");
        await this.loadAllocation();
      } else if (
        res &&
        res.data &&
        res.data.status === 409 &&
        res.data.message === "over_allocation"
      ) {
        const max =
          res.data.data && res.data.data.max !== undefined
            ? res.data.data.max
            : "";
        this.setState({
          allocation_error:
            "A Sub Agent's commission cannot exceed the Main Agent's commission (max " +
            max +
            "%).",
          allocation_success: "",
          allocation_saving: false,
        });
      } else {
        this.setState({
          allocation_error: "Something went wrong, try again later.",
          allocation_success: "",
          allocation_saving: false,
        });
      }
    } catch (e) {
      this.setState({
        allocation_error: "Something went wrong, try again later.",
        allocation_success: "",
        allocation_saving: false,
      });
    }
  };

  agentAssignRole = async () => {
    const agentId = this.state.client_id;
    const agentEmail = this.state.client_update_email;
    const agentComp = this.state.client_comp_name;
    const agentName = this.state.client_update_name;
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      agentRoleLoader: true,
      disableRoleBtn: false,
      disableSubRoleBtn: false,
      rolesAgentName: agentName + " (" + agentComp + ")",
      checkedName: agentName,
      checkedEmail: agentEmail,
    });
    window.$("#modalAgentAssignRole").modal("show");
    this.getAgentRoleData(agentId, agentEmail);
  };

  getAgentRoleData = async (agentId, agentEmail) => {
    const listAgentAssignRoles = await ListAgentAssignRoles(
      auth.getAccount(),
      auth.getToken(),
      agentId,
      agentEmail,
    );

    // console.log("ListAgentRoles Res: ", listAgentAssignRoles.data.data);
    if (
      listAgentAssignRoles.data.status === 403 ||
      listAgentAssignRoles.data.errors === "authentication missing" ||
      listAgentAssignRoles.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentAssignRoles.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentAssignRoles.data.status === 200 &&
      listAgentAssignRoles.data.message === "success"
    ) {
      const assignRoleData = listAgentAssignRoles.data.data.roles;
      const assignSubRoleData = listAgentAssignRoles.data.data.subroles;
      const allRoleData = listAgentAssignRoles.data.data.Allroles.map(
        (role) => {
          const isActiveRole = assignRoleData.some(
            (assignedRole) =>
              assignedRole.alt === role.alt && assignedRole.isactive === 1,
          );
          return {
            ...role,
            isChecked: isActiveRole,
          };
        },
      );

      const allSubRoleData = listAgentAssignRoles.data.data.Allsubroles.map(
        (subRole) => {
          const isActiveSubRole = assignSubRoleData.some(
            (assignedSubRole) =>
              assignedSubRole.alt === subRole.alt &&
              assignedSubRole.isactive === 1,
          );
          return {
            ...subRole,
            isChecked: isActiveSubRole,
          };
        },
      );

      this.setState({
        assignRoleData,
        assignSubRoleData,
        allRoleData,
        allSubRoleData,
        agentRoleLoader: false,
      });

      const initialActiveRoles = assignRoleData
        .filter((role) => role.isactive === 1)
        .map((role) => ({
          alt: role.alt,
          isChecked: true,
        }));

      const initialActiveSubRoles = assignSubRoleData
        .filter((subRole) => subRole.isactive === 1)
        .map((subRole) => ({
          id: subRole.id,
          isChecked: true,
        }));

      this.setState({
        changedRolesRights: initialActiveRoles,
        changedSubRolesRights: initialActiveSubRoles,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  changedAllRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedRoleIds in the state
    const { checkedRoleIds } = this.state;
    const updatedCheckedRoleIds = checked
      ? [...checkedRoleIds, name] // add ID if checked
      : checkedRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedRoleIds: updatedCheckedRoleIds });

    // Update allRoleData with isChecked property
    const { allRoleData, allSubRoleData } = this.state;
    const updatedAllRoleData = allRoleData.map((role) => {
      if (role.id.toString() === name) {
        return {
          ...role,
          isChecked: checked,
        };
      }
      return role;
    });

    // Update associated sub roles
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.role_id.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({
      allRoleData: updatedAllRoleData,
      allSubRoleData: updatedAllSubRoleData,
    });
  };

  changedAllSubRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedSubRoleIds in the state
    const { checkedSubRoleIds } = this.state;
    const updatedCheckedSubRoleIds = checked
      ? [...checkedSubRoleIds, name] // add ID if checked
      : checkedSubRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedSubRoleIds: updatedCheckedSubRoleIds });

    // Update allSubRoleData with isChecked property
    const { allSubRoleData } = this.state;
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.tabdetailid.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({ allSubRoleData: updatedAllSubRoleData });
  };

  handleSubmitRoleCheckbox = async (name, email) => {
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      disableRoleBtn: true,
    });

    const { allRoleData, allSubRoleData } = this.state;

    // Prepare the CheckRoleFields array with IDs and isactive status
    const CheckRoleFields = allRoleData.map((role) => ({
      id: role.id,
      isactive: role.isChecked ? 1 : 0,
    }));

    const CheckSubRoleFields = allSubRoleData.map((role) => ({
      id: role.tabdetailid,
      isactive: role.isChecked ? 1 : 0,
    }));

    try {
      // Call the backend API to save the roles
      const saveResponce = await editAgentAssignRole(
        auth.getAccount(),
        auth.getToken(),
        CheckRoleFields,
        CheckSubRoleFields,
        name,
        email,
      );

      // Handle response status
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        this.setState({
          errorMessageAgentRole: `There is some error while updating the ${localization.specificPortals.agentLabel} menu.`,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageAgentRole: "",
          successMessageAgentRole: `${localization.specificPortals.agentLabel} menu updated successfully.`,
          disableRoleBtn: false,
        });
        setTimeout(() => {
          window.$("#modalAgentAssignRole").modal("hide");
        }, 3000);
      } else {
        this.setState({
          errorMessageAgentRole: saveResponce.data.message,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      }
    } catch (error) {
      console.error("Error while saving roles:", error);
      this.setState({
        errorMessageAgentRole: "An error occurred while saving menu.",
        successMessageAgentRole: "",
        disableRoleBtn: false,
      });
    }
  };

  openLinkInNewTab = (link) => {
    window.open(link, "_blank");
  };

  loginDetailView = async (value, tableMeta) => {
    let agent_id = this.state.client_id;
    const servicesResponce = await getSingleAgentLoginDetail(
      auth.getAccount(),
      auth.getToken(),
      agent_id,
    );
    // console.log("servicesResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        loginDetails:
          servicesResponce.data.data && servicesResponce.data.data.length > 0
            ? [servicesResponce.data.data[0]]
            : [],
        tableLoader: false,
      });
      window.$("#modalLoginDetail").modal("show");
    } else {
      // window.location.replace("/error");
    }
  };

  agent_assigned_forms = async () => {
    const { agent_accountno } = this.state;
    // console.log("archived_agreements agent_accountno: ", agent_accountno);
    const kycResponce = await getAgentAssignedForms(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    // console.log("agent_assigned_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the assigned forms. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        formsAssignedData: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnForms: [
          {
            name: "form_title",
            label: "Title / Progress",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_client_title_for_clients(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_download_form(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_view_form_submission ===
                                  1 ? (
                                  <li>
                                    <Tooltip
                                      title="View Details"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.viewAgentSubmission(
                                            value,
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-card-view"></em>
                                        <span>View Details</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                {tableMeta.rowData[2] !== 1 &&
                                (!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] !== 1) ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_form_submission === 1 ? (
                                      <li>
                                        <Tooltip
                                          title="View Details"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            href={`${AGENT_PORTAL_URL}partner_forms/${tableMeta.rowData[10]}`}
                                            target="_blank"
                                          >
                                            <em className="icon ni ni-edit"></em>
                                            <span>Edit</span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}
                                {/* {tableMeta.rowData[2] === 1 ? (
                                  <li>
                                    <Tooltip
                                      title="Edit Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.redirectToEditResponse(
                                            "cp",
                                            tableMeta
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-card-view"></em>
                                        <span>Edit Submission</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null} */}
                                {tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 0 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_approve_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Approve Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openApproveClientAlert(
                                                value,
                                                "agents",
                                                tableMeta,
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-done text-success"></em>
                                            <span className="text-success">
                                              Approve
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_reject_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Reject Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openRejectionAgentAlert(
                                                value,
                                                "agents",
                                                tableMeta,
                                              )
                                            }
                                            className="text-danger"
                                          >
                                            <em className="icon ni ni-cross-circle text-danger"></em>
                                            <span className="text-danger">
                                              Reject
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 2 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state.permission_approve_agreement ===
                                      1 ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state
                                          .permission_approve_form_submission ===
                                          1 ? (
                                          <li>
                                            <Tooltip
                                              title="Approve Submission"
                                              placement="top"
                                            >
                                              <a
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  this.openApproveClientAlert(
                                                    value,
                                                    "agents",
                                                    tableMeta,
                                                  )
                                                }
                                              >
                                                <em className="icon ni ni-done text-success"></em>
                                                <span className="text-success">
                                                  Approve
                                                </span>
                                              </a>
                                            </Tooltip>
                                          </li>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state.permission_reject_agreement ===
                                      1 ? (
                                      <>
                                        {this.state.permissionsState &&
                                        this.state.permissionsState.length >
                                          0 &&
                                        this.state
                                          .permission_reject_form_submission ===
                                          1 ? (
                                          <li>
                                            <Tooltip
                                              title="Reject Submission"
                                              placement="top"
                                            >
                                              <a
                                                style={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  this.openRejectionAgentAlert(
                                                    value,
                                                    "agents",
                                                    tableMeta,
                                                  )
                                                }
                                                className="text-danger"
                                              >
                                                <em className="icon ni ni-cross-circle text-danger"></em>
                                                <span className="text-danger">
                                                  Reject
                                                </span>
                                              </a>
                                            </Tooltip>
                                          </li>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </>
                                ) : null}
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state
                                  .permission_view_submission_rejections ===
                                  1 ? (
                                  <li>
                                    <Tooltip
                                      title="View all rejections"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.modalAllRejectionsAgent(
                                            value,
                                            "agents",
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle"></em>
                                        <span>View Rejections</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                {tableMeta.rowData[8] === 0 &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_form_submission === 1 ? (
                                      <li>
                                        <Tooltip
                                          title="Send Form"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.get_general_submission_link(
                                                value,
                                                tableMeta,
                                              )
                                            }
                                            className="text-danger"
                                          >
                                            <em className="icon ni ni-send text-warning"></em>
                                            <span className="text-warning">
                                              Send Form
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}

                                {tableMeta.rowData[8] &&
                                tableMeta.rowData[8] === 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={tableMeta.rowData[9]}
                                        target="_blank"
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-link-alt text-warning"></em>
                                        <span className="text-warning">
                                          Link Only
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {(!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] === 0) &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_submission_notifications ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Notification settings"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.open_notifications(
                                                value,
                                                tableMeta,
                                              )
                                            }
                                            disabled={
                                              this.props.is_msa_signed ===
                                                "No" ||
                                              this.props.defaultSettings ===
                                                "missing"
                                                ? true
                                                : false
                                            }
                                          >
                                            <em className="icon ni ni-bell"></em>
                                            <span>Notification settings</span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "progress",
            label: "Token",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  format_submitted = (value) => {
    if (value === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_download_form = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    if (value && value !== "") {
      return (
        <>
          {this.state.permissionsState &&
          this.state.permissionsState.length > 0 &&
          this.state.permission_view_form_submission === 1 ? (
            <>
              <a
                onClick={() =>
                  this.downloadPdfClient(value, this.state.form_title)
                }
                title="Download PDF"
                style={{ cursor: "pointer" }}
              >
                <span className="badge badge-outline-primary">
                  <em className="icon ni ni-download"></em>
                </span>
              </a>
              <a
                href={`${APP_URL}forms/view_agent_submission/${form_token}`}
                title="Submission View"
                style={{ cursor: "pointer", marginLeft: "5px" }}
                target="_blank"
              >
                <span className="badge badge-outline-primary">
                  <em className="icon ni ni-table-view"></em>
                </span>
              </a>
            </>
          ) : (
            <span className="badge badge-outline-light">---</span>
          )}
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  format_submission_status = (value, tableMeta) => {
    const is_submitted = tableMeta.rowData[2];
    if (is_submitted === 1) {
      if (value === 0) {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-done"></em> Pending Approval
          </span>
        );
      } else if (value === 1) {
        return (
          <span className="badge badge-outline-success">
            <em className="icon ni ni-caution"></em> Approved
          </span>
        );
      } else if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-file"></em> Archived
          </span>
        );
      } else {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-caution"></em> Pending Approval
          </span>
        );
      }
    } else {
      if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-warning">
            <em className="icon ni ni-file"></em> Drafted
          </span>
        );
      } else {
        return "---";
      }
    }
  };

  downloadPdfClient = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url =
        AGENT_PORTAL_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  viewAgentSubmission = async (id, tableMeta) => {
    const { agent_accountno } = this.state;
    const form_token = tableMeta.rowData[10];
    this.setState({
      viewLoader: true,
      viewClientSubmissions: [],
      errorMessageTotals: "",
    });
    const servicesResponse = await viewAgentFormSubmission(
      auth.getAccount(),
      auth.getToken(),
      id,
      form_token,
      agent_accountno,
    );

    window.$("#modalAgentSubmission").modal("show");
    // console.log("viewAgentSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          if (total && total > 0) {
            progressPercentage = (completed / total) * 100;
          }
        }
      }
      this.setState({
        viewClientSubmissions: servicesResponse.data.data,
        extra_files_clients: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    } else {
      {
        this.setState({
          errorMessageTotalsTitle: "No Submission",
          errorMessageTotals: "There are no submissions right now.",
          viewLoader: false,
        });
      }
    }
  };

  redirectToEditResponse = (user, tableMeta) => {
    const url = `${APP_URL}forms/edit_response/${user}/${this.state.agent_accountno}/${tableMeta.rowData[7]}/${tableMeta.rowData[10]}`;
    window.location.href = url;
  };

  openApproveClientAlert = (id, type, tableMeta) => {
    const form_token = tableMeta.rowData[10];
    this.setState({
      agent_submission_id: form_token,
      form_accountno: id,
      agent_submission_type: type,
      approveAgentErrorMessage: "",
      approveAgentSuccessMessage: "",
      approve_agent_button: false,
      form_token: form_token,
      form_title: tableMeta.rowData[0],
    });
    window.$("#modalApproveAgentAlert").modal("show");
  };

  handleApprovalNotesChange = (event) => {
    const value = event.target.value;
    this.setState({
      approvalNotes: value,
      approvalNotesError: "",
    });
  };

  approve_client_form = async () => {
    const {
      agent_submission_id,
      agent_submission_type,
      form_accountno,
      form_title,
      agent_accountno,
      form_token,
      approvalNotes,
    } = this.state;
    this.setState({
      approveAgentErrorMessage: "",
      approveAgentSuccessMessage: "",
      approve_agent_button: true,
    });

    const servicesResponse = await approveAgentSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      agent_submission_id,
      form_title,
      agent_submission_type,
      agent_accountno,
      approvalNotes,
    );

    // console.log("approveAgentSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 400 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveAgentErrorMessage:
          "There is some error while approving the submission.",
        approveAgentSuccessMessage: "",
        approve_client_button: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          approveAgentErrorMessage: "",
          approveAgentSuccessMessage: "Submission approved successfully.",

          reject_general_reason: "",
        },
        () => {
          this.setState({
            approvalNotes: "",
            approvalNotesError: "",
          });
          setTimeout(() => {
            if (agent_submission_type === "agents") {
              this.agent_assigned_forms();
            }

            window.$("#modalApproveAgentAlert").modal("hide");
            this.setState({
              approveAgentErrorMessage: "",
              approveAgentSuccessMessage: "",
            });
            //window.location.reload();
          }, 3000);
        },
      );
    } else {
      this.setState({
        approve_client_button: false,
        approveAgentErrorMessage:
          "There is some error while approving the submission.",
        approveAgentSuccessMessage: "",
      });
    }
  };

  modalHideAlll = async (id) => {
    window.$("#" + id).modal("hide");
    if (id === "modalApproveAgentAlert") {
      this.setState({ approvalNotes: "", approvalNotesError: "" });
    }
  };

  openRejectionAgentAlert = (id, type, tableMeta) => {
    let rejection_agent_title = "Reject Submission";
    if (type === "agents") {
      rejection_agent_title = `Reject ${localization.specificPortals.agentLabel} Submission`;
    }
    const form_token = tableMeta.rowData[10];

    this.setState({
      agent_submission_id: form_token,
      form_accountno: id,
      rejectAgentErrorMessage: "",
      rejectAgentSuccessMessage: "",
      reject_agent_reason: "",
      reject_agent_button: false,
      rejection_agent_title: rejection_agent_title,
      agent_submission_type: type,
      form_token: form_token,
      form_title: tableMeta.rowData[0],
    });
    // console.log("resendForm: ", id);
    window.$("#modalRejectionAgentAlert").modal("show");
  };

  reject_agent_form = async () => {
    const {
      agent_submission_id,
      reject_agent_reason,
      form_accountno,
      form_title,
      agent_submission_type,
      agent_accountno,
      form_token,
    } = this.state;
    this.setState({
      reject_agent_button: true,
      rejectAgentErrorMessage: "",
      rejectAgentSuccessMessage: "",
    });
    let is_validated = true;
    if (reject_agent_reason === "") {
      is_validated = false;
    }
    if (is_validated === true) {
      const servicesResponse = await rejectAgentSubmission(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        agent_submission_id,
        reject_agent_reason,
        form_title,
        agent_submission_type,
        agent_accountno,
      );

      // console.log("reject_agent_form: ", servicesResponse.data);

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 400 &&
        servicesResponse.data.message === "form_not_found"
      ) {
        this.setState({
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
          reject_client_button: false,
        });
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState(
          {
            rejectAgentErrorMessage: "",
            rejectAgentSuccessMessage: "Submission rejected successfully.",
            reject_agent_button: false,
            reject_general_reason: "",
          },
          () => {
            setTimeout(() => {
              if (agent_submission_type === "agents") {
                this.agent_assigned_forms();
              }

              window.$("#modalRejectionAgentAlert").modal("hide");
              this.setState({
                rejectAgentErrorMessage: "",
                rejectAgentSuccessMessage: "Submission rejected successfully.",
              });
              //window.location.reload();
            }, 3000);
          },
        );
      } else {
        this.setState({
          reject_client_button: false,
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
        });
      }
    } else {
      this.setState({
        reject_client_button: false,
        rejectClientErrorMessage: "Please enter the reason.",
        rejectClientSuccessMessage: "",
      });
    }
  };

  modalAllRejectionsAgent = async (id, type, tableMeta) => {
    const { agent_accountno } = this.state;
    const form_token = tableMeta.rowData[10];
    const form_title = tableMeta.rowData[0];
    let rejection_agent_title = "All Rejections";
    if (type === "agents") {
      rejection_agent_title = `${localization.specificPortals.agentsLabel} Rejections`;
    }
    this.setState({
      agent_submission_id: id,
      rejectAgentErrorMessage: "",
      rejectAgentSuccessMessage: "",
      reject_agent_reason: "",
      reject_agent_button: false,
      rejection_agent_title: rejection_agent_title,
      agent_submission_type: type,
      form_title: form_title,
    });
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allAgentRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionAgents").modal("show");
    const servicesResponse = await allAgentRejections(
      auth.getAccount(),
      auth.getToken(),
      id,
      form_token,
      agent_accountno,
      type,
    );

    // console.log("allAgentRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",
        allAgentRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  getAllForms = async () => {
    const { agent_accountno } = this.state;
    this.setState({ disableAssignBtn: false });
    const listAgentsResponse = await listAllFormsAgent(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );

    // console.log("getAllForms: ", listAgentsResponse.data);

    if (
      listAgentsResponse.data.status === 403 ||
      listAgentsResponse.data.errors === "authentication missing" ||
      listAgentsResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentsResponse.data.status === 404) {
      // Handle 404 error if needed
      this.setState({
        assignModalLoader: false,
      });
    } else if (
      listAgentsResponse.data.status === 200 &&
      listAgentsResponse.data.message === "success"
    ) {
      let agents = listAgentsResponse.data.data.map((agent) => ({
        value: agent.form_accountno,
        label: agent.form_title,
      }));

      const selectedForms = listAgentsResponse.data.selected_forms.map(
        (agent) => agent.form_accountno,
      );

      const selectAllAgents =
        agents.length > 0 &&
        agents.every((agent) => selectedForms.includes(agent.value));

      this.setState({
        agentsList: agents,
        selectedForms: selectedForms,
        selectAllAgents: selectAllAgents,
        assignModalLoader: false,
      });
    } else {
      this.setState({
        assignModalLoader: false,
      });
      // Handle other responses or errors
    }
    window.$("#modalAssignFormAgent").modal("show");
  };

  handleSubmitAssignFormAgent = async () => {
    const { selectedForms, agent_accountno } = this.state;

    this.setState({ disableAssignBtn: true, formsAssignedData: [] });
    // console.log("selectedForms: ", selectedForms);
    const assignFormResponse = await assignFormToAgents(
      auth.getAccount(),
      auth.getToken(),
      JSON.stringify(selectedForms),
      agent_accountno,
    );

    // console.log("assignFormResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignModal: `There was some error while assigning the forms to the ${localization.specificPortals.agentLabel}.`,
        disableAssignBtn: false,
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      this.setState({
        successMessageAssignModal: `Forms assigned to selected ${localization.specificPortals.agentText}.`,
      });
      this.agent_assigned_forms();
      setTimeout(() => {
        this.setState({
          successMessageAssignModal: "",
          errorMessageAssignModal: "",
        });
        window.$("#modalAssignFormAgent").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageAssignModal: `There was some error while assigning the forms to the ${localization.specificPortals.agentText}.`,
        disableAssignBtn: false,
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignModal: "",
        errorMessageAssignModal: "",
      });
    }, 3500);
  };

  handleClientChange = (event, newSelectedOptions) => {
    const newselectedForms = newSelectedOptions.map((option) => option.value);

    const selectAllAgents =
      this.state.agentsList.length > 0 &&
      this.state.agentsList.length === newselectedForms.length;

    this.setState({
      selectedForms: newselectedForms,
      selectAllAgents: selectAllAgents,
    });
  };

  agent_archived_forms = async () => {
    const { agent_accountno } = this.state;
    // console.log("archived_agreements agent_accountno: ", agent_accountno);
    const kycResponce = await getAgentArchivedForms(
      auth.getAccount(),
      auth.getToken(),
      agent_accountno,
    );
    // console.log("agent_archived_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  format_download_form_archived = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    if (value && value !== "") {
      return (
        <>
          <a
            onClick={() => this.downloadPdfClient(value, this.state.form_title)}
            title="Download PDF"
            style={{
              cursor: "pointer",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-download"></em>
            </span>
          </a>
          <a
            href={`${APP_URL}forms/view_agent_archived_submission/${form_token}`}
            title="Submission View"
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
            target="_blank"
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-table-view"></em>
            </span>
          </a>
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  viewClientArchivedSubmission = async (value, tableMeta) => {
    const archive_date = tableMeta.rowData[11];
    this.setState({
      form_title: tableMeta.rowData[0],
      archive_date: archive_date,
    });

    window.$("#modalClientArchivedSubmission").modal("show");
  };

  preViewDefault = async () => {
    const getEmailResponse = await getEditAgentEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.agent_email || "{{client_email}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // Close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");
  };

  getActionActions = async () => {
    const servicesResponce = await getActionActions(
      auth.getAccount(),
      auth.getToken(),
      this.state.agent_accountno,
    );

    // console.log("servicesResponce.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({ errorMessageAgentAction: "No actions found." });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const actionList = servicesResponce.data.data || [];
      const selectedAction = servicesResponce.data.assign_action;

      // ✅ initialize selected_action_map
      const selectedMap = {};
      if (selectedAction && selectedAction.id) {
        selectedMap[selectedAction.id] = true;
      }

      this.setState({
        agent_action_list: actionList,
        selected_action_map: selectedMap,
        tableLoader: false,
      });

      window.$("#modalAgentAssignAction").modal("show");
    }
  };

  handleEnableChange = (actionId) => {
    this.setState((prevState) => {
      const updatedMap = {
        ...prevState.selected_action_map,
        [actionId]: !prevState.selected_action_map?.[actionId],
      };

      // console.log("Updated selected_action_map:", updatedMap);

      return { selected_action_map: updatedMap };
    });
  };

  saveAgentActions = async () => {
    const enabled_actions = Object.entries(this.state.selected_action_map)
      .filter(([_, isEnabled]) => isEnabled)
      .map(([id]) => parseInt(id));

    const servicesResponce = await saveAgentActionsRequest(
      auth.getToken(),
      auth.getAccount(),
      this.state.agent_accountno,
      enabled_actions,
    );

    // console.log("servicesResponce.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        successMessageAgentAction: "Agent actions updated successfully.",
        errorMessageAgentAction: "",
      });
      setTimeout(() => {
        this.setState({
          successMessageAgentAction: "",
          errorMessageAgentAction: "",
        });
        // window.$("#modalAgentAssignAction").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageAgentAction:
          servicesResponce.data.errors?.message || "Something went wrong.",
        successMessageAgentAction: "",
      });
      setTimeout(() => {
        this.setState({
          successMessageAgentAction: "",
          errorMessageAgentAction: "",
        });
      }, 3000);
    }

    this.setState({ disableSaveBtn: false });
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
          role_field_enabled:
            getCustomSetting_res.data.data[0].role_field_enabled === 1 ||
            getCustomSetting_res.data.data[0].role_field_enabled === "1" ||
            getCustomSetting_res.data.data[0].role_field_enabled === true ||
            getCustomSetting_res.data.data[0].role_field_enabled === "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  format_client_title_for_clients = (value, tableMeta) => {
    let progressPercentage = 0;

    if (
      tableMeta.rowData[11] &&
      tableMeta.rowData[11] !== "undefined/undefined"
    ) {
      let progress = tableMeta.rowData[11];
      let [completed, total] = progress.split("/").map(Number);
      if (total && total > 0) {
        progressPercentage = (completed / total) * 100;
      }
      //console.log("completed - total: " + completed + " - " + total);
    }
    //console.log("progressPercentage: ", progressPercentage);
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div
              className="progress-label text-dark fs-10"
              style={{ fontSize: "12px" }}
            >
              {tableMeta.rowData[0]}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  // getOnboardingPercentage = () => {
  //   const { onboardingItems } = this.state;

  //   if (!onboardingItems || onboardingItems.length === 0) {
  //     return 0;
  //   }

  //   const filledItems = onboardingItems.filter(
  //     (item) => item.isFilled || item.isSkipped,
  //   );
  //   const percentage = (filledItems.length / onboardingItems.length) * 100;

  //   return Math.round(percentage);
  // };

  handleNotificationSchedule = (event) => {
    // console.log("handleNotificationSchedule: ", event.target.checked);
    let schedule = event.target.checked;
    let schedule_div = false;
    if (schedule) {
      schedule_div = true;
    }
    this.setState({
      notification_scheduler: event.target.checked,
      schedule_div: schedule_div,
    });
  };

  handleChangeInitialReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ initial_reminder_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      this.setState({ initial_reminder_interval: numericValue });
    }
  };

  handleChangeRepeatReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 48) {
      this.setState({ repeat_interval: numericValue });
    }
  };

  handleChangeRepeatDays = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_count: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 12) {
      this.setState({ repeat_count: numericValue });
    }
  };

  open_notifications = async (value, tableMeta) => {
    const { agent_accountno } = this.state;
    let form_token = tableMeta.rowData[10];
    let form_accountno = tableMeta.rowData[7];
    this.setState({
      notification_form_token: form_token,
      form_accountno: form_accountno,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      notification_loader: true,
      disabled: false,
      missing_form_settings: "No",
    });
    const servicesResponse = await getAgentNotificationSettings(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      form_token,
      agent_accountno,
    );
    // console.log("getAgentNotificationSettings: ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        notificationErrorMsg: "Form submission not found.",
        notificationSuccessMsg: "",
        missing_form_settings: "No",
        notification_loader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_settings_missing"
    ) {
      this.setState({
        notificationErrorMsg: "",
        missing_form_settings: "Yes",
        notificationSuccessMsg: "",
        notification_loader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let notification_scheduler = false;
      let schedule_div = false;
      let initial_reminder_interval = 2;
      let repeat_interval = 12;
      let repeat_count = 7;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (
          servicesResponse.data.data[0]["is_active"] &&
          servicesResponse.data.data[0]["is_active"] === 1
        ) {
          notification_scheduler = true;
          schedule_div = true;
          initial_reminder_interval =
            servicesResponse.data.data[0]["initial_reminder_interval"];
          repeat_interval = servicesResponse.data.data[0]["repeat_interval"];
          repeat_count = servicesResponse.data.data[0]["repeat_count"];
        }
      }
      this.setState({
        notificationErrorMsg: "",
        notification_scheduler: notification_scheduler,
        schedule_div: schedule_div,
        repeat_count: repeat_count,
        repeat_interval: repeat_interval,
        initial_reminder_interval: initial_reminder_interval,
        notification_loader: false,
        missing_form_settings: "No",
      });
    } else {
      this.setState({
        notificationErrorMsg:
          "There is some error while displaying the notification settings.",
        notificationSuccessMsg: "",
        notification_loader: false,
        missing_form_settings: "No",
      });
    }
    window.$("#modalNotificationSchedule").modal("show");
  };

  submitNotifications = async () => {
    const {
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      notification_scheduler,
      form_submission_id,
      submission_type,
      form_accountno,
      agent_accountno,
      notification_form_token,
    } = this.state;

    this.setState({
      notification_loader: true,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
    });

    if (repeat_interval === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg: "Please enter the repeat reminder.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "" });
      }, 4000);
    } else if (repeat_count === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg:
          "Please enter the days for which this notification reminders will be sent.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "", notificationSuccessMsg: "" });
      }, 4000);
    } else {
      let notificationScheduler = notification_scheduler ? "1" : "0";
      const servicesResponse = await submitAgentNotificationSettings(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        notification_form_token,
        agent_accountno,
        notificationScheduler,
        repeat_count,
        repeat_interval,
        initial_reminder_interval,
      );
      // console.log("submitAgentNotificationSettings: ", servicesResponse.data);
      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 404 &&
        servicesResponse.data.message === "not_found"
      ) {
        this.setState({
          notificationErrorMsg: "Form submission not found.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState({
          notificationErrorMsg: "",
          notificationSuccessMsg: "Notification settings updated successfully.",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else {
        this.setState({
          notificationErrorMsg:
            "There is some error while updated the notification settings.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      }
    }
  };

  modalOpenForgotPasswordLink = () => {
    this.setState({
      notifyLoginLoading: true,
      notifyLoginSuccess: "",
      notifyLoginError: "",
      resetLink: "",
      loginUrl: AGENT_PORTAL_URL+ 'onboardsoft/agent/login',
      copiedLogin: false,
      copiedResetPassword: false,
      loginEmailSent: false,
      resetPasswordEmailSent: false,
      loginEmailError: "",
      resetPasswordEmailError: "",
    });
    this.openNotificationModal();
  };

  copyToClipboard = (type) => {
    const textToCopy = type === "login" ? this.state.loginUrl : this.state.resetLink;
    const stateKey = type === "login" ? "copiedLogin" : "copiedResetPassword";
    
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.setState({
        successMessage: "Link Copied Successfully!",
        [stateKey]: true,
      });
      setTimeout(
        () => this.setState({ successMessage: "", [stateKey]: false }),
        2000,
      );
    });
  };

  openNotificationModal = async () => {
    // Fetch reset password link
    try {
      const servicesResponce = await getPartnerForgotPasswordLink(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_update_email,
        this.state.agent_accountno,
      );

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState(
          {
            resetLink: servicesResponce.data.data.data,
            notifyLoginLoading: false,
          },
          () => {
            window.$("#modalNotificationLinks").modal("show");
          },
        );
      } else {
        this.setState({ 
          notifyLoginError: "Unable to generate reset password link.",
          notifyLoginLoading: false 
        });
      }
    } catch (e) {
      this.setState({ 
        notifyLoginError: "Failed to generate links.",
        notifyLoginLoading: false 
      });
    }
  };

  sendEmailUrl = async (type) => {
    const statePrefix = type === "login" ? "login" : "resetPassword";
    const urlToSend = type === "login" ? this.state.loginUrl : this.state.resetLink;
    const emailType = type === "login" ? "Login URL" : "Reset password";
    
    this.setState({
      [`sending${statePrefix.charAt(0).toUpperCase() + statePrefix.slice(1)}Email`]: true,
      [`${statePrefix}EmailSent`]: false,
      successMessage: "",
      errorMessage: "",
    });

    try {
      const apiCall = type === "login" 
        ? sendAgentLoginUrlEmail 
        : sendAgentResetPasswordEmail;
        
      const response = await apiCall(
        auth.getAccount(),
        auth.getToken(),
        this.state.agent_accountno,
        urlToSend,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        this.setState({ 
          errorMessage: "Authentication error"
        });
      } else if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        this.setState({ 
          [`${statePrefix}EmailSent`]: true,
          successMessage: `${emailType} email sent successfully!`
        });
        setTimeout(() => this.setState({ [`${statePrefix}EmailSent`]: false, successMessage: "" }), 5000);
      } else {
        const errMsg = response.data.message || response.data.errors || "Failed to send email.";
        this.setState({ 
          errorMessage: errMsg
        });
      }
    } catch (e) {
      this.setState({ 
        errorMessage: e.message || "Failed to send email."
      });
    }
    
    this.setState({
      [`sending${statePrefix.charAt(0).toUpperCase() + statePrefix.slice(1)}Email`]: false,
    });
  };

  getForgotPasswordLink = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      resetLink: "",
    });

    const servicesResponce = await getPartnerForgotPasswordLink(
      auth.getAccount(),
      auth.getToken(),
      this.state.client_update_email,
      this.state.agent_accountno,
    );
    // console.log("servicesResponce: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          resetLink: servicesResponce.data.data.data, // save full URL
        },
        () => {
          // show modal only after link is ready
          window.$("#modalForgotPasswordLink").modal("show");
        },
      );
    } else {
      this.setState({ errorMessage: "Unable to generate link." });
    }
  };

  get_general_submission_link = async (value, tableMeta, type) => {
    this.setState({
      showMailForm: false,
      form_title: tableMeta.rowData[0],
    });
    window.$("#modalSubmissionLink").modal("show");

    this.setState({
      deleteLoader: true,
      submission_link: "",
    });
    setTimeout(() => {
      this.setState({
        deleteLoader: false,
        submission_link: `${AGENT_PORTAL_URL}partner_forms/${tableMeta.rowData[10]}`,
      });
    }, 3000);
  };

  copySubmissionLink = () => {
    navigator.clipboard.writeText(this.state.submission_link).then(() => {
      this.setState({
        successMessageSub: "Link Copied Successfully!",
        copiedSub: true,
      });
      setTimeout(
        () => this.setState({ successMessageSub: "", copiedSub: false }),
        2000,
      );
    });
  };

  sendSubmissionLinkByEmail = async () => {
    const { mailName, mailEmail, mailComment, submission_link, form_title } =
      this.state;

    // reset messages and disable button
    this.setState({
      successMessageMail: "",
      errorMessageMail: "",
      disabled: true,
    });

    // validations
    if (!mailName.trim()) {
      this.setState({
        errorMessageMail: "Please enter the name.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (!mailEmail.trim()) {
      this.setState({
        errorMessageMail: "Please enter the email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (ValidateEmail(mailEmail) === false) {
      this.setState({
        errorMessageMail: "Please enter a valid email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
    if (!mailComment.trim()) {
      this.setState({
        errorMessageMail: "Please enter the comment.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }

    try {
      const response = await sendPartnerSubmissionLinkByEmail(
        auth.getAccount(),
        auth.getToken(),
        mailName.trim(),
        mailEmail.trim(),
        mailComment.trim(),
        submission_link,
        auth.getUserType(),
        form_title,
      );

      const { status, message, errors } = response.data;

      if (
        status === 403 ||
        errors === "authentication missing" ||
        errors === "jwt expired"
      ) {
        return auth.logout();
      }

      if (status === 409) {
        this.setState({
          errorMessageMail: "Client already registered with this email.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
      } else if (status === 404) {
        this.setState({
          errorMessageMail:
            "There was an error while sending the submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
      } else if (status === 200 && message === "success") {
        this.setState({
          successMessageMail:
            "Submission link successfully sent to the partner.",
          errorMessageMail: "",
          disabled: false,
          mailName: "",
          mailEmail: "",
          mailComment: "",
        });
        setTimeout(() => this.setState({ successMessageMail: "" }), 3000);
      } else {
        this.setState({
          errorMessageMail: "Unexpected error while sending submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
      }
    } catch (error) {
      console.error("Error sending submission link:", error);
      this.setState({
        errorMessageMail: "An error occurred. Please try again later.",
        disabled: false,
      });
      setTimeout(() => this.setState({ errorMessageMail: "" }), 3000);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const fetchToken = async () => {
      try {
        const response = await fetch(
          AGENT_SERVER_URL + "agents/editor_token_url",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          },
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content " id="Clients_Block">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      {this.state.is_sub_agent
                        ? "Sub Agent"
                        : localization.specificPortals.agentLabel}{" "}
                      /{" "}
                      <strong className="text-primary small">
                        {this.state.client_update_name} (
                        {this.state.client_comp_name})
                      </strong>
                    </h3>
                    <div className="nk-block-des text-soft">
                      <ul className="list-inline">
                        <li>
                          {this.state.is_sub_agent
                            ? "Sub Agent"
                            : localization.specificPortals.agentLabel}{" "}
                          ID:{" "}
                          <span className="text-base">
                            {this.state.agent_accountno}
                          </span>
                        </li>

                        {/*<li>
                          Last Login:{" "}
                          <span className="text-base">15 Feb, 2019 01:02 PM</span>
                        </li>*/}
                      </ul>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <a
                      onClick={() => this.openInviteClientModal()}
                      style={{ cursor: "pointer", marginRight: "10px" }}
                      className="btn btn-primary d-none d-sm-inline-flex text-white"
                    >
                      <em className="icon ni ni-user-add"></em>
                      <span>Invite New Client</span>
                    </a>
                    <a
                      onClick={() => this.openInviteClientModal()}
                      style={{ cursor: "pointer", marginRight: "10px" }}
                      className="btn btn-icon btn-primary d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-user-add"></em>
                    </a>
                    <a
                      onClick={() => this.addMenuHistory("/agents")}
                      style={{ cursor: "pointer" }}
                      className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                      <span>Back</span>
                    </a>
                    <a
                      onClick={() => this.addMenuHistory("/agents")}
                      style={{ cursor: "pointer" }}
                      className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                    </a>
                  </div>
                </div>
              </div>
              <div className="modal fade" tabIndex="-1" id="modalInviteClientAgent">
                <div
                  className="modal-dialog modal-dialog-top modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em
                          className="icon ni ni-user-add"
                          style={{ marginRight: "5px" }}
                        ></em>{" "}
                        Invite New Client
                      </h5>
                    </div>
                    <div className="modal-body">
                      <div className="row g-4">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              Client Signup Link
                            </label>
                            <div className="form-control-group">
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={this.buildClientRegisterLink()}
                                  readOnly
                                  onFocus={(e) => e.target.select()}
                                  placeholder="Client signup link"
                                />
                                <div className="input-group-append">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.copyClientSignup}
                                    disabled={!this.state.clientSignupLink}
                                    title="Copy link"
                                  >
                                    <em className="icon ni ni-copy"></em>
                                    <span style={{ marginLeft: "5px" }}>
                                      {this.state.copiedClientSignup
                                        ? "Copied"
                                        : "Copy"}
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.inviteClientError !== "" ? (
                          <div className="col-md-12">
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.inviteClientError}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.inviteClientSuccess !== "" ? (
                          <div className="col-md-12">
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.inviteClientSuccess}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="col-md-12">
                          <div className="example-alert">
                            <div className="alert alert-light">
                              <em className="icon ni ni-alert-circle mr-1"></em>{" "}
                              The client will be invited to register under{" "}
                              <strong>
                                {this.state.client_update_name} (
                                {this.state.client_comp_name})
                              </strong>
                              .
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="inviteClientName"
                                name="inviteClientName"
                                type="text"
                                label="Full Name"
                                value={this.state.inviteClientName}
                                inputProps={{ maxLength: 64 }}
                                onChange={(e) =>
                                  this.setState({
                                    inviteClientName: e.target.value,
                                  })
                                }
                                helperText="Full name of the invite recipient."
                                variant="outlined"
                                fullWidth
                                autoComplete="new-password"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="inviteClientEmail"
                                name="inviteClientEmail"
                                type="text"
                                label="Email Address"
                                value={this.state.inviteClientEmail}
                                inputProps={{ maxLength: 100 }}
                                onChange={(e) =>
                                  this.setState({
                                    inviteClientEmail: e.target.value,
                                  })
                                }
                                helperText="Email address of the invite recipient."
                                variant="outlined"
                                fullWidth
                                autoComplete="new-password"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <TextareaAutosize
                                maxrows={4}
                                name="inviteClientComment"
                                id="inviteClientComment"
                                aria-label=""
                                placeholder="Add Comment *"
                                value={this.state.inviteClientComment}
                                onChange={(e) =>
                                  this.setState({
                                    inviteClientComment: e.target.value,
                                  })
                                }
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  borderColor: "rgba(0, 0, 0, 0.125)",
                                  borderRadius: "4px",
                                  padding: "5px",
                                }}
                                variant="outlined"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 d-flex justify-content-end">
                          <button
                            type="button"
                            onClick={() => this.inviteClientFromAgent()}
                            className="btn btn-primary"
                            disabled={this.state.inviteClientDisabled}
                          >
                            <span>Send Invite</span>{" "}
                            <em className="icon ni ni-emails"></em>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-aside-wrap clientsView">
                    <div className="card-content">
                      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card viewClient_nav-tabs_customStyle">
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "agreements"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("agreements");
                              this.agentAgreements();
                            }}
                          >
                            <em className="icon ni ni-reports-alt"></em>
                            <span>Agreements</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "assigned_products"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("assigned_products");
                              this.showAssignedServices();
                            }}
                          >
                            <em className="icon ni ni-package"></em>
                            <span>Assigned Products</span>
                          </a>
                        </li>
                        {/* <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "onboarding_settings"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("onboarding_settings");
                              // this.getOnboardingItems();
                            }}
                          >
                            <em className="icon ni ni-setting"></em>
                            <span>Onboarding Process</span>
                          </a>
                        </li> */}
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "forms" ? "active" : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("forms");
                              this.agent_assigned_forms();
                            }}
                          >
                            <em className="icon ni ni-list-check"></em>
                            <span>Forms</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className="nav-link"
                            onClick={() => this.agentAssignRole()}
                          >
                            <em className="icon ni ni-grid-alt"></em>
                            <span>
                              {localization.specificPortals.agentLabel} Menu
                            </span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className="nav-link"
                            onClick={() =>
                              this.state.is_sub_agent
                                ? this.openAllocationModal()
                                : this.addMenuHistory(
                                    "/agents/commissions/" +
                                      this.state.client_id,
                                  )
                            }
                          >
                            <em className="icon ni ni-money"></em>
                            <span>Commissions</span>
                          </a>
                        </li>
                        {/* Hidden for Partner Sub-Agents: they can never
                            create Sub Users or Sub-Agents. */}
                        {!this.state.is_sub_agent && (
                          <>
                            <li
                              className="nav-item viewClients_nav-item_customStyle"
                              style={{ cursor: "pointer" }}
                            >
                              <a
                                className="nav-link"
                                onClick={() =>
                                  this.openLinkInNewTab(
                                    "/agents/subagents/" + this.state.client_id,
                                  )
                                }
                              >
                                <em className="icon ni ni-user-list"></em>
                                <span>Sub Users</span>
                              </a>
                            </li>
                            <li
                              className="nav-item viewClients_nav-item_customStyle"
                              style={{ cursor: "pointer" }}
                            >
                              <a
                                className="nav-link"
                                onClick={() =>
                                  this.openLinkInNewTab(
                                    "/agents/partner_subagents/" +
                                      this.state.client_id,
                                  )
                                }
                              >
                                <em className="icon ni ni-users"></em>
                                <span>Sub Agents</span>
                              </a>
                            </li>
                          </>
                        )}
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className="nav-link"
                            onClick={() => this.getActionActions()}
                          >
                            <em className="icon ni ni-setting"></em>
                            <span>
                              {localization.specificPortals.agentLabel} Actions
                            </span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className="nav-link"
                            onClick={() => this.loginDetailView()}
                          >
                            <em className="icon ni ni-signin"></em>
                            <span>Login Details</span>
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={
                            this.state.activeTab === "assigned_products"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemProducts"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <h5 className="title">
                                  Assigned Products & Services
                                </h5>
                                <p>
                                  This list comprises the products or services
                                  allocated or permitted for this{" "}
                                  {localization.specificPortals.agentText}.
                                </p>
                              </div>
                              {this.state.assignedErrorMessage !== "" ? (
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>Error</h6>
                                    <p>{this.state.assignedErrorMessage}</p>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.assignedSuccessMessage !== "" ? (
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.assignedSuccessMessage}</p>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <div className="table-responsive">
                                  {this.state.serviceAssignedData &&
                                  this.state.serviceAssignedData.length > 0 ? (
                                    <>
                                      <table className="table table-striped">
                                        <thead>
                                          <tr>
                                            <th>
                                              <div className="custom-control custom-checkbox">
                                                <input
                                                  type="checkbox"
                                                  checked={this.state.checkAll}
                                                  className="custom-control-input"
                                                  name="selected_products_1"
                                                  onChange={
                                                    this.handleCheckAllChange
                                                  }
                                                  id="product_ids"
                                                autoComplete="new-password" />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="product_ids"
                                                ></label>
                                              </div>
                                            </th>
                                            <th>Item</th>
                                            <th>SKU</th>
                                            <th>Title</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.serviceAssignedData.map(
                                            (row, index) => (
                                              <tr key={`prokey${index}`}>
                                                <td>
                                                  <div className="custom-control custom-checkbox">
                                                    <input
                                                      type="checkbox"
                                                      checked={row.checked}
                                                      className="custom-control-input"
                                                      name="selected_products"
                                                      onChange={() =>
                                                        this.handleCheckboxChange(
                                                          row.id,
                                                        )
                                                      }
                                                      value={row.id}
                                                      id={`product_id_${index}`}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`product_id_${index}`}
                                                    ></label>
                                                  </div>
                                                </td>
                                                <td>{row.id}</td>
                                                <td>
                                                  {row.sku && row.sku !== ""
                                                    ? row.sku
                                                    : "---"}
                                                </td>
                                                <td>{row.service_title}</td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </table>
                                      <div className="col-sm-12 mt-4 d-flex justify-content-end">
                                        <div className="nk-block-head-content">
                                          <ul className="nk-block-tools gx-3">
                                            {this.state
                                              .update_service_button ===
                                            true ? (
                                              <button
                                                className="btn btn-primary"
                                                type="button"
                                                disabled
                                              >
                                                <span
                                                  className="spinner-grow spinner-grow-sm"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                                <span> Processing... </span>
                                              </button>
                                            ) : (
                                              <>
                                                {this.state.permissionsState &&
                                                this.state.permissionsState
                                                  .length > 0 &&
                                                this.state
                                                  .permission_update_products ===
                                                  1 ? (
                                                  <li>
                                                    <a
                                                      onClick={() =>
                                                        this.updateAssignedServices()
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "#fff",
                                                      }}
                                                      className="btn btn-primary"
                                                    >
                                                      <em className="icon ni ni-check-round-cut"></em>{" "}
                                                      <span>Update</span>{" "}
                                                    </a>
                                                  </li>
                                                ) : null}
                                              </>
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>No Service Assigned</h6>
                                        <p>
                                          No service has been assigned to this
                                          client.
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "agreements"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between mb-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title page-title">
                                      Agreements
                                    </h5>
                                  </div>
                                  <div
                                    className="nk-block-head-content"
                                    id="HeadContent"
                                  >
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                      <a
                                        href="#"
                                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                                        data-target="pageMenu"
                                      >
                                        <em className="icon ni ni-more-v"></em>
                                      </a>
                                      <div
                                        className="toggle-expand-content"
                                        data-content="pageMenu"
                                      >
                                        <ul className="nk-block-tools g-3">
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={(e) => {
                                                this.changeActiveTab(
                                                  "archived_agreements",
                                                );
                                                this.archived_agreements(
                                                  this.state.agent_accountno,
                                                );
                                              }}
                                              className="btn btn-white btn-dim btn-outline-primary"
                                            >
                                              <em className="icon ni ni-archived"></em>
                                              &nbsp; Archived Agreements
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        {this.state.errorMessageAgreements !==
                                        "" ? (
                                          <div className="example-alert example-alert-revoke mb-2">
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .errorMessageAgreements
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                        {this.state.successMessageAgreements !==
                                        "" ? (
                                          <div className="example-alert example-alert-revoke mb-2">
                                            <div className="alert alert-pro alert-success">
                                              <div className="alert-text">
                                                <h4>Success</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .successMessageAgreements
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                        {this.state.isRevokeReasonActive ? (
                                          <div id="revokeReasonItems">
                                            <div className="tb-odr-id">
                                              Reason to revoke
                                            </div>
                                            <div className="card card-bordered card-preview mt-1">
                                              <TextareaAutosize
                                                maxRows={4}
                                                name="revoke_reason"
                                                id="revoke_reason"
                                                aria-label=""
                                                placeholder=""
                                                value={this.state.revoke_reason}
                                                onChange={
                                                  this.handleRevokeValueChange
                                                }
                                                style={{
                                                  width: "100%",
                                                  height: "100px",
                                                  borderColor:
                                                    "rgba(0, 0, 0, 0.125)",
                                                  borderRadius: "4px",
                                                }}
                                              />
                                            </div>
                                            <div
                                              className="form-group text-right"
                                              style={{
                                                marginTop: "15px",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <button
                                                type="button"
                                                style={{ marginRight: 5 }}
                                                className="btn btn-light"
                                                onClick={() => {
                                                  this.setState({
                                                    isRevokeReasonActive: false,
                                                    revoke_reason: "",
                                                    errorMessage: "",
                                                    successMessage: "",
                                                  });
                                                }}
                                              >
                                                Cancel
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => {
                                                  this.handleAgentAgreementRevokeSubmit(
                                                    this.state
                                                      .revokeAgreementData
                                                      .agreement_id,
                                                    this.state
                                                      .revokeAgreementData
                                                      .agreement_accountno,
                                                    this.state.agent_accountno,
                                                    this.state.revoke_reason,
                                                  );
                                                }}
                                                disabled={this.state.disabled}
                                              >
                                                Submit
                                              </button>
                                            </div>
                                          </div>
                                        ) : null}

                                        {this.state.isApproveActive ? (
                                          <div className="row g-gs">
                                            <div className="col-md-12 mb-3">
                                              <div className="card card-bordered">
                                                <div className="card-inner">
                                                  <h5 className="card-title">
                                                    Approve Agreement
                                                  </h5>

                                                  <p className="card-text">
                                                    Are you sure you want to
                                                    approve this agreement?
                                                  </p>

                                                  <div className="col-md-12">
                                                    <div className="form-group text-right">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          this.setState({
                                                            isApproveActive: false,
                                                            approve_agreement_accountno:
                                                              "",
                                                            approve_agreement_id:
                                                              "",
                                                          })
                                                        }
                                                        className="btn btn-light"
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        style={{
                                                          marginRight: "15px",
                                                        }}
                                                      >
                                                        No
                                                      </button>
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          this.approveAgreement(
                                                            this.state
                                                              .client_id,
                                                          )
                                                        }
                                                        className="btn btn-success"
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        title=""
                                                      >
                                                        Yes
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        <div className="card card-bordered card-preview">
                                          <table className="table table-orders viewClient_table-orders_customStyle">
                                            <thead className="tb-odr-head">
                                              <tr className="tb-odr-item">
                                                <th>
                                                  <span className="tb-odr-id">
                                                    Agreement Name
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-date d-none d-md-inline-block">
                                                    Signed Date
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-total">
                                                    Approved
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-total">
                                                    Status
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-status d-none d-md-inline-block">
                                                    Download
                                                  </span>
                                                </th>
                                                <th className="tb-odr-action">
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="tb-odr-body">
                                              {this.state.signedData &&
                                              this.state.signedData.length >
                                                0 ? (
                                                <>
                                                  {this.state.signedData.map(
                                                    (signed, index) => (
                                                      <tr
                                                        className="tb-odr-item"
                                                        key={`sign${index}`}
                                                      >
                                                        <td>
                                                          <span className="tb-odr-id">
                                                            {
                                                              signed.agreement_title
                                                            }
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-date">
                                                            {signed.signed_date &&
                                                            signed.signed_date !==
                                                              ""
                                                              ? this.format_date(
                                                                  signed.signed_date,
                                                                )
                                                              : "---"}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-status">
                                                            {signed.approved ===
                                                            "Yes" ? (
                                                              <span className="badge badge-outline-success">
                                                                Yes
                                                              </span>
                                                            ) : (
                                                              <span className="badge badge-outline-danger">
                                                                No
                                                              </span>
                                                            )}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-status">
                                                            {signed.is_signed ===
                                                            "Yes" ? (
                                                              <span className="badge badge-outline-success">
                                                                Signed
                                                              </span>
                                                            ) : (
                                                              <span className="badge badge-outline-danger">
                                                                Unsigned
                                                              </span>
                                                            )}
                                                          </span>
                                                        </td>

                                                        <td>
                                                          {signed.pdf_path &&
                                                          signed.pdf_path !==
                                                            "" ? (
                                                            <>
                                                              <a
                                                                onClick={() =>
                                                                  this.downloadPdf(
                                                                    signed.pdf_path,
                                                                    signed.agreement_title,
                                                                  )
                                                                }
                                                                title="Download Agreement"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              >
                                                                <span className="badge badge-outline-primary">
                                                                  <em className="icon ni ni-download"></em>
                                                                </span>
                                                              </a>
                                                            </>
                                                          ) : (
                                                            <span className="badge badge-outline-light">
                                                              ---
                                                            </span>
                                                          )}
                                                        </td>
                                                        <td className="tb-odr-action">
                                                          <div className="dropdown">
                                                            <a
                                                              className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                                              data-toggle="dropdown"
                                                              data-offset="-8,0"
                                                            >
                                                              <em className="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div
                                                              className="dropdown-menu dropdown-menu-right dropdown-menu-xs"
                                                              style={{
                                                                padding: "0px",
                                                              }}
                                                            >
                                                              <ul className="link-list-plain">
                                                                {signed.is_signed ===
                                                                  "Yes" &&
                                                                signed.approved ===
                                                                  "No" ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      className="text-success"
                                                                      onClick={() =>
                                                                        this.setState(
                                                                          {
                                                                            isApproveActive: true,
                                                                            isRevokeReasonActive: false,
                                                                            approve_agreement_id:
                                                                              signed.agreement_id,
                                                                            approve_agreement_accountno:
                                                                              signed.agreement_accountno,
                                                                          },
                                                                        )
                                                                      }
                                                                    >
                                                                      <em className="icon ni ni-done"></em>
                                                                      <span>
                                                                        Approve
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                                {signed.is_signed ===
                                                                "Yes" ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.revokeAgreement(
                                                                          signed.agreement_id,
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                    >
                                                                      <em className="icon ni ni-na"></em>
                                                                      <span>
                                                                        Revoke
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                                {signed.is_signed ===
                                                                "Yes" ? (
                                                                  <>
                                                                    {this.state
                                                                      .permissionsState &&
                                                                    this.state
                                                                      .permissionsState
                                                                      .length >
                                                                      0 &&
                                                                    this.state
                                                                      .permission_view_signee ===
                                                                      1 ? (
                                                                      <li>
                                                                        <a
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          onClick={() =>
                                                                            this.openSigneeDetails(
                                                                              signed.agreement_accountno,
                                                                            )
                                                                          }
                                                                          data-toggle="tooltip"
                                                                          data-placement="top"
                                                                          title="Show signee details"
                                                                        >
                                                                          <em className="icon ni ni-table-view"></em>
                                                                          <span>
                                                                            Signee
                                                                            Details
                                                                          </span>
                                                                        </a>
                                                                      </li>
                                                                    ) : null}
                                                                  </>
                                                                ) : null}
                                                                {this.state
                                                                  .permissionsState &&
                                                                this.state
                                                                  .permissionsState
                                                                  .length > 0 &&
                                                                this.state
                                                                  .permission_upload_agreement ===
                                                                  1 ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.openUploadContract(
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Upload new agreement"
                                                                    >
                                                                      <em className="icon ni ni-upload"></em>
                                                                      <span>
                                                                        Upload
                                                                        Agreement
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                                {this.state
                                                                  .permissionsState &&
                                                                this.state
                                                                  .permissionsState
                                                                  .length > 0 &&
                                                                this.state
                                                                  .permission_remove_agreement ===
                                                                  1 ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.removeContract(
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Remove Agreement"
                                                                    >
                                                                      <em className="icon ni ni-minus-circle"></em>{" "}
                                                                      <span>
                                                                        Remove
                                                                        Agreement
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}

                                                                {signed.is_signed ===
                                                                "No" ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.open_signee(
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Send this agreement to the signee via email"
                                                                    >
                                                                      <em className="icon ni ni-mail"></em>{" "}
                                                                      <span>
                                                                        Send
                                                                        Email
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                              </ul>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </>
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan="6"
                                                    className="text-center"
                                                  >
                                                    No Assigned Agreements
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "forms"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemForms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      Assigned Forms
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      {this.state.permissionsState &&
                                      this.state.permissionsState.length > 0 &&
                                      this.state.permission_assign_form ===
                                        1 ? (
                                        <li className="order-md-last">
                                          <a
                                            onClick={() => this.getAllForms()}
                                            href="#"
                                            className="btn btn-white btn-dim btn-outline-primary"
                                          >
                                            <em className="icon ni ni-note-add-c"></em>
                                            <span>Assign Forms</span>
                                          </a>
                                        </li>
                                      ) : null}
                                      {this.state.permissionsState &&
                                      this.state.permissionsState.length > 0 &&
                                      this.state
                                        .permission_view_archived_forms ===
                                        1 ? (
                                        <li className="order-md-last">
                                          <a
                                            onClick={(e) => {
                                              this.changeActiveTab(
                                                "archived_forms",
                                              );
                                              this.agent_archived_forms(
                                                this.state.agent_accountno,
                                              );
                                            }}
                                            href="#"
                                            className="btn btn-white btn-dim btn-outline-primary"
                                          >
                                            <em className="icon ni ni-archived"></em>
                                            <span>Archived Submissions</span>
                                          </a>
                                        </li>
                                      ) : null}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.formsErrorMessage !== "" ? (
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>Error</h6>
                                    <p>{this.state.formsErrorMessage}</p>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.formsSuccessMessage !== "" ? (
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.formsSuccessMessage}</p>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={this.state.columnForms}
                                          tableData={
                                            this.state.formsAssignedData
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/***** Archived Agreements *****/}
                        <div
                          className={
                            this.state.activeTab === "archived_agreements"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemArchivedAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-archived"></em>{" "}
                                    Archived Agreements
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        {this.state
                                          .errorMessageArchiveAgreements !==
                                        "" ? (
                                          <div className="example-alert example-alert-revoke">
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .errorMessageArchiveAgreements
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        <div className="card card-bordered card-preview">
                                          <DataTableExtended
                                            columns={this.state.columnServices}
                                            tableData={
                                              this.state.archivedAgreements
                                            }
                                            title=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Archived AGreements *****/}
                        {/***** Archived Forms *****/}
                        <div
                          className={
                            this.state.activeTab === "archived_forms"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemArchivedForms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-card-view"></em>{" "}
                                    Archived Form Submissions
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        {this.state.errorMessageArchiveForms !==
                                        "" ? (
                                          <div className="example-alert example-alert-revoke">
                                            <div className="alert alert-pro alert-danger">
                                              <div className="alert-text">
                                                <h4>Error</h4>
                                                <p>
                                                  {
                                                    this.state
                                                      .errorMessageArchiveForms
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        <div className="card card-bordered card-preview">
                                          <DataTableExtended
                                            columns={
                                              this.state.columnArchivedForms
                                            }
                                            tableData={this.state.archivedForms}
                                            title=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Onboarding Settings *****/}
                        {/* <div
                          className={
                            this.state.activeTab === "onboarding_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemOnboarding"
                        >
                          {this.state.onboardingErrorMessage !== "" ? (
                            <div className="example-alert mb-4">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>
                                    {this.state.onboardingErrorMessageTitle}
                                  </h4>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.onboardingErrorMessage,
                                    }}
                                  ></p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.onboardingSuccessMessage !== "" ? (
                            <div className="example-alert mb-4">
                              <div className="alert alert-pro alert-success m-4">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.onboardingSuccessMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-md-12 mb-4">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  id="onboarding_title"
                                  name="onboarding_title"
                                  type="text"
                                  label="Onboarding Title"
                                  value={this.state.onboardingTitle}
                                  onChange={(e) =>
                                    this.setState({
                                      onboardingTitle: e.target.value,
                                    })
                                  }
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  id="onboarding_message"
                                  name="onboarding_message"
                                  type="text"
                                  label="Onboarding Message"
                                  value={this.state.onboardingMessage}
                                  onChange={(e) =>
                                    this.setState({
                                      onboardingMessage: e.target.value,
                                    })
                                  }
                                  variant="outlined"
                                  fullWidth
                                  multiline
                                  rows={3}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            id="dragHandleLeft"
                            className="dragula-container card card-bordered p-4 h-100 mt-3"
                          >
                            <h5 className="nk-block-title mb-4">
                              {" "}
                              <em className="icon ni ni-setting"></em>{" "}
                              Onboarding Steps
                            </h5>
                            {this.state.onboardingItems
                              .filter((item) => item.isLocked)
                              .map((item, index) => (
                                <div
                                  key={item.id}
                                  className="p-3 bg-white border border-light round-lg round-lg"
                                  style={{
                                    opacity: 0.8,
                                    marginBottom: "10px",
                                    cursor: "not-allowed",
                                    borderColor:
                                      this.state.onboardingItemsWithErrors.includes(
                                        item.id,
                                      )
                                        ? "#dc3545"
                                        : "#e3e6f0",
                                    borderWidth:
                                      this.state.onboardingItemsWithErrors.includes(
                                        item.id,
                                      )
                                        ? "2px"
                                        : "1px",
                                    transition: "all 0.2s ease",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 12,
                                      width: "100%",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "6px 10px",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <em className="far fa-heart"></em>
                                    </span>

                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <MutextField
                                        required
                                        id={`onboarding-${item.id}`}
                                        name={`onboarding-${item.id}`}
                                        type="text"
                                        disabled={true}
                                        label={item.title}
                                        value={item.title}
                                        className={
                                          (index === 0 && item.isFilled) ||
                                          (index === 1 &&
                                            this.isAgreementStepFilled())
                                            ? "onboarding-filled-field"
                                            : ""
                                        }
                                        onChange={(e) =>
                                          this.updateOnboardingItemTitle(
                                            item.id,
                                            e.target.value,
                                          )
                                        }
                                        inputProps={{
                                          maxLength: 100,
                                          style: {
                                            cursor: "not-allowed",
                                          },
                                        }}
                                        variant="outlined"
                                        fullWidth
                                        error={this.state.onboardingItemsWithErrors.includes(
                                          item.id,
                                        )}
                                        sx={{
                                          "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor:
                                                  this.state.onboardingItemsWithErrors.includes(
                                                    item.id,
                                                  )
                                                    ? "#dc3545 !important"
                                                    : (index === 0 &&
                                                          item.isFilled) ||
                                                        (index === 1 &&
                                                          this.isAgreementStepFilled())
                                                      ? "#0fca7a !important"
                                                      : "inherit",
                                              },
                                          },
                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor:
                                                this.state.onboardingItemsWithErrors.includes(
                                                  item.id,
                                                )
                                                  ? "#dc3545 !important"
                                                  : (index === 0 &&
                                                        item.isFilled) ||
                                                      (index === 1 &&
                                                        this.isAgreementStepFilled())
                                                    ? "#0fca7a !important"
                                                    : "#d0d0d0",
                                              borderWidth:
                                                this.state.onboardingItemsWithErrors.includes(
                                                  item.id,
                                                ) ||
                                                (index === 0 &&
                                                  item.isFilled) ||
                                                (index === 1 &&
                                                  this.isAgreementStepFilled())
                                                  ? "2px !important"
                                                  : "1px",
                                            },
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))}

                            {this.state.onboardingItems
                              .filter((item) => !item.isLocked)
                              .map((item) => {
                                const actualIndex =
                                  this.state.onboardingItems.findIndex(
                                    (i) => i.id === item.id,
                                  );
                                return (
                                  <div
                                    key={item.id}
                                    draggable={true}
                                    onDragStart={(e) =>
                                      this.handleDragStart(e, actualIndex)
                                    }
                                    onDragOver={(e) =>
                                      this.handleDragOver(e, actualIndex)
                                    }
                                    onDragLeave={this.handleDragLeave}
                                    onDrop={(e) =>
                                      this.handleDrop(e, actualIndex)
                                    }
                                    onDragEnd={this.handleDragEnd}
                                    className="p-3 bg-white border border-light round-lg round-lg dragula-handle"
                                    style={{
                                      opacity:
                                        this.state.draggedItem === actualIndex
                                          ? 0.5
                                          : 1,
                                      marginBottom: "10px",
                                      cursor: "grab",
                                      borderColor:
                                        this.state.onboardingItemsWithErrors.includes(
                                          item.id,
                                        )
                                          ? "#dc3545"
                                          : this.state.dragOverIndex ===
                                              actualIndex
                                            ? "#007bff"
                                            : "#e3e6f0",
                                      borderWidth:
                                        this.state.onboardingItemsWithErrors.includes(
                                          item.id,
                                        ) ||
                                        this.state.dragOverIndex === actualIndex
                                          ? "2px"
                                          : "1px",
                                      transition: "all 0.2s ease",
                                      backgroundColor:
                                        this.state.dragOverIndex === actualIndex
                                          ? "#e3f2fd"
                                          : "#fff",
                                      boxShadow:
                                        this.state.dragOverIndex === actualIndex
                                          ? "0 4px 12px rgba(0, 123, 255, 0.2)"
                                          : "0 1px 3px rgba(0, 0, 0, 0.05)",
                                      transform:
                                        this.state.draggedItem === actualIndex
                                          ? "scale(0.98)"
                                          : "scale(1)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 12,
                                        width: "100%",
                                      }}
                                    >
                                      <span
                                        className="dragHandle"
                                        style={{
                                          cursor: "grab",
                                          display: "inline-flex",
                                          // alignItems: "center",
                                          justifyContent: "center",
                                          padding: "6px 10px",
                                          borderRadius: "4px",
                                          userSelect: "none",
                                          fontSize: "16px",
                                          flexShrink: 0,
                                        }}
                                      >
                                        <em
                                          className="icon ni ni-swap"
                                          style={{ color: "#666" }}
                                        ></em>
                                      </span>

                                      <div
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 8,
                                        }}
                                      >
                                        <MutextField
                                          required
                                          id={`onboarding-${item.id}`}
                                          name={`onboarding-${item.id}`}
                                          type="text"
                                          disabled={false}
                                          label={item.title}
                                          value={item.title}
                                          className={
                                            item.isFilled
                                              ? "onboarding-filled-field"
                                              : ""
                                          }
                                          onChange={(e) =>
                                            this.updateOnboardingItemTitle(
                                              item.id,
                                              e.target.value,
                                            )
                                          }
                                          inputProps={{
                                            maxLength: 100,
                                            style: {
                                              cursor: "text",
                                            },
                                          }}
                                          variant="outlined"
                                          fullWidth
                                          error={this.state.onboardingItemsWithErrors.includes(
                                            item.id,
                                          )}
                                          sx={{
                                            "& .MuiOutlinedInput-root": {
                                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                {
                                                  borderColor:
                                                    this.state.onboardingItemsWithErrors.includes(
                                                      item.id,
                                                    )
                                                      ? "#dc3545 !important"
                                                      : item.isFilled
                                                        ? "#0fca7a !important"
                                                        : "inherit",
                                                },
                                            },
                                            "& .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor:
                                                  this.state.onboardingItemsWithErrors.includes(
                                                    item.id,
                                                  )
                                                    ? "#dc3545 !important"
                                                    : item.isFilled
                                                      ? "#0fca7a !important"
                                                      : "#d0d0d0",
                                                borderWidth:
                                                  this.state.onboardingItemsWithErrors.includes(
                                                    item.id,
                                                  ) || item.isFilled
                                                    ? "2px !important"
                                                    : "1px",
                                              },
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 8,
                                          flexShrink: 0,
                                        }}
                                      >
                                        <Tooltip
                                          title={
                                            item.isFilled
                                              ? "This step is completed and cannot be edited"
                                              : "Edit Onboarding Item"
                                          }
                                          placement="top"
                                        >
                                          <a
                                            onClick={() => {
                                              if (!item.isFilled) {
                                                this.editOnboarding(item.id);
                                              }
                                            }}
                                            style={{
                                              cursor: item.isFilled
                                                ? "not-allowed"
                                                : "pointer",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              opacity: item.isFilled ? 0.5 : 1,
                                            }}
                                          >
                                            <em
                                              className="icon ni ni-edit text-primary"
                                              style={{
                                                fontSize: 20,
                                              }}
                                            />
                                          </a>
                                        </Tooltip>

                                        <Tooltip
                                          title="Delete Onboarding Item"
                                          placement="top"
                                        >
                                          <a
                                            onClick={() =>
                                              this.deleteOnboarding(item.id)
                                            }
                                            style={{
                                              cursor: "pointer",
                                              borderLeft:
                                                "1px solid rgb(0 0 0 / 87%)",
                                              paddingLeft: 8,
                                            }}
                                          >
                                            <em
                                              className="icon ni ni-trash text-danger"
                                              style={{
                                                fontSize: 20,
                                              }}
                                            />
                                          </a>
                                        </Tooltip>
                                      </div>
                                    </div>
                                    <label
                                      style={{
                                        fontSize: 14,
                                        paddingTop: 8,
                                        paddingLeft: "45px",
                                      }}
                                    >
                                      Attached Form:{" "}
                                      {
                                        this.state.formsList.find(
                                          (f) => f.form_accountno === item.form,
                                        )?.form_title
                                      }
                                    </label>
                                  </div>
                                );
                              })}

                            <button
                              type="button"
                              style={{
                                cursor: "pointer",
                                color: "#fff",
                                marginTop: "15px",
                                paddingTop: "10px",
                                width: "170px",
                              }}
                              onClick={this.addNewOnboardingStep}
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              &nbsp; Add New Step
                            </button>
                          </div>{" "}
                          {this.state.onboarding_save_loading === false ? (
                            <button
                              type="button"
                              className="btn btn-lg btn-primary my-3 float-right"
                              style={{ marginRight: "15px" }}
                              onClick={this.saveOnboardingSettings}
                            >
                              <em className="icon ni ni-swap"></em> Save
                              Settings
                            </button>
                          ) : (
                            <button
                              className="btn btn-lg btn-primary my-3 float-right"
                              style={{ marginRight: "15px" }}
                              disabled
                            >
                              <em className="icon ni ni-save"></em> Save
                              Settings
                              <div
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </button>
                          )}
                        </div> */}
                        {/***** Onboarding Settings *****/}
                      </div>
                    </div>

                    {/* Edit Onboarding Modal */}
                    {/* <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalEditOnboarding"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-edit text-primary" />{" "}
                              <span>Update Onboarding Item</span>
                            </h5>
                          </div>
                          <div className="modal-body">
                            <div id="OnboardingEditDiv">
                              <div
                                className="col-12"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                }}
                              >
                                {this.state.questionErrorMessage !== "" ? (
                                  <div className="example-alert mb-4">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {this.state.questionErrorMessageTitle}
                                        </h4>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.state.questionErrorMessage,
                                          }}
                                        ></p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.questionSuccessMessage !== "" ? (
                                  <div className="example-alert mb-4">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {this.state.questionSuccessMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="row g-4">
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <Autocomplete
                                        options={this.getAvailableFormsForStep(
                                          this.state.editOnboardingId,
                                        ).map((form) => ({
                                          id: form.form_accountno,
                                          label: form.form_title,
                                          form: form,
                                        }))}
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        value={
                                          this.state.editOnboardingForm
                                            ? this.state.formsList.find(
                                                (f) =>
                                                  f.form_accountno ===
                                                  this.state.editOnboardingForm,
                                              )
                                              ? {
                                                  id: this.state
                                                    .editOnboardingForm,
                                                  label:
                                                    this.state.formsList.find(
                                                      (f) =>
                                                        f.form_accountno ===
                                                        this.state
                                                          .editOnboardingForm,
                                                    )?.form_title,
                                                  form: this.state.formsList.find(
                                                    (f) =>
                                                      f.form_accountno ===
                                                      this.state
                                                        .editOnboardingForm,
                                                  ),
                                                }
                                              : null
                                            : null
                                        }
                                        onChange={(e, newValue) => {
                                          // Only set form if a valid option is selected, otherwise clear it
                                          if (newValue && newValue.id) {
                                            const selectedFormId = newValue.id;
                                            const selectedForm =
                                              this.state.formsList.find(
                                                (form) =>
                                                  form.form_accountno ===
                                                  selectedFormId,
                                              );
                                            this.setState({
                                              editOnboardingForm:
                                                selectedFormId,
                                              editOnboardingAllowMultiple:
                                                selectedForm?.allow_multiple !==
                                                undefined
                                                  ? selectedForm.allow_multiple
                                                  : 0,
                                            });
                                          } else {
                                            // Clear the form if field is cleared or invalid value
                                            this.setState({
                                              editOnboardingForm: "",
                                              editOnboardingAllowMultiple: 0,
                                            });
                                          }
                                        }}
                                        disabled={this.state.formsLoading}
                                        clearOnBlur={false}
                                        clearOnEscape={false}
                                        noOptionsText="No Forms"
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Form"
                                            variant="outlined"
                                            fullWidth
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-3">
                                    <div className="form-group d-flex align-items-center">
                                      <div
                                        className="custom-control custom-checkbox"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="edit-allow-skip"
                                          checked={
                                            this.state.editOnboardingAllowSkip
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              editOnboardingAllowSkip:
                                                e.target.checked,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="edit-allow-skip"
                                          style={{
                                            fontWeight: "500",
                                            marginLeft: "8px",
                                            marginBottom: "0",
                                          }}
                                        >
                                          Allow Skip
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3">
                                    <div className="form-group d-flex align-items-center">
                                      <div
                                        className="custom-control custom-checkbox"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="edit-allow-Enable"
                                          checked={
                                            this.state
                                              .editOnboardingIsEnabled === 1
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              editOnboardingIsEnabled: e.target
                                                .checked
                                                ? 1
                                                : 0,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="edit-allow-Enable"
                                          style={{
                                            fontWeight: "500",
                                            marginLeft: "8px",
                                            marginBottom: "0",
                                          }}
                                        >
                                          Enable
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-6 d-flex align-items-center justify-content-end">
                                    <ul
                                      className="nk-block-tools g-3 mb-0"
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                      }}
                                    >
                                      {this.state.add_question_loader ===
                                      true ? (
                                        <li className="nk-block-tools-opt">
                                          <button
                                            className="btn btn-lg btn-primary"
                                            disabled
                                          >
                                            <em className="icon ni ni-swap"></em>{" "}
                                            Saving
                                            <div
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                            >
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          </button>
                                        </li>
                                      ) : (
                                        <>
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              onClick={() =>
                                                this.closeModal(
                                                  "modalEditOnboarding",
                                                )
                                              }
                                              className={`btn btn-primary btn-lg`}
                                            >
                                              <em className="icon ni ni-cross-round"></em>
                                              <span>Cancel</span>
                                            </a>
                                          </li>
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              onClick={() =>
                                                this.submitEditOnboarding()
                                              }
                                              className={`btn btn-primary btn-lg`}
                                            >
                                              <em className="icon ni ni-edit" />{" "}
                                              <span>Update Item</span>
                                            </a>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* End Edit Onboarding Modal */}

                    {/* Delete Onboarding Modal */}
                    {/* <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalDeleteAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                              <h4 className="nk-modal-title">
                                Delete Onboarding Item?
                              </h4>

                              <div className="nk-modal-text">
                                {this.state.onboardingErrorMessageDelete !==
                                "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>
                                          {
                                            this.state
                                              .onboardingErrorMessageDelete
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.onboardingSuccessMessageDelete !==
                                "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success m-4">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {
                                            this.state
                                              .onboardingSuccessMessageDelete
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="caption-text">
                                  Are you sure you want to delete this
                                  onboarding item?
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-primary"
                                  onClick={() => {
                                    this.modalHideDel();
                                  }}
                                  disabled={this.state.isProcessing}
                                >
                                  CANCEL
                                </a>
                                {"  "}
                                {this.state.isProcessing ? (
                                  <button
                                    className="btn btn-lg btn-mw btn-danger"
                                    disabled
                                  >
                                    <em className="icon ni ni-trash"></em>
                                    <span>DELETING</span>
                                    <div
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                ) : (
                                  <button
                                    style={{ cursor: "pointer" }}
                                    className="btn btn-lg btn-mw btn-danger"
                                    onClick={() => {
                                      this.deleteOnboardingItem();
                                    }}
                                    disabled={
                                      this.state.disabled ||
                                      this.state.isProcessing
                                    }
                                  >
                                    <span>DELETE</span>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* End Delete Onboarding Modal */}

                    {/* Add Onboarding Modal */}
                    {/* <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAddOnboarding"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-plus text-primary" />{" "}
                              <span>Add Onboarding Item</span>
                            </h5>
                          </div>
                          <div className="modal-body">
                            <div id="OnboardingEditDiv">
                              <div
                                className="col-12"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                }}
                              >
                                {this.state.questionErrorMessage !== "" ? (
                                  <div className="example-alert mb-4">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>
                                          {this.state.questionErrorMessageTitle}
                                        </h4>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              this.state.questionErrorMessage,
                                          }}
                                        ></p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.questionSuccessMessage !== "" ? (
                                  <div className="example-alert mb-4">
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {this.state.questionSuccessMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="row g-4">
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <MutextField
                                        id="add-onboarding-title"
                                        name="add-onboarding-title"
                                        label="Onboarding Item Title"
                                        value={this.state.editOnboardingTitle}
                                        onChange={(e) =>
                                          this.setState({
                                            editOnboardingTitle: e.target.value,
                                          })
                                        }
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Enter onboarding item title"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <Autocomplete
                                        options={this.getAvailableFormsForStep(
                                          this.state.editOnboardingId,
                                        ).map((form) => ({
                                          id: form.form_accountno,
                                          label: form.form_title,
                                          form: form,
                                        }))}
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        value={
                                          this.state.editOnboardingForm
                                            ? this.state.formsList.find(
                                                (f) =>
                                                  f.form_accountno ===
                                                  this.state.editOnboardingForm,
                                              )
                                              ? {
                                                  id: this.state
                                                    .editOnboardingForm,
                                                  label:
                                                    this.state.formsList.find(
                                                      (f) =>
                                                        f.form_accountno ===
                                                        this.state
                                                          .editOnboardingForm,
                                                    )?.form_title,
                                                  form: this.state.formsList.find(
                                                    (f) =>
                                                      f.form_accountno ===
                                                      this.state
                                                        .editOnboardingForm,
                                                  ),
                                                }
                                              : null
                                            : null
                                        }
                                        onChange={(e, newValue) => {
                                          // Only set form if a valid option is selected, otherwise clear it
                                          if (newValue && newValue.id) {
                                            const selectedFormId = newValue.id;
                                            const selectedForm =
                                              this.state.formsList.find(
                                                (form) =>
                                                  form.form_accountno ===
                                                  selectedFormId,
                                              );
                                            this.setState({
                                              editOnboardingForm:
                                                selectedFormId,
                                              editOnboardingAllowMultiple:
                                                selectedForm?.allow_multiple !==
                                                undefined
                                                  ? selectedForm.allow_multiple
                                                  : 0,
                                            });
                                          } else {
                                            // Clear the form if field is cleared or invalid value
                                            this.setState({
                                              editOnboardingForm: "",
                                              editOnboardingAllowMultiple: 0,
                                            });
                                          }
                                        }}
                                        disabled={this.state.formsLoading}
                                        clearOnBlur={false}
                                        clearOnEscape={false}
                                        noOptionsText="No Forms"
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Form"
                                            variant="outlined"
                                            fullWidth
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-3">
                                    <div className="form-group d-flex align-items-center">
                                      <div
                                        className="custom-control custom-checkbox"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="add-allow-skip"
                                          checked={
                                            this.state.editOnboardingAllowSkip
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              editOnboardingAllowSkip:
                                                e.target.checked,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="add-allow-skip"
                                          style={{
                                            fontWeight: "500",
                                            marginLeft: "8px",
                                            marginBottom: "0",
                                          }}
                                        >
                                          Allow Skip
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-3">
                                    <div className="form-group d-flex align-items-center">
                                      <div
                                        className="custom-control custom-checkbox"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="add-allow-Enable"
                                          checked={
                                            this.state
                                              .editOnboardingIsEnabled === 1
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              editOnboardingIsEnabled: e.target
                                                .checked
                                                ? 1
                                                : 0,
                                            })
                                          }
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="add-allow-Enable"
                                          style={{
                                            fontWeight: "500",
                                            marginLeft: "8px",
                                            marginBottom: "0",
                                          }}
                                        >
                                          Enable
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-lg-6 d-flex align-items-center justify-content-end">
                                    <ul
                                      className="nk-block-tools g-3 mb-0"
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                      }}
                                    >
                                      {this.state.add_question_loader ===
                                      true ? (
                                        <li className="nk-block-tools-opt">
                                          <button
                                            className="btn btn-lg btn-primary"
                                            disabled
                                          >
                                            <em className="icon ni ni-swap"></em>{" "}
                                            Saving
                                            <div
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                            >
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          </button>
                                        </li>
                                      ) : (
                                        <>
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              onClick={() =>
                                                this.closeModal(
                                                  "modalAddOnboarding",
                                                )
                                              }
                                              className={`btn btn-primary btn-lg`}
                                            >
                                              <em className="icon ni ni-cross-round"></em>
                                              <span>Cancel</span>
                                            </a>
                                          </li>
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              onClick={() =>
                                                this.submitEditOnboarding()
                                              }
                                              className={`btn btn-primary btn-lg`}
                                            >
                                              <em className="icon ni ni-plus" />{" "}
                                              <span>Add Item</span>
                                            </a>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* End Add Onboarding Modal */}

                    <div
                      className="card-aside card-aside-right user-aside"
                      data-content="userAside"
                      data-toggle-screen="xxl"
                      data-toggle-overlay="true"
                      data-toggle-body="true"
                    >
                      <div className="card-inner-group" data-simplebar>
                        <div
                          className="card-inner"
                          style={{ borderBottom: "1px solid #dbdfea" }}
                        >
                          <div className="user-card user-card-s2">
                            <div className="user-avatar lg bg-primary">
                              <span>{this.state.client_name_initials}</span>
                            </div>
                            <div className="user-info">
                              {this.state.client_status &&
                              this.state.client_status === "Yes" ? (
                                <div className="badge badge-outline-success badge-pill ucap">
                                  Verified
                                </div>
                              ) : (
                                <div className="badge badge-outline-danger badge-pill ucap">
                                  Not Verified
                                </div>
                              )}
                              <h5>{this.state.client_update_name}</h5>
                              <span className="sub-text">
                                {this.state.client_update_email}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #dbdfea",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          gap: "10px",
                          fontSize: "20px",
                        }}
                      >
                        <div
                          style={{
                            margin: "7px 0px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <a
                            style={{ cursor: this.state.notifyLoginLoading || this.state.notifyLoginSuccess || this.state.notifyLoginError ? "default" : "pointer", fontSize: "12px", fontWeight: "bold" }}
                            className={
                              this.state.notifyLoginSuccess
                                ? "text-success"
                                : this.state.notifyLoginError
                                ? "text-danger"
                                : "text-primary"
                            }
                            onClick={!this.state.notifyLoginLoading && !this.state.notifyLoginSuccess && !this.state.notifyLoginError ? this.notifyAgentLoginByEmail : undefined}
                          >
                            {this.state.notifyLoginLoading ? (
                              <>
                                <em className="icon ni ni-loader" /> Loading...
                              </>
                            ) : (
                              <>
                                <em className="icon ni ni-mail" /> Notify {localization.specificPortals.agentLabel}
                              </>
                            )}
                          </a>
                        </div> 
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #dbdfea",
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "stretch",
                          gap: "10px",
                          fontSize: "20px",
                        }}
                      >
                        {/* Left: Edit Partner */}
                        {this.state.permissionsState &&
                        this.state.permissionsState.length > 0 &&
                        this.state.permission_edit_partner === 1 ? (
                          <div
                            style={{
                              margin: "5px 0px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <a
                              className="text-primary"
                              onClick={() => this.editAgentForm()}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <em
                                className="icon ni ni-edit"
                                style={{ fontSize: "14px" }}
                              />
                              <span
                                style={{ fontSize: "12px", marginLeft: "5px" }}
                              >
                                Edit {localization.specificPortals.agentLabel}
                              </span>
                            </a>
                          </div>
                        ) : null}

                        {/* Divider: only show if left AND right exist */}
                        {this.state.permission_edit_partner === 1 &&
                        (this.state.client_status === "No" ||
                          (this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_view_partner_sso === 1)) ? (
                          <div
                            style={{
                              borderLeft: "1px solid #dbdfea",
                              height: "36px",
                              margin: "0 3px",
                            }}
                          />
                        ) : null}

                        {/* Right: Resend Activation or Dashboard */}
                        {this.state.client_status === "No" ? (
                          <div
                            style={{
                              margin: "5px 0px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <a
                              className="text-primary"
                              onClick={() => this.resendActivationAgent()}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                fontWeight: "bold",
                              }}
                            >
                              <em
                                className="icon ni ni-send"
                                style={{ fontSize: "14px" }}
                              />
                              <span
                                style={{ fontSize: "12px", marginLeft: "5px" }}
                              >
                                Resend Activation
                              </span>
                            </a>
                          </div>
                        ) : (
                          <>
                            {this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_view_partner_sso === 1 ? (
                              <div
                                style={{
                                  margin: "5px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <a
                                  className="text-primary"
                                  onClick={() => this.agentLogin()}
                                  title="Dashboard"
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <em
                                    className="icon ni ni-signin"
                                    style={{ fontSize: "14px" }}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    Dashboard
                                  </span>
                                </a>
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>

                      <div className="card-inner">
                        <a
                          className="overline-title-alt"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            this.changeActiveTab("agreements");
                            this.agentAgreements();
                            this.reloadAgentInfo();
                          }}
                        >
                          Agreements
                        </a>
                        <div className="row text-center">
                          <div className="col-4">
                            <div
                              className="profile-stats"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                this.changeActiveTab("agreements");
                                this.agentAgreements();
                                this.reloadAgentInfo();
                              }}
                            >
                              <span className="amount">
                                {this.state.totalClientAgreements}
                              </span>
                              <span className="sub-text">Total</span>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              className="profile-stats"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                this.changeActiveTab("agreements");
                                this.agentAgreements();
                                this.reloadAgentInfo();
                              }}
                            >
                              <span className="amount">
                                {this.state.signedClientAgreements}
                              </span>
                              <span className="sub-text">Signed</span>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              className="profile-stats"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                this.changeActiveTab("agreements");
                                this.agentAgreements();
                                this.reloadAgentInfo();
                              }}
                            >
                              <span className="amount">
                                {this.state.unsignedClientAgreements}
                              </span>
                              <span className="sub-text">Unsigned</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr
                        style={{
                          borderTop: "1px solid #dbdfea",
                          margin: "0",
                        }}
                      />
                      {/* <div className="card-inner">
                        <a
                          className="overline-title-alt"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            this.changeActiveTab("onboarding_settings");
                            this.getOnboardingItems();
                          }}
                        >
                          Onboarding Progress
                        </a>
                        <div
                          className="progress progress-lg"
                          style={{ marginTop: "10px" }}
                        >
                          <div
                            className="progress-bar"
                            data-progress={this.getOnboardingPercentage()}
                            style={{
                              width: `${this.getOnboardingPercentage()}%`,
                              backgroundColor:
                                this.getOnboardingPercentage() === 100
                                  ? "#00b894"
                                  : "",
                            }}
                          >
                            {this.getOnboardingPercentage()}%
                          </div>
                        </div>
                      </div> */}
                      <hr
                        style={{
                          borderTop: "1px solid #dbdfea",
                          margin: "0",
                        }}
                      />
                      <div className="card-inner">
                        <>
                          {this.state.permissionsState &&
                          this.state.permissionsState.length > 0 &&
                          this.state.permission_forogt_password_link === 1 ? (
                            <a
                              className="overline-title-alt text-primary"
                              onClick={() => this.modalOpenForgotPasswordLink()}
                              style={{ cursor: "pointer", clear: "both" }}
                            >
                              <em className="icon ni ni-link"></em> Forgot
                              Password Link
                            </a>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <span className="text-muted">---</span>
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                    {/* Remove Contract */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalRemoveContract"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideRemove();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                              <h4 className="nk-modal-title">
                                Remove agreement?
                              </h4>
                              <div className="nk-modal-text">
                                {this.state.removeErrorMessage !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.removeErrorMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.removeSuccessMessage !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.removeSuccessMessage}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="caption-text">
                                  Are you sure you want to delete this
                                  agreement?
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                {this.state.remove_agreement_button === true ? (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Loading... </span>
                                  </button>
                                ) : (
                                  <>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.modalHideRemove();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      CANCEL
                                    </a>
                                    {"  "}
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-danger"
                                      onClick={() => {
                                        this.remove_agreement();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      REMOVE
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Remove Contract */}
                    {/* View Archived Details */}
                    <div
                      className="modal fade zoom"
                      tabIndex="-1"
                      id="modalArchivedDetails"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-list-round"></em>{" "}
                                Agreement Details <sup></sup>
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body">
                            {/* NRC DIVS START */}

                            {this.state.viewLoader === true ? (
                              FormLoader()
                            ) : (
                              <>
                                {this.state.errorMessageArchivedDetails !==
                                "" ? (
                                  <div className="example-alert example-alert-revoke">
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>
                                          {
                                            this.state
                                              .errorMessageArchivedDetails
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div>
                                  <div className="card card-bordered">
                                    <div className="card-inner-group">
                                      {this.state.archivedAgreementsDetails &&
                                      this.state.archivedAgreementsDetails
                                        .length > 0 ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Agreement Details
                                            </h6>
                                          </div>
                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <table className="table table-bordered table-striped">
                                              {this.state.archivedAgreementsDetails.map(
                                                (general, index) => (
                                                  <tbody
                                                    key={index}
                                                    className="text-dark"
                                                  >
                                                    <tr>
                                                      <td>Agreement Name</td>
                                                      <td>
                                                        {
                                                          general.agreement_title
                                                        }
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Archived Date</td>
                                                      <td>
                                                        {this.format_date(
                                                          general.archived_date,
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Approved Date</td>
                                                      <td>
                                                        {this.format_date(
                                                          general.approved_date,
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Document Uploaded</td>
                                                      <td>
                                                        {general.is_uploaded &&
                                                        general.is_uploaded ===
                                                          "Yes"
                                                          ? "Document Uploaded"
                                                          : "---"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Signee name</td>
                                                      <td>
                                                        {general.signee_name}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Signee Email</td>
                                                      <td>
                                                        {general.signee_email &&
                                                        general.signee_email !==
                                                          ""
                                                          ? general.signee_email
                                                          : "---"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Signee Title</td>
                                                      <td>
                                                        {general.signee_title &&
                                                        general.signee_title !==
                                                          ""
                                                          ? general.signee_title
                                                          : "---"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Reason</td>
                                                      <td>
                                                        {general.revoke_reason}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                ),
                                              )}
                                            </table>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* View Archived Details */}
                    {/* MODAL REASSIGN AGREEMENT */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalReassignAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideReassign();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-repeat bg-success"></em>
                              <h4 className="nk-modal-title">
                                Reassign the agreement?
                              </h4>
                              <div className="nk-modal-text">
                                {this.state.errorMessageReassign !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessageReassign}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.successMessageReassign !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {this.state.successMessageReassign}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="caption-text">
                                  Reassigning this archived agreement will
                                  replace the existing one if it's already
                                  assigned to the{" "}
                                  {localization.specificPortals.agentText}.
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                {this.state.disabled === true ? (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Loading... </span>
                                  </button>
                                ) : (
                                  <>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.modalHideReassign();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      CANCEL
                                    </a>
                                    {"  "}
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-success"
                                      onClick={() => {
                                        this.reassign_archived_agreement();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      Submit
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MODAL REASSIGN AGREEMENT */}
                    {/** Login Modal Start **/}
                    {this.state.showLoginModal && (
                      <div
                        className="modal fade show"
                        tabIndex="-1"
                        id="modalDefaultLogin"
                        style={{ display: "block" }}
                        role="dialog"
                      >
                        <div
                          className="modal-dialog modal-dialog-top modal-xl"
                          role="document"
                        >
                          <div className="modal-content">
                            <a
                              onClick={() => this.closeLoginModal()}
                              className="close"
                              style={{ cursor: "pointer" }}
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                            <div className="modal-header">
                              <h5 className="modal-title">
                                <em
                                  className="icon ni ni-user-list"
                                  style={{ marginRight: "15px" }}
                                ></em>{" "}
                                {`Login to the ${localization.specificPortals.agentLabel}`}
                              </h5>
                            </div>
                            <div className="modal-body">
                              {this.state.loginErrorMessage === "" ? (
                                <div className="alert alert-pro alert-primary">
                                  <div className="alert-text">
                                    <h6>Connecting.....</h6>
                                    <p>
                                      Please wait while we are connecting to the{" "}
                                      {localization.specificPortals.agentText}{" "}
                                      login. You will be redirected to the{" "}
                                      {localization.specificPortals.agentLabel}{" "}
                                      dashboard after the authentication.
                                    </p>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.loginErrorMessage !== "" ? (
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>Login Error</h6>
                                    <p>{this.state.loginErrorMessage}</p>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.showLoginModal && (
                      <div className="modal-backdrop fade show"></div>
                    )}
                    {/** Login Modal End **/}
                    {/* DETAIL MODAL End */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalFormDetail"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              Edit {localization.specificPortals.agentLabel}
                            </h5>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body">
                            {/* Error Start */}
                            {this.state.errorMessageEdit !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "20px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.errorMessageEdit,
                                      }}
                                    ></p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageEdit !== "" ? (
                              <div
                                className="example-alert"
                                style={{ marginBottom: "20px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.successMessageEdit}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.showEmailWarning === true ? (
                              <div className="alert alert-pro alert-warning">
                                <div className="alert-text">
                                  <h6>Confirm Email Update</h6>
                                  <p>
                                    Are you sure you want to update the email?
                                  </p>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      gap: "10px",
                                    }}
                                  >
                                    <button
                                      className="btn btn-danger"
                                      onClick={this.handleEmailWarningNo}
                                      type="button"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={this.handleEmailWarningYes}
                                    >
                                      Yes, Proceed
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <br />
                            <div className="row g-4">
                              <form method="post" autoComplete="off" role="presentation" encType="multipart/form-data">
                                <div className="row g-4">
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Company Name"
                                        error={this.state.errorAgentCompany === "error"}
                                        id="agent_company"
                                        name="agent_company"
                                        value={this.state.agent_company}
                                        placeholder="Company Name"
                                        onChange={this.handleChange}
                                        type="text"
                                        inputProps={{ maxLength: 100 }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Full Name"
                                        error={this.state.errorName === "error"}
                                        id="name"
                                        name="name"
                                        value={this.state.name}
                                        placeholder="Full Name"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 100 }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Title"
                                        id="title"
                                        name="title"
                                        value={this.state.title}
                                        placeholder="Title"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 30 }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  {this.state.role_field_enabled ? (
                                    <div className="col-lg-4">
                                      <div className="form-group">
                                        <MutextField
                                          label="Role"
                                          id="agent_role"
                                          name="agent_role"
                                          value={this.state.agent_role}
                                          placeholder="Role"
                                          onChange={this.handleChange}
                                          inputProps={{ maxLength: 30 }}
                                          variant="outlined"
                                          fullWidth
                                          helperText="Enter the role."
                                          autoComplete="new-password"
                                        />
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Email"
                                        type="text"
                                        error={this.state.errorAgentEmail === "error"}
                                        id="agent_email"
                                        name="agent_email"
                                        value={this.state.agent_email}
                                        placeholder="Enter email address"
                                        onChange={this.handleChange}
                                        autoComplete="off"
                                        variant="outlined"
                                        fullWidth
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <ReactPhoneInput
                                        country="us"
                                        value={(this.state.agent_phone || "").replace(/^\+/, "")}
                                        onChange={(value) =>
                                          this.handleChange({
                                            target: {
                                              name: "agent_phone",
                                              value: value ? `+${value}` : "",
                                            },
                                          })
                                        }
                                        inputProps={{
                                          name: "agent_phone",
                                          id: "agent_phone",
                                          maxLength: 20,
                                          required: true,
                                        }}
                                        specialLabel="Phone Number *"
                                        containerStyle={{ width: "100%", marginTop: "2px" }}
                                        inputStyle={{
                                          width: "100%",
                                          height: "56px",
                                          borderColor:
                                            this.state.errorAgentPhone === "error" ? "red" : "",
                                        }}
                                        buttonStyle={{
                                          borderColor:
                                            this.state.errorAgentPhone === "error" ? "red" : "",
                                        }}
                                        isValid={this.state.errorAgentPhone !== "error"}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <MutextField
                                        id="agent_status"
                                        name="agent_status"
                                        select
                                        label="Account Status"
                                        value={this.state.agent_status}
                                        onChange={this.handleChange}
                                        SelectProps={{
                                          native: true,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option key="status1" value="1">
                                          Active
                                        </option>
                                        <option key="status0" value="0">
                                          Inactive
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="nk-block-between-md g-4">
                                      {this.state.address_autocomplete ===
                                        "Yes" && (
                                        <div className="nk-block-head-content">
                                          <ul className="nk-block-tools gx-3">
                                            <li>
                                              <a
                                                onClick={this.handleToggle}
                                                className="text-primary fs-11"
                                                style={{
                                                  cursor: "pointer",
                                                  fontSize: "11px",
                                                }}
                                              >
                                                {toggleButtonText}
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                    <div className="form-group">
                                      {this.state.address_autocomplete ===
                                      "Yes" ? (
                                        useGooglePlaces ? (
                                          <GooglePlacesAutocomplete
                                            apiKey={
                                              process.env
                                                .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                            }
                                            apiOptions={{ loading: 'async' }}
                                            selectProps={{
                                              value: this.state.agent_address
                                                ? {
                                                    label:
                                                      this.state.agent_address,
                                                    value:
                                                      this.state.agent_address,
                                                  }
                                                : null,
                                              onChange:
                                                this.handleAddressSelect,
                                              placeholder: this.state
                                                .agent_address
                                                ? null
                                                : "Enter your address..",
                                              styles: {
                                                input: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                  height: "43px",
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                singleValue: (provided) => ({
                                                  ...provided,
                                                  color: "black",
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9,
                                                }),
                                              },
                                            }}
                                            className="googleLocation-autocomplete"
                                          />
                                        ) : (
                                          <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            id="agent_address"
                                            name="agent_address"
                                            value={this.state.agent_address}
                                            onChange={this.handleChange}
                                            placeholder="PO Box Address"
                                            //maxLength={50}
                                            maxLength={100}
                                            autoComplete="new-password" />
                                        )
                                      ) : (
                                        // address_autocomplete === "No" → show PO Box only
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="agent_address"
                                          name="agent_address"
                                          value={this.state.agent_address}
                                          onChange={this.handleChange}
                                          placeholder="Enter address here"
                                        autoComplete="new-password" />
                                      )}
                                      {/*  */}
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group" style={{ marginTop: "18px" }}>
                                      <MutextField
                                        label="Apartment, Suite, Etc."
                                        type="text"
                                        id="agent_address2"
                                        name="agent_address2"
                                        value={this.state.agent_address2}
                                        placeholder=""
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 100 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-group" style={{ marginTop: "18px" }}>
                                      <MutextField
                                        id="agent_isVerified"
                                        name="agent_isVerified"
                                        select
                                        label="Verify Account"
                                        value={this.state.agent_isVerified}
                                        onChange={this.handleChange}
                                        SelectProps={{
                                          native: true,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      >
                                        <option key="status1" value="Yes">
                                          Yes
                                        </option>
                                        <option key="status0" value="No">
                                          No
                                        </option>
                                      </MutextField>
                                    </div>
                                  </div>

                                  <div className="col-lg-2">
                                    <div className="form-group">
                                      <MutextField
                                        label="City"
                                        type="text"
                                        error={this.state.errorAgentCity === "error"}
                                        id="agent_city"
                                        name="agent_city"
                                        value={this.state.agent_city}
                                        placeholder="Enter city"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 32 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-2">
                                    <div className="form-group">
                                      <MutextField
                                        label="State"
                                        type="text"
                                        error={this.state.errorAgentState === "error"}
                                        id="agent_state"
                                        name="agent_state"
                                        value={this.state.agent_state}
                                        placeholder="Enter state"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 32 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Zip Code"
                                        type="text"
                                        error={this.state.errorAgentZip === "error"}
                                        id="agent_zip"
                                        name="agent_zip"
                                        value={this.state.agent_zip}
                                        placeholder="Enter zip code"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 9 }}
                                        variant="outlined"
                                        fullWidth
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-lg-4">
                                    <div className="form-group">
                                      <Autocomplete
                                        id="agent_country"
                                        options={this.countryOptions}
                                        getOptionLabel={(option) => option.label}
                                        value={
                                          this.state.agent_country
                                            ? this.countryOptions.find(opt => opt.label === this.state.agent_country)
                                            : null
                                        }
                                        onChange={(event, newValue) =>
                                          this.handleChangeCountry(newValue)
                                        }
                                        renderInput={(params) => (
                                          <MutextField
                                            {...params}
                                            label="Country"
                                            variant="outlined"
                                            fullWidth
                                            error={this.state.errorAgentCountry === "error"}
                                          autoComplete="new-password"
                                          />
                                        )}
                                      />
                                    </div>
                                  </div>
                                  {/* Keep Password & Confirm Password side by side regardless of the
                                      optional Role field shifting the grid. */}
                                  <div className="w-100"></div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Password"
                                        type={
                                          this.state.passwordShown
                                            ? "text"
                                            : "password"
                                        }
                                        error={this.state.errorClientPass === "error"}
                                        id="agent_password"
                                        name="agent_password"
                                        value={this.state.agent_password}
                                        placeholder="Enter password"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 30 }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                                      autoComplete="new-password"
                                      />
                                      <a
                                        style={{
                                          left: "auto",
                                          top: "30px",
                                          position: "absolute",
                                          cursor: "pointer",
                                        }}
                                        tabIndex="-1"
                                        onClick={this.togglePassword}
                                        className="form-icon form-icon-right passcode-switch"
                                        data-target="password"
                                      >
                                        {this.state.passwordShown ? (
                                          <em className="icon ni ni-eye-off"></em>
                                        ) : (
                                          <em className="icon ni ni-eye"></em>
                                        )}
                                      </a>
                                      <PasswordStrengthBar
                                        password={this.state.agent_password}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <MutextField
                                        label="Confirm Password"
                                        type={
                                          this.state.confirmPasswordShown
                                            ? "text"
                                            : "password"
                                        }
                                        error={this.state.errorClientPass === "error"}
                                        id="c_password"
                                        name="c_password"
                                        value={this.state.c_password}
                                        placeholder="Enter confirm password"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 30 }}
                                        variant="outlined"
                                        fullWidth
                                        helperText="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                                      autoComplete="new-password"
                                      />
                                      <a
                                        style={{
                                          left: "auto",
                                          top: "30px",
                                          position: "absolute",
                                          cursor: "pointer",
                                        }}
                                        tabIndex="-1"
                                        onClick={() => {
                                          this.toggleConfirmPassword();
                                        }}
                                        className="form-icon form-icon-right passcode-switch"
                                        data-target="password"
                                      >
                                        {this.state.confirmPasswordShown ? (
                                          <em className="icon ni ni-eye-off"></em>
                                        ) : (
                                          <em className="icon ni ni-eye"></em>
                                        )}
                                      </a>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <MutextField
                                        label={`${localization.specificPortals.sharelinkLabel} Limit`}
                                        type="text"
                                        error={
                                          this.state.errorAgentSharelink ===
                                          "error"
                                        }
                                        id="sharelink_limit"
                                        name="sharelink_limit"
                                        value={this.state.sharelink_limit}
                                        placeholder="Enter zip code"
                                        onChange={this.handleChange}
                                        inputProps={{ maxLength: 2 }}
                                        variant="outlined"
                                        fullWidth
                                        onKeyPress={() => {
                                          this.checkNumber();
                                        }}
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group col-md-4">
                                    <div
                                      className="custom-control custom-control-lg custom-checkbox"
                                      style={{ padding: 0, marginLeft: "3rem" }}
                                    >
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck2"
                                        onChange={() => {
                                          const isChecked =
                                            !this.state.notifyCheckBox;
                                          this.setState({
                                            notifyCheckBox: isChecked,
                                          });
                                          // console.log(
                                          //   "Notify Checkbox Checked:",
                                          //   isChecked
                                          // );
                                        }}
                                      />

                                      <label
                                        className="custom-control-label"
                                        htmlFor="customCheck2"
                                      >
                                        {`Notify ${localization.specificPortals.agentLabel}`}
                                      </label>
                                    </div>
                                  </div>
                                  <div
                                    className="col-lg-12 no-padding-margin-preview"
                                    style={{
                                      padding: 0,
                                      cursor: "pointer",
                                      color: "#0066cc",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.preViewDefault();
                                    }}
                                  >
                                    <span>Preview Notification Email </span>
                                  </div>
                                  <div style={{ clear: "both" }}></div>
                                  <hr />
                                  <div className="form-group text-right col-md-12">
                                    <button
                                      className="btn btn-lg btn-primary"
                                      type="button"
                                      disabled={this.state.disabled}
                                      onClick={this.formUpdateSubmit}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>

                            {/* </form> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* DETAIL MODAL START */}
                    {/* RESEND ACTIVATION MODAL START */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAlertResend"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a href="#" className="close" data-dismiss="modal">
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              {this.state.activation_button === true ? (
                                <>
                                  <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-warning"></em>
                                  <h4 className="nk-modal-title">Sending!</h4>
                                  <div className="nk-modal-text">
                                    <div className="caption-text">
                                      Please wait while we are processing your
                                      request
                                    </div>
                                    <span className="sub-text-sm"></span>
                                  </div>
                                  <div className="nk-modal-action"></div>
                                </>
                              ) : null}
                              {this.state.activation_tick === true ? (
                                <>
                                  <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                                  <h4 className="nk-modal-title">
                                    Congratulations!
                                  </h4>
                                  <div className="nk-modal-text">
                                    <div className="caption-text">
                                      Activation email has been sent
                                      successfully.
                                    </div>
                                    <span className="sub-text-sm"></span>
                                  </div>
                                  <div className="nk-modal-action"></div>
                                </>
                              ) : null}
                              {this.state.activation_cross === true ? (
                                <>
                                  <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                  <h4 className="nk-modal-title">Oops!</h4>
                                  <div className="nk-modal-text">
                                    <div className="caption-text">
                                      There is some error while sending
                                      activation email. Please try again later
                                    </div>
                                    <span className="sub-text-sm"></span>
                                  </div>
                                  <div className="nk-modal-action"></div>
                                </>
                              ) : null}
                            </div>
                          </div>
                          <div className="modal-footer bg-lighter">
                            <div className="text-center w-100">
                              <a
                                href="#"
                                className="btn btn-lg btn-mw btn-primary"
                                data-dismiss="modal"
                              >
                                Close
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* RESEND ACTIVATION MODAL END */}
                    {/* DELETE ARCHIVE */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalDeleteAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                              <h4 className="nk-modal-title">
                                Delete archived agreement?
                              </h4>
                              <div className="nk-modal-text">
                                {this.state.errorMessageDelete !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessageDelete}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.successMessageDelete !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>{this.state.successMessageDelete}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="caption-text">
                                  Are you sure you want to delete this archived
                                  agreement?
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-primary"
                                  onClick={() => {
                                    this.modalHideDel();
                                  }}
                                  disabled={this.state.disabled}
                                >
                                  CANCEL
                                </a>
                                {"  "}
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-danger"
                                  onClick={() => {
                                    this.delete_archived_agreement();
                                  }}
                                  disabled={this.state.disabled}
                                >
                                  DELETE
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* DELETE ARCHIVE */}
                    {/**** Open Contract Modal ***/}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalOpenUploadContract"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">Upload Agreement</h5>
                          </div>
                          <div className="modal-body">
                            <div className="row g-gs">
                              <div className="col-md-12 mb-3">
                                {this.state.uploadErrorMessage !== "" ? (
                                  <div className="alert alert-pro alert-danger mb-2">
                                    <div className="alert-text">
                                      <h6>Error</h6>
                                      <p>{this.state.uploadErrorMessage} </p>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.uploadSuccessMessage !== "" ? (
                                  <div className="alert alert-pro alert-success mb-2">
                                    <div className="alert-text">
                                      <h6>Success</h6>
                                      <p>{this.state.uploadSuccessMessage} </p>
                                    </div>
                                  </div>
                                ) : null}

                                <div
                                  className="col-md-12 mb-2"
                                  style={{
                                    marginBottom: "20px",
                                    clear: "both",
                                  }}
                                >
                                  <div className="form-group">
                                    <div className="form-label-group">
                                      <label className="form-label">
                                        <Tooltip
                                          title="Upload agreement directly."
                                          placement="right"
                                        >
                                          <em
                                            className="icon ni ni-info"
                                            style={{
                                              color: "#6576ff",
                                            }}
                                          ></em>
                                        </Tooltip>{" "}
                                        Upload Agreement <sup>*</sup>
                                        <span className="text-danger"></span>
                                      </label>
                                    </div>
                                    <div className="form-control-group signatory_upload mb-4">
                                      <div className="custom-file">
                                        <input
                                          type="file"
                                          className="custom-file-input"
                                          id="add_picture"
                                          name="add_picture"
                                          defaultValue={this.state.add_picture}
                                          accept=".png, .jpg, .jpeg, .doc, .docx, .pdf, .txt, .rtf, .zip"
                                          onChange={this.handleFileChange}
                                        autoComplete="new-password" />
                                        <label
                                          className="custom-file-label"
                                          htmlFor="add_picture"
                                        >
                                          Choose file
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-note">
                                      {this.state.add_picture_name}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 mt-5">
                                  <div className="example-alert">
                                    <div className="alert alert-light">
                                      <ul className="list">
                                        <li>
                                          Accepted Formats: PDF, DOC, DOCX, ZIP,
                                          TXT, RTF, PNG, JPEG, JPG
                                        </li>
                                        <li>Recommended Size: 10MB</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="modal-footer"
                            style={{ justifyContent: "right" }}
                          >
                            <div className="d-flex justify-content-end">
                              {this.state.upload_agreement_button === true ? (
                                <button
                                  className="btn btn-lg btn-primary"
                                  disabled
                                >
                                  <em className="icon ni ni-swap"></em> Saving
                                  <div
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  onClick={() => this.submitClientContract()}
                                >
                                  Save Agreement
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**** Open Contract Modal ***/}
                    {/**** Open Signee Details Modal ***/}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalOpenSignee"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">Signee Details</h5>
                          </div>
                          <div className="modal-body">
                            <div className="g-4">
                              <div id="no-more-tables-new">
                                <table className="table table-bordered">
                                  <thead className="thead-light">
                                    <tr>
                                      <th className="tb-col-os">
                                        <span className="overline-title">
                                          Name
                                        </span>
                                      </th>
                                      <th className="tb-col-os">
                                        <span className="overline-title">
                                          Email
                                        </span>
                                      </th>
                                      <th className="tb-col-os">
                                        <span className="overline-title">
                                          Title
                                        </span>
                                      </th>
                                      <th className="tb-col-ip">
                                        <span className="overline-title">
                                          Signed Date
                                        </span>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.signee_details &&
                                    this.state.signee_details.length > 0 ? (
                                      <>
                                        {this.state.signee_details.map(
                                          (details, index) => (
                                            <tr key={`idx${index}`}>
                                              <td className="tb-col-os">
                                                {details.signee_name}
                                              </td>
                                              <td className="tb-col-os">
                                                {details.signee_email}
                                              </td>
                                              <td className="tb-col-os">
                                                {details.signee_title &&
                                                details.signee_title !== ""
                                                  ? details.signee_title
                                                  : "---"}
                                              </td>
                                              <td className="tb-col-ip">
                                                {details.signed_date &&
                                                details.signed_date !== ""
                                                  ? this.format_date(
                                                      details.signed_date,
                                                    )
                                                  : "---"}
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </>
                                    ) : (
                                      <tr>
                                        <td className="tb-col-os" colSpan={4}>
                                          <strong className="text-dark">
                                            Uploded By Admin.
                                          </strong>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/**** Open Signee Details Modal ***/}
                    {/* PREVIEW DEFAULT MODAL  */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalPreviewDefaultModal"
                      style={{ zIndex: "9999" }}
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <div
                            className="modal-header"
                            style={{ borderBottom: "1px solid #e5e9f2" }}
                          >
                            <h5
                              className="modal-title"
                              style={{
                                fontFamily: "'DM Sans', sans-serif",
                                fontWeight: "700",
                                fontSize: "1.25rem",
                                color: "#364a63",
                              }}
                            >
                              Preview Notification Email
                            </h5>
                            <a
                              style={{ cursor: "pointer" }}
                              className="close"
                              onClick={() => this.closePreviewModal()}
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>
                          <div
                            className="modal-body"
                            style={{ padding: "1.5rem" }}
                          >
                            <div className="nk-block">
                              <div className="card card-bordered">
                                <div className="card-inner">
                                  <div
                                    className="email-preview"
                                    style={{
                                      maxHeight: "60vh",
                                      overflow: "auto",
                                      padding: "1rem",
                                      backgroundColor: "#f5f6fa",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    {this.state.isEditorReady ? (
                                      <div
                                        className="email-preview-content"
                                        style={{
                                          fontFamily: "'Roboto', sans-serif",
                                          fontSize: "14px",
                                          lineHeight: "1.65",
                                          pointerEvents: "none",
                                          userSelect: "none",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: this.state.email_template,
                                        }}
                                      />
                                    ) : (
                                      tableLoader()
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="modal-footer"
                            style={{
                              borderTop: "1px solid #e5e9f2",
                              padding: "1rem 1.5rem",
                            }}
                          >
                            <button
                              onClick={() => this.closePreviewModal()}
                              className="btn btn-primary"
                              style={{
                                fontFamily: "'DM Sans', sans-serif",
                                fontWeight: "500",
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* PREVIEW DEFAULT MODAL  */}
                    {/*** Signee Modal ***/}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalSendSignee"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">Send Email</h5>
                          </div>
                          <div className="modal-body">
                            {this.state.errorMessageSignee !== "" ? (
                              <div className="example-alert">
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.errorMessageSignee}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.successMessageSignee !== "" ? (
                              <div className="example-alert">
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.successMessageSignee}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            <br />

                            <div className="row g-4">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-group">
                                    <MutextField
                                      required
                                      id="signee_name"
                                      name="signee_name"
                                      type="text"
                                      label="Full Name"
                                      value={this.state.signee_name}
                                      onChange={this.handleChange}
                                      variant="outlined"
                                      fullWidth
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <MutextField
                                    id="signee_title"
                                    name="signee_title"
                                    type="text"
                                    label="Title"
                                    value={this.state.signee_title}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <MutextField
                                    required
                                    id="signee_email"
                                    name="signee_email"
                                    type="text"
                                    label="Email Address"
                                    value={this.state.signee_email}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                  autoComplete="new-password"
                                  />
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <textarea
                                    className="form-control"
                                    id="signee_comment"
                                    name="signee_comment"
                                    onChange={this.handleChangeTextArea}
                                    placeholder="Comments (Optional)"
                                    maxLength={1000}
                                    value={this.state.signee_comment}
                                  />
                                  <div className="form-note">
                                    {this.state.signee_comment.length}/
                                    {this.state.charLimit} characters
                                  </div>
                                  <div className="form-note">
                                    {this.state.characterExceededMessage &&
                                    this.state.characterExceededMessage !==
                                      "" ? (
                                      <code>
                                        {this.state.characterExceededMessage}
                                      </code>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="example-alert">
                                  <div className="alert alert-warning alert-icon">
                                    <em className="icon ni ni-alert-circle"></em>{" "}
                                    <strong>NOTE</strong>. This will send new
                                    agreement sign request. Your previous
                                    request will be discarded if you have sent
                                    any.
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12 text-right">
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => this.close_signee()}
                                >
                                  <em className="icon ni ni-cross-round"></em>{" "}
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => this.send_email()}
                                  disabled={this.state.disabled}
                                >
                                  <em className="icon ni ni-done"></em> Send
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Signee Model */}
                    {/* Role Assignment Modal START */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAgentAssignRole"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-grid-alt"></em>
                                {
                                  localization.specificPortals.agentLabel
                                } Menu{" "}
                                <sup>
                                  <small className="text-soft">
                                    {this.state.rolesAgentName}
                                  </small>
                                </sup>
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body text-left">
                            <div className="nk-modal">
                              <div className="nk-modal-text">
                                {this.state.agentRoleLoader === true ? (
                                  tableLoader()
                                ) : (
                                  <>
                                    {this.state.errorMessageAgentRole !== "" ? (
                                      <div
                                        className="example-alert "
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>Error</h4>
                                            <p>
                                              {this.state.errorMessageAgentRole}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    {this.state.successMessageAgentRole !==
                                    "" ? (
                                      <div
                                        className="example-alert "
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {
                                                this.state
                                                  .successMessageAgentRole
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}

                                    <div className="card card-bordered card-preview">
                                      <table className="table table-sm">
                                        <thead className="tb-odr-head">
                                          <tr className="tb-odr-item">
                                            <th
                                              width="35%"
                                              style={{
                                                borderRight:
                                                  "1px solid #dbdfea",
                                              }}
                                            >
                                              <span className="tb-odr-action">
                                                Main Menu
                                              </span>
                                            </th>
                                            <th width="65%">
                                              <span className="tb-odr-action">
                                                Sub Menu
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="tb-odr-body">
                                          {this.state.allRoleData &&
                                          this.state.allRoleData.length > 0 ? (
                                            <>
                                              {this.state.allRoleData.map(
                                                (role, index) => (
                                                  <tr
                                                    className=""
                                                    key={`role${index}`}
                                                  >
                                                    <td
                                                      style={{
                                                        borderRight:
                                                          "1px solid #dbdfea",
                                                      }}
                                                    >
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            checked={this.state.allRoleData.some(
                                                              (item) =>
                                                                item.alt ===
                                                                  role.alt &&
                                                                item.isChecked,
                                                            )}
                                                            onChange={
                                                              this
                                                                .changedAllRolesRights
                                                            }
                                                            disabled={
                                                              role.seqno ===
                                                                1 &&
                                                              this.state.assignRoleData.some(
                                                                (subRole) =>
                                                                  role.alt ===
                                                                  subRole.alt,
                                                              )
                                                            }
                                                            name={role?.id?.toString()}
                                                            color="primary"
                                                          />
                                                        }
                                                        style={{
                                                          marginBottom: "0px",
                                                        }}
                                                        label={role.alt}
                                                      />
                                                    </td>
                                                    <td
                                                      style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        paddingLeft: "16px",
                                                      }}
                                                    >
                                                      {this.state.allSubRoleData
                                                        .filter((subRole) => {
                                                          return (
                                                            subRole.role_id ===
                                                            role.id
                                                          );
                                                        })
                                                        .map(
                                                          (
                                                            subRole,
                                                            subIndex,
                                                          ) => (
                                                            <div
                                                              key={`subRole${subIndex}`}
                                                            >
                                                              <FormControlLabel
                                                                control={
                                                                  <Checkbox
                                                                    checked={this.state.allSubRoleData.some(
                                                                      (item) =>
                                                                        item.alt ===
                                                                          subRole.alt &&
                                                                        item.isChecked,
                                                                    )}
                                                                    onChange={
                                                                      this
                                                                        .changedAllSubRolesRights
                                                                    }
                                                                    name={subRole?.tabdetailid?.toString()}
                                                                    color="primary"
                                                                  />
                                                                }
                                                                style={{
                                                                  marginBottom:
                                                                    "0px",
                                                                }}
                                                                label={
                                                                  subRole.alt
                                                                }
                                                              />
                                                            </div>
                                                          ),
                                                        )}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </>
                                          ) : null}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className="nk-modal-action  text-right">
                                      {this.state.permissionsState &&
                                      this.state.permissionsState.length > 0 &&
                                      this.state.permission_update_menu ===
                                        1 ? (
                                        <a
                                          href="#"
                                          className="btn btn-lg btn-mw btn-primary "
                                          onClick={() => {
                                            this.handleSubmitRoleCheckbox(
                                              this.state.checkedName,
                                              this.state.checkedEmail,
                                            );
                                          }}
                                          disabled={this.state.disableRoleBtn}
                                        >
                                          Save Changes
                                        </a>
                                      ) : null}
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Role Assignment Modal End */}
                    {/* Commission Allocation Modal (Partner Sub-Agents) Start */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalSubAgentAllocation"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-lg"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em
                                className="icon ni ni-money"
                                style={{ marginRight: "8px" }}
                              ></em>
                              Commission Allocation
                            </h5>
                          </div>
                          <div className="modal-body">
                            {this.state.allocation_error !== "" ? (
                              <div className="example-alert mb-3">
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h6>Error</h6>
                                    <p>{this.state.allocation_error}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.allocation_success !== "" ? (
                              <div className="example-alert mb-3">
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h6>Success</h6>
                                    <p>{this.state.allocation_success}</p>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.allocation_loading === true ? (
                              FormLoader()
                            ) : (
                              <div className="row g-4">
                                <div className="col-lg-12">
                                  <div className="example-alert">
                                    {/* <div className="alert alert-light">
                                      <ul className="list">
                                        {this.state.allocation_main_rate !==
                                        null ? (
                                          <>
                                            <li>
                                              Main Agent commission:{" "}
                                              <strong>
                                                {
                                                  this.state
                                                    .allocation_main_rate
                                                }
                                                %
                                              </strong>{" "}
                                              of the order total.
                                            </li>
                                            <li>
                                              Each Sub Agent is allocated{" "}
                                              <strong>independently</strong>{" "}
                                              &mdash; up to the Main Agent's
                                              full{" "}
                                              {this.state.allocation_main_rate}%.
                                              What the other Sub Agents hold
                                              does not reduce what this one can
                                              be given.
                                            </li>
                                            <li>
                                              After assigning{" "}
                                              <strong>
                                                {parseFloat(
                                                  this.state.allocation_pct
                                                ) || 0}
                                                %
                                              </strong>
                                              , the Main Agent keeps{" "}
                                              <strong>
                                                {Math.max(
                                                  0,
                                                  this.state
                                                    .allocation_main_rate -
                                                    (parseFloat(
                                                      this.state.allocation_pct
                                                    ) || 0)
                                                ).toFixed(2)}
                                                %
                                              </strong>{" "}
                                              on THIS Sub Agent's orders. The
                                              Main Agent's own orders are not
                                              affected (always the full{" "}
                                              {this.state.allocation_main_rate}
                                              %).
                                            </li>
                                          </>
                                        ) : (
                                          <li>
                                            The Sub Agent earns the entered
                                            percentage of each order total,
                                            capped by the Main Agent's
                                            commission on that order. The
                                            Main Agent's own orders are not
                                            affected.
                                          </li>
                                        )}
                                        <li>
                                          Enter any value you like &mdash; e.g.
                                          0.1, 2, 5, 10.
                                        </li>
                                      </ul>
                                    </div> */}
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="form-group">
                                    <MutextField
                                      id="allocation_pct"
                                      name="allocation_pct"
                                      type="number"
                                      inputProps={{
                                        step: "0.01",
                                        min: "0",
                                        max: "100",
                                      }}
                                      label="Sub Agent Commission (%)"
                                      value={this.state.allocation_pct}
                                      onChange={this.handleChange}
                                      helperText="Percentage of the order total allocated to this Sub Agent."
                                      variant="outlined"
                                      fullWidth
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 d-flex align-items-center">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.allocation_saving}
                                    onClick={() => this.saveAllocation()}
                                  >
                                    {this.state.allocation_saving ? (
                                      <>
                                        <em className="icon ni ni-loader"></em>
                                        &nbsp;Saving...
                                      </>
                                    ) : (
                                      <>
                                        <em className="icon ni ni-check-round"></em>
                                        &nbsp;Save Allocation
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Commission Allocation Modal End */}
                    {/* {MODAL LOGIN DETAILS } */}
                    <div
                      className="modal fade"
                      id="modalLoginDetail"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="modalLoginDetailLabel"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="modalLoginDetailLabel"
                            >
                              Login Details
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            {/* Table to Display Login Details */}
                            <div className="table-responsive">
                              <table className="table table-bordered">
                                <thead className="thead-light">
                                  <tr>
                                    <th>IP Address</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Timezone</th>
                                    <th>Login Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.loginDetails &&
                                  this.state.loginDetails.length > 0 ? (
                                    this.state.loginDetails.map(
                                      (detail, index) => (
                                        <tr key={index}>
                                          <td>{detail.ip_address}</td>
                                          <td>{detail.country}</td>
                                          <td>{detail.state}</td>
                                          <td>{detail.city}</td>
                                          <td>{detail.time_zone}</td>
                                          <td>
                                            {new Date(detail.login_time)
                                              .toLocaleDateString("en-US", {
                                                month: "long",
                                                day: "numeric",
                                                year: "numeric",
                                              })
                                              .replace(/(\d+)(?=,)/, "$1th")}
                                            ,{" "}
                                            {new Date(
                                              detail.login_time,
                                            ).toLocaleTimeString("en-US")}
                                          </td>
                                        </tr>
                                      ),
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">
                                        No login details found.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* { MODAL LOGIN DETAILS } */}
                    {/* View Client Submissions */}
                    <div
                      className="modal fade zoom"
                      tabIndex="-1"
                      id="modalAgentSubmission"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-list-round"></em>{" "}
                                Submission Details{" "}
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body">
                            {/* NRC DIVS START */}

                            {this.state.viewLoader === true ? (
                              FormLoader()
                            ) : (
                              <>
                                <div>
                                  <div className="card card-bordered">
                                    <div className="card-inner-group">
                                      {this.state.errorMessageTotals !== "" ? (
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h6>
                                              {
                                                this.state
                                                  .errorMessageTotalsTitle
                                              }
                                            </h6>
                                            <p>
                                              {this.state.errorMessageTotals}
                                            </p>
                                          </div>
                                        </div>
                                      ) : null}
                                      {this.state.viewClientSubmissions &&
                                      this.state.viewClientSubmissions.length >
                                        0 ? (
                                        <div className="card-inner">
                                          <div className="sp-plan-head">
                                            <h6 className="title">
                                              Form Submission Details
                                            </h6>
                                          </div>

                                          <div className="sp-plan-desc sp-plan-desc-mb">
                                            <table className="table table-bordered table-striped">
                                              {this.state.viewClientSubmissions.map(
                                                (general, index) => (
                                                  <tbody
                                                    key={index}
                                                    className="text-dark"
                                                  >
                                                    <tr>
                                                      <td>Progress</td>
                                                      <td>
                                                        <div className="card card-bordered card-preview">
                                                          <div className="card-inner viewClient_card-inner_customStyle">
                                                            <div className="progress progress-lg">
                                                              <div
                                                                className="progress-bar"
                                                                data-progress={
                                                                  this.state
                                                                    .progressPercentage
                                                                }
                                                                style={{
                                                                  width: `${this.state.progressPercentage}%`,
                                                                }}
                                                              >
                                                                {
                                                                  this.state
                                                                    .progressPercentage
                                                                }
                                                                %
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent To Name</td>
                                                      <td>
                                                        {general.submitter_name}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent To Email</td>
                                                      <td>
                                                        {
                                                          general.submitter_email
                                                        }
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent By</td>
                                                      <td>
                                                        {general.sent_by_email}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent Date</td>
                                                      <td>
                                                        {this.format_date(
                                                          general.sent_on,
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Submitted</td>
                                                      <td>
                                                        {general.is_submitted &&
                                                        general.is_submitted ===
                                                          1 ? (
                                                          <span className="badge badge-dot badge-success">
                                                            Yes
                                                          </span>
                                                        ) : (
                                                          <span className="badge badge-dot badge-danger">
                                                            No
                                                          </span>
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Submission Date</td>
                                                      <td>
                                                        {general.is_submitted &&
                                                        general.is_submitted ===
                                                          1
                                                          ? this.format_date(
                                                              general.submitted_on,
                                                            )
                                                          : "---"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>View PDF</td>
                                                      <td>
                                                        {general.is_submitted &&
                                                        general.is_submitted ===
                                                          1 ? (
                                                          <a
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              this.downloadFormPdf(
                                                                general.pdf_name,
                                                              )
                                                            }
                                                          >
                                                            <span className="badge badge-outline-dark">
                                                              View
                                                            </span>
                                                          </a>
                                                        ) : (
                                                          "---"
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Extra Files</td>
                                                      <td>
                                                        {this.state
                                                          .extra_files_clients &&
                                                        this.state
                                                          .extra_files_clients !==
                                                          "" ? (
                                                          <>
                                                            {this.state.extra_files_clients.map(
                                                              (file, index) => (
                                                                <>
                                                                  {file.file_name &&
                                                                  file.file_name !==
                                                                    "" ? (
                                                                    <div
                                                                      key={
                                                                        index
                                                                      }
                                                                      className="col-md-12"
                                                                      style={{
                                                                        paddingLeft:
                                                                          "0px",
                                                                      }}
                                                                    >
                                                                      {file.field_name.trim()}{" "}
                                                                      <span
                                                                        onClick={() =>
                                                                          this.downloadFormPdf(
                                                                            file.file_name.trim(),
                                                                          )
                                                                        }
                                                                        className="badge badge-outline-primary"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        title="Download / View"
                                                                      >
                                                                        <em className="icon ni ni-download"></em>{" "}
                                                                        {file.file_name.trim()}
                                                                      </span>
                                                                    </div>
                                                                  ) : null}
                                                                </>
                                                              ),
                                                            )}
                                                          </>
                                                        ) : (
                                                          "---"
                                                        )}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent Form Subject</td>
                                                      <td>
                                                        {general.email_subject}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>Sent Form Message</td>
                                                      <td>
                                                        {general.email_content}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                ),
                                              )}
                                            </table>
                                          </div>
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* View Client Submissions */}
                    {/* START APPROVE Client MODAL  */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalApproveAgentAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideAlll("modalApproveAgentAlert");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-done bg-success"></em>

                              <h4 className="nk-modal-title">
                                Approve Submission?
                              </h4>

                              <div className="nk-modal-text">
                                {this.state.approveAgentErrorMessage !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>
                                          {this.state.approveAgentErrorMessage}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.approveAgentSuccessMessage !==
                                "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {
                                            this.state
                                              .approveAgentSuccessMessage
                                          }
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}

                                <div className="caption-text">
                                  Are you sure you want to approve this
                                  submission
                                </div>

                                <div style={{ marginTop: "20px", textAlign: "left", marginBottom: "20px" }}>
                                  <label style={{ fontWeight: "600", marginBottom: "10px", display: "block", fontSize: "14px", color: "#333" }}>
                                    Approval Notes (Optional)
                                  </label>
                                  <TextareaAutosize
                                    minRows={3}
                                    placeholder="Enter approval notes..."
                                    value={this.state.approvalNotes}
                                    onChange={this.handleApprovalNotesChange}
                                    style={{
                                      width: "100%",
                                      padding: "12px",
                                      borderRadius: "4px",
                                      border: this.state.approvalNotesError ? "1px solid #dc3545" : "1px solid #e0e0e0",
                                      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                      fontSize: "13px",
                                      lineHeight: "1.5",
                                      boxSizing: "border-box",
                                      resize: "vertical",
                                      backgroundColor: "#fff",
                                      color: "#333",
                                      height: "100px",
                                      transition: "border-color 0.2s"
                                    }}
                                  />
                                  {this.state.approvalNotesError && (
                                    <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "6px" }}>
                                      {this.state.approvalNotesError}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                {this.state.approve_agent_button ? (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Processing... </span>
                                  </button>
                                ) : (
                                  <>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-dim btn-outline-light"
                                      onClick={() => {
                                        this.modalHideAlll(
                                          "modalApproveAgentAlert",
                                        );
                                      }}
                                    >
                                      <em className="icon ni ni-cross-round"></em>{" "}
                                      <span>Cancel</span>
                                    </a>
                                    {"  "}
                                    <a
                                      style={{ cursor: "pointer" }}
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.approve_client_form();
                                      }}
                                      disabled={
                                        this.state.disabled ||
                                        this.state.isProcessing
                                      } // disable button when processing
                                    >
                                      <em className="icon ni ni-done"></em>{" "}
                                      <span>Approve</span>
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END APPROVE CLIENT MODAL  */}
                    {/* START REJECTION CLIENT MODAL */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalRejectionAgentAlert"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              {this.state.rejection_agent_title}{" "}
                              <sup className="text-primary">
                                {this.state.form_title}
                              </sup>
                            </h5>
                          </div>
                          <div className="modal-body">
                            {this.state.rejectAgentErrorMessage !== "" ? (
                              <div className="alert alert-pro alert-danger mb-2">
                                <div className="alert-text">
                                  <h6>Error</h6>
                                  <p>{this.state.rejectAgentErrorMessage} </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.rejectAgentSuccessMessage !== "" ? (
                              <div className="alert alert-pro alert-success mb-2">
                                <div className="alert-text">
                                  <h6>Success</h6>
                                  <p>{this.state.rejectAgentSuccessMessage} </p>
                                </div>
                              </div>
                            ) : null}
                            <div id="revokeReasonItems">
                              <div className="tb-odr-id">Reason to reject</div>
                              <div className="card card-bordered card-preview mt-1">
                                <TextareaAutosize
                                  maxRows={4}
                                  name="reject_agent_reason"
                                  id="reject_agent_reason"
                                  aria-label=""
                                  placeholder=""
                                  value={this.state.reject_agent_reason}
                                  onChange={this.handleChange}
                                  style={{
                                    width: "100%",
                                    height: "100px",
                                    borderColor: "rgba(0, 0, 0, 0.125)",
                                    borderRadius: "4px",
                                  }}
                                />
                              </div>
                              <div className="form-group text-right mt-2 mb-2">
                                {this.state.reject_client_button === true ? (
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Loading... </span>
                                  </button>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-light"
                                      onClick={() => {
                                        this.modalHideAlll(
                                          "modalRejectionAgentAlert",
                                        );
                                      }}
                                      style={{ marginRight: "10px" }}
                                    >
                                      <em className="icon ni ni-cross-round"></em>{" "}
                                      <span>Cancel</span>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        this.reject_agent_form();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      <em className="icon ni ni-cross-circle"></em>{" "}
                                      <span>Reject</span>
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END REJECTION CLIENT MODAL */}
                    {/* START CLIENT REJECTIONS MODAL */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalRejectionAgents"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              All Rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                            </h5>
                          </div>
                          <div className="modal-body">
                            {this.state.rejectAgentErrorMessage !== "" ? (
                              <div className="alert alert-pro alert-danger mb-2">
                                <div className="alert-text">
                                  <h6>Error</h6>
                                  <p>{this.state.rejectAgentErrorMessage} </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.rejectAgentSuccessMessage !== "" ? (
                              <div className="alert alert-pro alert-success mb-2">
                                <div className="alert-text">
                                  <h6>Success</h6>
                                  <p>{this.state.rejectAgentSuccessMessage} </p>
                                </div>
                              </div>
                            ) : null}
                            <div id="revokeReasonItems">
                              {this.state.rejectionLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div>
                                    <div className="card card-bordered">
                                      <div className="card-inner-group">
                                        {this.state.allAgentRejectionsListing &&
                                        this.state.allAgentRejectionsListing
                                          .length > 0 ? (
                                          <div className="card-inner">
                                            <div className="sp-plan-head">
                                              <h6 className="title">
                                                All Rejections
                                              </h6>
                                            </div>
                                            <div className="sp-plan-desc sp-plan-desc-mb">
                                              <table className="table table-bordered table-striped">
                                                <thead>
                                                  <th>Form Title</th>
                                                  <th>Rejection date</th>
                                                  <th>Reason</th>
                                                  <th>Submitted PDF</th>
                                                </thead>
                                                {this.state.allAgentRejectionsListing.map(
                                                  (general, index) => (
                                                    <tbody
                                                      key={`ind${index}`}
                                                      className="text-dark"
                                                    >
                                                      <tr>
                                                        <td>
                                                          {
                                                            this.state
                                                              .form_title
                                                          }
                                                        </td>
                                                        <td>
                                                          {this.format_date(
                                                            general.rejection_date,
                                                          )}
                                                        </td>
                                                        <td>
                                                          {
                                                            general.rejection_reason
                                                          }
                                                        </td>
                                                        <td>
                                                          {general.is_submitted &&
                                                          general.is_submitted ===
                                                            1 ? (
                                                            <a
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.downloadPdfGeneral(
                                                                  general.pdf_name,
                                                                )
                                                              }
                                                            >
                                                              <span className="badge badge-outline-dark">
                                                                View
                                                              </span>
                                                            </a>
                                                          ) : (
                                                            "---"
                                                          )}
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  ),
                                                )}
                                              </table>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="alert alert-pro alert-primary">
                                            <div className="alert-text">
                                              <h6>No Rejection</h6>
                                              <p>
                                                Rejections are not available
                                                against this submission.
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* END REJECTIONS CLIENT MODAL */}
                    {/* MODAL ASSIGN FORM */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAssignFormAgent"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-clipboad-check"></em>
                                Assign Form to {this.state.client_update_name} (
                                {this.state.client_comp_name}){" "}
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body text-left">
                            <div className="nk-modal">
                              <div className="nk-modal-text">
                                {this.state.assignModalLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    {this.state.errorMessageAssignModal !==
                                    "" ? (
                                      <div
                                        className="example-alert "
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-danger">
                                          <div className="alert-text">
                                            <h4>Error</h4>
                                            <p>
                                              {
                                                this.state
                                                  .errorMessageAssignModal
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                    {this.state.successMessageAssignModal !==
                                    "" ? (
                                      <div
                                        className="example-alert "
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <div className="alert alert-pro alert-success">
                                          <div className="alert-text">
                                            <h4>Success</h4>
                                            <p>
                                              {
                                                this.state
                                                  .successMessageAssignModal
                                              }
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}

                                    <div className="card card-bordered card-preview">
                                      <table className="table table-orders">
                                        <thead className="tb-odr-head">
                                          <tr className="tb-odr-item">
                                            <th>
                                              <span className="tb-odr-action">
                                                Forms
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="tb-odr-body">
                                          {this.state.agentsList &&
                                          this.state.agentsList.length > 0 ? (
                                            <tr className="tb-odr-item customStyle_tb-odr-item_forms">
                                              <td
                                                style={{
                                                  paddingLeft: "16px",
                                                }}
                                              >
                                                {this.state.agentsList &&
                                                this.state.agentsList.length >
                                                  0 ? (
                                                  <div
                                                    className="form-group"
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                    }}
                                                  >
                                                    <Autocomplete
                                                      multiple
                                                      id="clients-autocomplete"
                                                      options={
                                                        this.state.agentsList
                                                      }
                                                      disableCloseOnSelect
                                                      getOptionLabel={(
                                                        option,
                                                      ) => option.label}
                                                      value={this.state.agentsList.filter(
                                                        (agent) =>
                                                          this.state.selectedForms.includes(
                                                            agent.value,
                                                          ),
                                                      )}
                                                      onChange={
                                                        this.handleClientChange
                                                      }
                                                      getOptionSelected={(
                                                        option,
                                                        value,
                                                      ) =>
                                                        option.value ===
                                                        value.value
                                                      }
                                                      renderOption={(
                                                        option,
                                                        { selected },
                                                      ) => (
                                                        <Fragment>
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={
                                                              checkedIcon
                                                            }
                                                            style={{
                                                              marginRight: 8,
                                                            }}
                                                            checked={selected}
                                                          />
                                                          {option.label}
                                                        </Fragment>
                                                      )}
                                                      style={{ width: "100%" }}
                                                      renderInput={(params) => (
                                                        <MutextField
                                                          {...params}
                                                          label="Select Forms"
                                                          placeholder=""
                                                        autoComplete="new-password"
                                                        />
                                                      )}
                                                    />
                                                  </div>
                                                ) : null}
                                              </td>
                                            </tr>
                                          ) : null}
                                          {this.state.agentsList &&
                                          this.state.agentsList.length > 0 ? (
                                            <>
                                              <tr>
                                                <td>
                                                  <div className="nk-modal-action text-right">
                                                    <a
                                                      href="#"
                                                      className="btn btn-lg btn-mw btn-primary"
                                                      onClick={() => {
                                                        this.handleSubmitAssignFormAgent();
                                                      }}
                                                      disabled={
                                                        this.state
                                                          .disableAssignBtn
                                                      }
                                                    >
                                                      {`Assign to ${localization.specificPortals.agentLabel}`}
                                                    </a>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          ) : null}
                                        </tbody>
                                      </table>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MODAL ASSIGN FORM */}
                    {/* View Client Submissions */}
                    <div
                      className="modal fade zoom"
                      tabIndex="-1"
                      id="modalClientArchivedSubmission"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-list-round"></em>{" "}
                                Archived Submission Details{" "}
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body">
                            {/* NRC DIVS START */}

                            {this.state.viewLoader === true ? (
                              FormLoader()
                            ) : (
                              <>
                                <div>
                                  <div className="card card-bordered">
                                    <div className="card-inner-group">
                                      <div className="card-inner">
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            Form Submission Details
                                          </h6>
                                        </div>

                                        <div className="sp-plan-desc sp-plan-desc-mb">
                                          <table className="table table-bordered table-striped">
                                            <tbody
                                              key="arch1"
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>Form Title</td>
                                                <td>{this.state.form_title}</td>
                                              </tr>
                                              <tr>
                                                <td>Archive Date</td>
                                                <td>
                                                  {this.state.archive_date &&
                                                  this.state.archive_date !== ""
                                                    ? this.format_date(
                                                        this.state.archive_date,
                                                      )
                                                    : "---"}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* View Client Submissions */}
                    {/* Agent Action Assignment Modal START */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAgentAssignAction"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-setting"></em> Partner
                                Actions
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body text-left">
                            <div className="nk-modal">
                              <div className="nk-modal-text">
                                <>
                                  {/* Alerts */}
                                  {this.state.errorMessageAgentAction && (
                                    <div
                                      className="example-alert"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h4>Error</h4>
                                          <p>
                                            {this.state.errorMessageAgentAction}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {this.state.successMessageAgentAction && (
                                    <div
                                      className="example-alert"
                                      style={{ marginBottom: "15px" }}
                                    >
                                      <div className="alert alert-pro alert-success">
                                        <div className="alert-text">
                                          <h4>Success</h4>
                                          <p>
                                            {
                                              this.state
                                                .successMessageAgentAction
                                            }
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  <div className="card card-bordered card-preview">
                                    <table className="table table-sm">
                                      <thead className="tb-odr-head">
                                        <tr className="tb-odr-item">
                                          <th
                                            width="25%"
                                            style={{
                                              borderRight: "1px solid #dbdfea",
                                              textAlign: "center",
                                              padding: "15px",
                                            }}
                                          >
                                            <span className="tb-odr-action">
                                              Enable/Disable
                                            </span>
                                          </th>
                                          <th
                                            width="75%"
                                            style={{
                                              textAlign: "center",
                                              padding: "15px",
                                            }}
                                          >
                                            <span className="tb-odr-action">
                                              Title
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="tb-odr-body">
                                        {this.state.agent_action_list?.map(
                                          (action) => (
                                            <tr key={action.id}>
                                              <td
                                                style={{
                                                  borderRight:
                                                    "1px solid #dbdfea",
                                                  textAlign: "center",
                                                  padding: "15px",
                                                }}
                                              >
                                                <div className="custom-control custom-checkbox">
                                                  <div className="form-group">
                                                    <input
                                                      type="checkbox"
                                                      className="custom-control-input"
                                                      id={`customCheckAction${action.id}`}
                                                      checked={
                                                        !!this.state
                                                          .selected_action_map?.[
                                                          action.id
                                                        ]
                                                      }
                                                      onChange={() =>
                                                        this.handleEnableChange(
                                                          action.id,
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`customCheckAction${action.id}`}
                                                    ></label>
                                                  </div>
                                                </div>
                                              </td>
                                              <td
                                                style={{
                                                  textAlign: "center",
                                                  padding: "15px",
                                                }}
                                              >
                                                {action.actions}
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </>
                              </div>
                            </div>
                          </div>

                          <div
                            className="modal-footer justify-content-end"
                            style={{ border: "none" }}
                          >
                            {this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_update_actions === 1 ? (
                              <button
                                type="button"
                                className="btn btn-primary"
                                disabled={this.state.disableSaveBtn}
                                onClick={this.saveAgentActions}
                              >
                                Save Changes
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Agent Action Assignment Modal END */}
                    {/* get Submission Link */}
                    <div
                      className="modal fade zoom"
                      tabIndex="-1"
                      id="modalSubmissionLink"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <div
                              className="modal-title"
                              style={{ textAlign: "center", fontSize: "20px" }}
                            >
                              <strong>
                                <em className="icon ni ni-copy"></em> Submission
                                Link{" "}
                              </strong>
                            </div>
                            <a
                              href="#"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          <div className="modal-body">
                            {this.state.deleteLoader === true ? (
                              FormLoader()
                            ) : (
                              <>
                                <div>
                                  <div className="card card-bordered">
                                    <div className="card-inner-group">
                                      <div className="card-inner">
                                        <div className="sp-plan-head">
                                          <h6 className="title">
                                            Copy Submission link
                                          </h6>
                                        </div>
                                        {this.state.successMessageSub !== "" ? (
                                          <div
                                            className="example-alert "
                                            style={{
                                              marginBottom: "20px",
                                              marginTop: "20px",
                                            }}
                                          >
                                            {this.state.successMessageSub && (
                                              <div className="alert alert-success mb-3">
                                                <strong>Success:</strong>{" "}
                                                {this.state.successMessageSub}
                                              </div>
                                            )}
                                          </div>
                                        ) : null}

                                        <div className="sp-plan-desc sp-plan-desc-mb d-flex align-items-center justify-content-between">
                                          <p
                                            style={{
                                              marginBottom: "0",
                                              wordBreak: "break-all",
                                            }}
                                          >
                                            <a
                                              href={this.state.submission_link}
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              {this.state.submission_link}
                                            </a>
                                          </p>
                                          <div className="d-flex align-items-center ml-3">
                                            {/* Copy Icon */}
                                            <a
                                              onClick={this.copySubmissionLink}
                                              style={{
                                                cursor: "pointer",
                                                marginRight: "10px",
                                              }}
                                            >
                                              {this.state.copiedSub ? (
                                                <em
                                                  className="icon ni ni-check"
                                                  style={{ fontSize: "18px" }}
                                                ></em>
                                              ) : (
                                                <em
                                                  className="icon ni ni-copy"
                                                  style={{ fontSize: "18px" }}
                                                ></em>
                                              )}
                                            </a>

                                            {/* Mail Icon */}
                                            <a
                                              onClick={() =>
                                                this.setState({
                                                  showMailForm:
                                                    !this.state.showMailForm,
                                                })
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <em
                                                className="icon ni ni-mail"
                                                style={{ fontSize: "18px" }}
                                              ></em>
                                            </a>
                                          </div>
                                        </div>

                                        {/* Inline Mail Form */}
                                        {this.state.showMailForm && (
                                          <div className="mt-4">
                                            {this.state.errorMessageMail !==
                                            "" ? (
                                              <div
                                                className="example-alert"
                                                style={{ marginBottom: "15px" }}
                                              >
                                                <div className="alert alert-pro alert-danger">
                                                  <div className="alert-text">
                                                    <h4>Error</h4>
                                                    <p>
                                                      {
                                                        this.state
                                                          .errorMessageMail
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            {this.state.successMessageMail !==
                                            "" ? (
                                              <div
                                                className="example-alert"
                                                style={{ marginBottom: "15px" }}
                                              >
                                                <div className="alert alert-pro alert-success">
                                                  <div className="alert-text">
                                                    <h4>Success</h4>
                                                    <p>
                                                      {
                                                        this.state
                                                          .successMessageMail
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}

                                            <div className="form-group">
                                              <label>
                                                Name{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={this.state.mailName}
                                                onChange={(e) =>
                                                  this.setState({
                                                    mailName: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>

                                            <div className="form-group">
                                              <label>
                                                Email{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="email"
                                                className="form-control"
                                                value={this.state.mailEmail}
                                                onChange={(e) =>
                                                  this.setState({
                                                    mailEmail: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>

                                            <div className="form-group">
                                              <label>
                                                Comment{" "}
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <textarea
                                                className="form-control"
                                                value={this.state.mailComment}
                                                onChange={(e) =>
                                                  this.setState({
                                                    mailComment: e.target.value,
                                                  })
                                                }
                                              />
                                            </div>

                                            <button
                                              className="btn btn-primary"
                                              onClick={
                                                this.sendSubmissionLinkByEmail
                                              }
                                            >
                                              Send Link
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* View Client Submissions */}

                    {/* NOTIFICATION MODAL */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalNotificationSchedule"
                    >
                      <div
                        className="modal-dialog modal-dialog-top modal-xl"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-bell"></em>{" "}
                              <span>Schedule Notifications </span>
                            </h5>
                          </div>
                          <div className="modal-body">
                            {this.state.notificationErrorMsg !== "" ? (
                              <div className="alert alert-pro alert-danger mb-3">
                                <div className="alert-text">
                                  <h6>Missing Fields</h6>
                                  <p>{this.state.notificationErrorMsg} </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.notificationSuccessMsg !== "" ? (
                              <div className="alert alert-pro alert-success mb-3">
                                <div className="alert-text">
                                  <h6>Success</h6>
                                  <p>{this.state.notificationSuccessMsg} </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.missing_form_settings === "Yes" ? (
                              <div className="alert alert-pro alert-danger mb-3">
                                <div className="alert-text">
                                  <h6>Missing Form Settings</h6>
                                  <p>
                                    Form notification settings are missing.
                                    Please{" "}
                                    <a
                                      href={`${APP_URL}forms/edit_form/${this.state.form_accountno}`}
                                      className="text-primary"
                                      target="_blank"
                                    >
                                      <b>click here</b>
                                    </a>{" "}
                                    to update the notification schedule.
                                  </p>
                                </div>
                              </div>
                            ) : null}
                            {this.state.missing_form_settings === "No" ? (
                              <>
                                <div className="col-md-12 mb-4">
                                  <div className="custom-control custom-control-lg custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="notification_scheduler"
                                      onChange={this.handleNotificationSchedule}
                                      value={this.state.notification_scheduler}
                                      checked={
                                        this.state.notification_scheduler
                                      }
                                    autoComplete="new-password" />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="notification_scheduler"
                                    >
                                      Enable Notification Scheduler
                                    </label>
                                  </div>
                                </div>
                                {this.state.schedule_div === true ? (
                                  <div className="row g-4 mb-4">
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="initial_reminder_interval"
                                        >
                                          Initial Reminder (Hours)
                                        </label>
                                        <div className="form-control-wrap">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="initial_reminder_interval"
                                            name="initial_reminder_interval"
                                            placeholder="Allowed values between 1 to 24"
                                            onChange={
                                              this.handleChangeInitialReminder
                                            }
                                            value={
                                              this.state
                                                .initial_reminder_interval
                                            }
                                            maxLength={2}
                                          autoComplete="new-password" />
                                        </div>
                                        <div className="form-note"></div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="repeat_interval"
                                        >
                                          Repeat Reminder (Hours)
                                        </label>
                                        <div className="form-control-wrap">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="repeat_interval"
                                            name="repeat_interval"
                                            placeholder="Allowed values between 1 to 48"
                                            value={this.state.repeat_interval}
                                            onChange={
                                              this.handleChangeRepeatReminder
                                            }
                                            maxLength={2}
                                          autoComplete="new-password" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="repeat_count"
                                        >
                                          Maximum Days
                                        </label>
                                        <div className="form-control-wrap">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="repeat_count"
                                            name="repeat_count"
                                            placeholder="Allowed values between 1 to 12 days"
                                            value={this.state.repeat_count}
                                            onChange={
                                              this.handleChangeRepeatDays
                                            }
                                            maxLength={2}
                                          autoComplete="new-password" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="form-group text-right">
                                        {this.state.notification_loader ===
                                        true ? (
                                          <button
                                            className="btn btn-primary"
                                            type="button"
                                            disabled
                                          >
                                            <span
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            <span> Saving... </span>
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={() =>
                                              this.submitNotifications()
                                            }
                                            className="btn btn-primary"
                                          >
                                            Submit
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* NOTIFICATION MODAL */}
                    {/* Notification Links Modal START */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalNotificationLinks"
                    >
                      <div
                        className="modal-dialog modal-lg modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content rounded-3 shadow">
                          {/* Header */}
                          <div className="modal-header border-0 pb-0">
                            <h5
                              className="modal-title d-flex align-items-center"
                              style={{ fontSize: "20px" }}
                            >
                              <em className="icon ni ni-link-alt mr-2"></em>
                              Notification Links
                            </h5>
                            <a
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <em className="icon ni ni-cross"></em>
                            </a>
                          </div>

                          {/* Body */}
                          <div className="modal-body">
                            {this.state.successMessage && (
                              <div className="alert alert-success mb-3">
                                <strong>Success:</strong>{" "}
                                {this.state.successMessage}
                              </div>
                            )}
                            {this.state.errorMessage && (
                              <div className="alert alert-danger mb-3">
                                <strong>Error:</strong> {this.state.errorMessage}
                              </div>
                            )}

                            {/* Login URL Section */}
                            <div className="mb-4">
                              <label className="form-label font-weight-bold">
                                <em className="icon ni ni-signin mr-2"></em>
                                Login URL
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={this.state.loginUrl}
                                  readOnly
                                  style={{ fontSize: "14px" }}
                                  autoComplete="new-password"
                                />
                                <div className="input-group-append">
                                  <Tooltip title="Copy Link">
                                    <a
                                      className="btn border"
                                      onClick={() => this.copyToClipboard("login")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {this.state.copiedLogin ? (
                                        <em className="icon ni ni-check"></em>
                                      ) : (
                                        <em className="icon ni ni-copy"></em>
                                      )}
                                    </a>
                                  </Tooltip>
                                  <Tooltip title="Email Link">
                                    <a
                                      className="btn border"
                                      onClick={() => this.sendEmailUrl("login")}
                                      disabled={this.state.sendingLoginEmail}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {this.state.sendingLoginEmail ? (
                                        <em className="icon ni ni-loader" />
                                      ) : this.state.loginEmailSent ? (
                                        <em className="icon ni ni-check text-success"></em>
                                      ) : (
                                        <em className="icon ni ni-mail"></em>
                                      )}
                                    </a>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>

                            {/* Reset Password URL Section */}
                            <div className="mb-3">
                              <label className="form-label font-weight-bold">
                                <em className="icon ni ni-lock-alt mr-2"></em>
                                Reset Password URL
                              </label>
                              {this.state.resetLink ? (
                                <>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={this.state.resetLink}
                                      readOnly
                                      style={{ fontSize: "14px" }}
                                      autoComplete="new-password"
                                    />
                                    <div className="input-group-append">
                                      <Tooltip title="Copy Link">
                                        <a
                                          className="btn border"
                                          onClick={() => this.copyToClipboard("resetPassword")}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {this.state.copiedResetPassword ? (
                                            <em className="icon ni ni-check"></em>
                                          ) : (
                                            <em className="icon ni ni-copy"></em>
                                          )}
                                        </a>
                                      </Tooltip>
                                      <Tooltip title="Email Link">
                                        <a
                                          className="btn border"
                                          onClick={() => this.sendEmailUrl("resetPassword")}
                                          disabled={this.state.sendingResetPasswordEmail}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {this.state.sendingResetPasswordEmail ? (
                                            <em className="icon ni ni-loader" />
                                          ) : this.state.resetPasswordEmailSent ? (
                                            <em className="icon ni ni-check text-success"></em>
                                          ) : (
                                            <em className="icon ni ni-mail"></em>
                                          )}
                                        </a>
                                      </Tooltip>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div className="text-center py-3">
                                  <span className="spinner-border spinner-border-sm mr-2"></span>
                                  <span>Loading reset password link...</span>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Footer */}
                          <div className="modal-footer border-0 pt-0 d-flex flex-column align-items-start w-100">
                            <div className="card card-bordered w-100">
                              <div className="card-inner p-3">
                                <ul className="list-unstyled mb-0">
                                  <li className="d-flex align-items-start mb-2">
                                    <span
                                      className="dot mr-2"
                                      style={{
                                        height: "8px",
                                        width: "8px",
                                        borderRadius: "50%",
                                        backgroundColor: "#526484",
                                        marginTop: "6px",
                                      }}
                                    ></span>
                                    <span>
                                      Use the <strong>Copy</strong> icon to copy links to clipboard.
                                    </span>
                                  </li>
                                  <li className="d-flex align-items-start mb-2">
                                    <span
                                      className="dot mr-2"
                                      style={{
                                        height: "8px",
                                        width: "8px",
                                        borderRadius: "50%",
                                        backgroundColor: "#526484",
                                        marginTop: "6px",
                                      }}
                                    ></span>
                                    <span>
                                      Use the <strong>Email</strong> icon to send the link directly to the partner.
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Notification Links Modal End */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ViewAgent));
